const address = [
    {
      id: 2,
      pid: 1,
      name: "北京市",
      children: [
        {
          id: 3,
          pid: 2,
          name: "北京市",
          children: [
            {
              id: 4,
              pid: 3,
              name: "东城区",
            },
            {
              id: 5,
              pid: 3,
              name: "西城区",
            },
            {
              id: 6,
              pid: 3,
              name: "朝阳区",
            },
            {
              id: 7,
              pid: 3,
              name: "丰台区",
            },
            {
              id: 8,
              pid: 3,
              name: "石景山区",
            },
            {
              id: 9,
              pid: 3,
              name: "海淀区",
            },
            {
              id: 10,
              pid: 3,
              name: "门头沟区",
            },
            {
              id: 11,
              pid: 3,
              name: "房山区",
            },
            {
              id: 12,
              pid: 3,
              name: "通州区",
            },
            {
              id: 13,
              pid: 3,
              name: "顺义区",
            },
            {
              id: 14,
              pid: 3,
              name: "昌平区",
            },
            {
              id: 15,
              pid: 3,
              name: "大兴区",
            },
            {
              id: 16,
              pid: 3,
              name: "怀柔区",
            },
            {
              id: 17,
              pid: 3,
              name: "平谷区",
            },
            {
              id: 18,
              pid: 3,
              name: "密云区",
            },
            {
              id: 19,
              pid: 3,
              name: "延庆区",
            },
          ],
        },
      ],
    },
    {
      id: 20,
      pid: 1,
      name: "天津市",
      children: [
        {
          id: 21,
          pid: 20,
          name: "天津市",
          children: [
            {
              id: 22,
              pid: 21,
              name: "和平区",
            },
            {
              id: 23,
              pid: 21,
              name: "河东区",
            },
            {
              id: 24,
              pid: 21,
              name: "河西区",
            },
            {
              id: 25,
              pid: 21,
              name: "南开区",
            },
            {
              id: 26,
              pid: 21,
              name: "河北区",
            },
            {
              id: 27,
              pid: 21,
              name: "红桥区",
            },
            {
              id: 28,
              pid: 21,
              name: "东丽区",
            },
            {
              id: 29,
              pid: 21,
              name: "西青区",
            },
            {
              id: 30,
              pid: 21,
              name: "津南区",
            },
            {
              id: 31,
              pid: 21,
              name: "北辰区",
            },
            {
              id: 32,
              pid: 21,
              name: "武清区",
            },
            {
              id: 33,
              pid: 21,
              name: "宝坻区",
            },
            {
              id: 34,
              pid: 21,
              name: "滨海新区",
            },
            {
              id: 35,
              pid: 21,
              name: "宁河区",
            },
            {
              id: 36,
              pid: 21,
              name: "静海区",
            },
            {
              id: 37,
              pid: 21,
              name: "蓟州区",
            },
          ],
        },
      ],
    },
    {
      id: 38,
      pid: 1,
      name: "河北省",
      children: [
        {
          id: 39,
          pid: 38,
          name: "石家庄市",
          children: [
            {
              id: 41,
              pid: 39,
              name: "长安区",
            },
            {
              id: 42,
              pid: 39,
              name: "桥西区",
            },
            {
              id: 43,
              pid: 39,
              name: "新华区",
            },
            {
              id: 44,
              pid: 39,
              name: "井陉矿区",
            },
            {
              id: 45,
              pid: 39,
              name: "裕华区",
            },
            {
              id: 46,
              pid: 39,
              name: "藁城区",
            },
            {
              id: 47,
              pid: 39,
              name: "鹿泉区",
            },
            {
              id: 48,
              pid: 39,
              name: "栾城区",
            },
            {
              id: 49,
              pid: 39,
              name: "井陉县",
            },
            {
              id: 50,
              pid: 39,
              name: "正定县",
            },
            {
              id: 51,
              pid: 39,
              name: "行唐县",
            },
            {
              id: 52,
              pid: 39,
              name: "灵寿县",
            },
            {
              id: 53,
              pid: 39,
              name: "高邑县",
            },
            {
              id: 54,
              pid: 39,
              name: "深泽县",
            },
            {
              id: 55,
              pid: 39,
              name: "赞皇县",
            },
            {
              id: 56,
              pid: 39,
              name: "无极县",
            },
            {
              id: 57,
              pid: 39,
              name: "平山县",
            },
            {
              id: 58,
              pid: 39,
              name: "元氏县",
            },
            {
              id: 59,
              pid: 39,
              name: "赵县",
            },
            {
              id: 60,
              pid: 39,
              name: "辛集市",
            },
            {
              id: 61,
              pid: 39,
              name: "晋州市",
            },
            {
              id: 62,
              pid: 39,
              name: "新乐市",
            },
          ],
        },
        {
          id: 63,
          pid: 38,
          name: "唐山市",
          children: [
            {
              id: 65,
              pid: 63,
              name: "路南区",
            },
            {
              id: 66,
              pid: 63,
              name: "路北区",
            },
            {
              id: 67,
              pid: 63,
              name: "古冶区",
            },
            {
              id: 68,
              pid: 63,
              name: "开平区",
            },
            {
              id: 69,
              pid: 63,
              name: "丰南区",
            },
            {
              id: 70,
              pid: 63,
              name: "丰润区",
            },
            {
              id: 71,
              pid: 63,
              name: "曹妃甸区",
            },
            {
              id: 72,
              pid: 63,
              name: "滦州市",
            },
            {
              id: 73,
              pid: 63,
              name: "滦南县",
            },
            {
              id: 74,
              pid: 63,
              name: "乐亭县",
            },
            {
              id: 75,
              pid: 63,
              name: "迁西县",
            },
            {
              id: 76,
              pid: 63,
              name: "玉田县",
            },
            {
              id: 77,
              pid: 63,
              name: "遵化市",
            },
            {
              id: 78,
              pid: 63,
              name: "迁安市",
            },
          ],
        },
        {
          id: 79,
          pid: 38,
          name: "秦皇岛市",
          children: [
            {
              id: 81,
              pid: 79,
              name: "海港区",
            },
            {
              id: 82,
              pid: 79,
              name: "山海关区",
            },
            {
              id: 83,
              pid: 79,
              name: "北戴河区",
            },
            {
              id: 84,
              pid: 79,
              name: "抚宁区",
            },
            {
              id: 85,
              pid: 79,
              name: "青龙满族自治县",
            },
            {
              id: 86,
              pid: 79,
              name: "昌黎县",
            },
            {
              id: 87,
              pid: 79,
              name: "卢龙县",
            },
          ],
        },
        {
          id: 88,
          pid: 38,
          name: "邯郸市",
          children: [
            {
              id: 90,
              pid: 88,
              name: "邯山区",
            },
            {
              id: 91,
              pid: 88,
              name: "丛台区",
            },
            {
              id: 92,
              pid: 88,
              name: "复兴区",
            },
            {
              id: 93,
              pid: 88,
              name: "峰峰矿区",
            },
            {
              id: 94,
              pid: 88,
              name: "肥乡区",
            },
            {
              id: 95,
              pid: 88,
              name: "永年区",
            },
            {
              id: 96,
              pid: 88,
              name: "临漳县",
            },
            {
              id: 97,
              pid: 88,
              name: "成安县",
            },
            {
              id: 98,
              pid: 88,
              name: "大名县",
            },
            {
              id: 99,
              pid: 88,
              name: "涉县",
            },
            {
              id: 100,
              pid: 88,
              name: "磁县",
            },
            {
              id: 101,
              pid: 88,
              name: "邱县",
            },
            {
              id: 102,
              pid: 88,
              name: "鸡泽县",
            },
            {
              id: 103,
              pid: 88,
              name: "广平县",
            },
            {
              id: 104,
              pid: 88,
              name: "馆陶县",
            },
            {
              id: 105,
              pid: 88,
              name: "魏县",
            },
            {
              id: 106,
              pid: 88,
              name: "曲周县",
            },
            {
              id: 107,
              pid: 88,
              name: "武安市",
            },
          ],
        },
        {
          id: 108,
          pid: 38,
          name: "邢台市",
          children: [
            {
              id: 110,
              pid: 108,
              name: "襄都区",
            },
            {
              id: 111,
              pid: 108,
              name: "信都区",
            },
            {
              id: 112,
              pid: 108,
              name: "临城县",
            },
            {
              id: 113,
              pid: 108,
              name: "内丘县",
            },
            {
              id: 114,
              pid: 108,
              name: "柏乡县",
            },
            {
              id: 115,
              pid: 108,
              name: "隆尧县",
            },
            {
              id: 116,
              pid: 108,
              name: "任泽区",
            },
            {
              id: 117,
              pid: 108,
              name: "南和区",
            },
            {
              id: 118,
              pid: 108,
              name: "宁晋县",
            },
            {
              id: 119,
              pid: 108,
              name: "巨鹿县",
            },
            {
              id: 120,
              pid: 108,
              name: "新河县",
            },
            {
              id: 121,
              pid: 108,
              name: "广宗县",
            },
            {
              id: 122,
              pid: 108,
              name: "平乡县",
            },
            {
              id: 123,
              pid: 108,
              name: "威县",
            },
            {
              id: 124,
              pid: 108,
              name: "清河县",
            },
            {
              id: 125,
              pid: 108,
              name: "临西县",
            },
            {
              id: 126,
              pid: 108,
              name: "南宫市",
            },
            {
              id: 127,
              pid: 108,
              name: "沙河市",
            },
          ],
        },
        {
          id: 128,
          pid: 38,
          name: "保定市",
          children: [
            {
              id: 130,
              pid: 128,
              name: "竞秀区",
            },
            {
              id: 131,
              pid: 128,
              name: "莲池区",
            },
            {
              id: 132,
              pid: 128,
              name: "满城区",
            },
            {
              id: 133,
              pid: 128,
              name: "清苑区",
            },
            {
              id: 134,
              pid: 128,
              name: "徐水区",
            },
            {
              id: 135,
              pid: 128,
              name: "涞水县",
            },
            {
              id: 136,
              pid: 128,
              name: "阜平县",
            },
            {
              id: 137,
              pid: 128,
              name: "定兴县",
            },
            {
              id: 138,
              pid: 128,
              name: "唐县",
            },
            {
              id: 139,
              pid: 128,
              name: "高阳县",
            },
            {
              id: 141,
              pid: 128,
              name: "涞源县",
            },
            {
              id: 142,
              pid: 128,
              name: "望都县",
            },
            {
              id: 144,
              pid: 128,
              name: "易县",
            },
            {
              id: 145,
              pid: 128,
              name: "曲阳县",
            },
            {
              id: 146,
              pid: 128,
              name: "蠡县",
            },
            {
              id: 147,
              pid: 128,
              name: "顺平县",
            },
            {
              id: 148,
              pid: 128,
              name: "博野县",
            },
            {
              id: 150,
              pid: 128,
              name: "涿州市",
            },
            {
              id: 151,
              pid: 128,
              name: "定州市",
            },
            {
              id: 152,
              pid: 128,
              name: "安国市",
            },
            {
              id: 153,
              pid: 128,
              name: "高碑店市",
            },
          ],
        },
        {
          id: 154,
          pid: 38,
          name: "张家口市",
          children: [
            {
              id: 156,
              pid: 154,
              name: "桥东区",
            },
            {
              id: 157,
              pid: 154,
              name: "桥西区",
            },
            {
              id: 158,
              pid: 154,
              name: "宣化区",
            },
            {
              id: 159,
              pid: 154,
              name: "下花园区",
            },
            {
              id: 160,
              pid: 154,
              name: "万全区",
            },
            {
              id: 161,
              pid: 154,
              name: "崇礼区",
            },
            {
              id: 162,
              pid: 154,
              name: "张北县",
            },
            {
              id: 163,
              pid: 154,
              name: "康保县",
            },
            {
              id: 164,
              pid: 154,
              name: "沽源县",
            },
            {
              id: 165,
              pid: 154,
              name: "尚义县",
            },
            {
              id: 166,
              pid: 154,
              name: "蔚县",
            },
            {
              id: 167,
              pid: 154,
              name: "阳原县",
            },
            {
              id: 168,
              pid: 154,
              name: "怀安县",
            },
            {
              id: 169,
              pid: 154,
              name: "怀来县",
            },
            {
              id: 170,
              pid: 154,
              name: "涿鹿县",
            },
            {
              id: 171,
              pid: 154,
              name: "赤城县",
            },
          ],
        },
        {
          id: 172,
          pid: 38,
          name: "承德市",
          children: [
            {
              id: 174,
              pid: 172,
              name: "双桥区",
            },
            {
              id: 175,
              pid: 172,
              name: "双滦区",
            },
            {
              id: 176,
              pid: 172,
              name: "鹰手营子矿区",
            },
            {
              id: 177,
              pid: 172,
              name: "承德县",
            },
            {
              id: 178,
              pid: 172,
              name: "兴隆县",
            },
            {
              id: 179,
              pid: 172,
              name: "滦平县",
            },
            {
              id: 180,
              pid: 172,
              name: "隆化县",
            },
            {
              id: 181,
              pid: 172,
              name: "丰宁满族自治县",
            },
            {
              id: 182,
              pid: 172,
              name: "宽城满族自治县",
            },
            {
              id: 183,
              pid: 172,
              name: "围场满族蒙古族自治县",
            },
            {
              id: 184,
              pid: 172,
              name: "平泉市",
            },
          ],
        },
        {
          id: 185,
          pid: 38,
          name: "沧州市",
          children: [
            {
              id: 187,
              pid: 185,
              name: "新华区",
            },
            {
              id: 188,
              pid: 185,
              name: "运河区",
            },
            {
              id: 189,
              pid: 185,
              name: "沧县",
            },
            {
              id: 190,
              pid: 185,
              name: "青县",
            },
            {
              id: 191,
              pid: 185,
              name: "东光县",
            },
            {
              id: 192,
              pid: 185,
              name: "海兴县",
            },
            {
              id: 193,
              pid: 185,
              name: "盐山县",
            },
            {
              id: 194,
              pid: 185,
              name: "肃宁县",
            },
            {
              id: 195,
              pid: 185,
              name: "南皮县",
            },
            {
              id: 196,
              pid: 185,
              name: "吴桥县",
            },
            {
              id: 197,
              pid: 185,
              name: "献县",
            },
            {
              id: 198,
              pid: 185,
              name: "孟村回族自治县",
            },
            {
              id: 199,
              pid: 185,
              name: "泊头市",
            },
            {
              id: 200,
              pid: 185,
              name: "任丘市",
            },
            {
              id: 201,
              pid: 185,
              name: "黄骅市",
            },
            {
              id: 202,
              pid: 185,
              name: "河间市",
            },
          ],
        },
        {
          id: 203,
          pid: 38,
          name: "廊坊市",
          children: [
            {
              id: 205,
              pid: 203,
              name: "安次区",
            },
            {
              id: 206,
              pid: 203,
              name: "广阳区",
            },
            {
              id: 207,
              pid: 203,
              name: "固安县",
            },
            {
              id: 208,
              pid: 203,
              name: "永清县",
            },
            {
              id: 209,
              pid: 203,
              name: "香河县",
            },
            {
              id: 210,
              pid: 203,
              name: "大城县",
            },
            {
              id: 211,
              pid: 203,
              name: "文安县",
            },
            {
              id: 212,
              pid: 203,
              name: "大厂回族自治县",
            },
            {
              id: 213,
              pid: 203,
              name: "霸州市",
            },
            {
              id: 214,
              pid: 203,
              name: "三河市",
            },
          ],
        },
        {
          id: 3933,
          pid: 38,
          name: "雄安新区",
          children: [
            {
              id: 149,
              pid: 3933,
              name: "雄县",
            },
            {
              id: 140,
              pid: 3933,
              name: "容城县",
            },
            {
              id: 143,
              pid: 3933,
              name: "安新县",
            },
          ],
        },
        {
          id: 215,
          pid: 38,
          name: "衡水市",
          children: [
            {
              id: 217,
              pid: 215,
              name: "桃城区",
            },
            {
              id: 218,
              pid: 215,
              name: "冀州区",
            },
            {
              id: 219,
              pid: 215,
              name: "枣强县",
            },
            {
              id: 220,
              pid: 215,
              name: "武邑县",
            },
            {
              id: 221,
              pid: 215,
              name: "武强县",
            },
            {
              id: 222,
              pid: 215,
              name: "饶阳县",
            },
            {
              id: 223,
              pid: 215,
              name: "安平县",
            },
            {
              id: 224,
              pid: 215,
              name: "故城县",
            },
            {
              id: 225,
              pid: 215,
              name: "景县",
            },
            {
              id: 226,
              pid: 215,
              name: "阜城县",
            },
            {
              id: 227,
              pid: 215,
              name: "深州市",
            },
          ],
        },
      ],
    },
    {
      id: 228,
      pid: 1,
      name: "山西省",
      children: [
        {
          id: 229,
          pid: 228,
          name: "太原市",
          children: [
            {
              id: 231,
              pid: 229,
              name: "小店区",
            },
            {
              id: 232,
              pid: 229,
              name: "迎泽区",
            },
            {
              id: 233,
              pid: 229,
              name: "杏花岭区",
            },
            {
              id: 234,
              pid: 229,
              name: "尖草坪区",
            },
            {
              id: 235,
              pid: 229,
              name: "万柏林区",
            },
            {
              id: 236,
              pid: 229,
              name: "晋源区",
            },
            {
              id: 237,
              pid: 229,
              name: "清徐县",
            },
            {
              id: 238,
              pid: 229,
              name: "阳曲县",
            },
            {
              id: 239,
              pid: 229,
              name: "娄烦县",
            },
            {
              id: 240,
              pid: 229,
              name: "古交市",
            },
          ],
        },
        {
          id: 241,
          pid: 228,
          name: "大同市",
          children: [
            {
              id: 243,
              pid: 241,
              name: "平城区",
            },
            {
              id: 244,
              pid: 241,
              name: "云冈区",
            },
            {
              id: 245,
              pid: 241,
              name: "新荣区",
            },
            {
              id: 246,
              pid: 241,
              name: "阳高县",
            },
            {
              id: 247,
              pid: 241,
              name: "天镇县",
            },
            {
              id: 248,
              pid: 241,
              name: "广灵县",
            },
            {
              id: 249,
              pid: 241,
              name: "灵丘县",
            },
            {
              id: 250,
              pid: 241,
              name: "浑源县",
            },
            {
              id: 251,
              pid: 241,
              name: "左云县",
            },
            {
              id: 252,
              pid: 241,
              name: "云州区",
            },
          ],
        },
        {
          id: 253,
          pid: 228,
          name: "阳泉市",
          children: [
            {
              id: 255,
              pid: 253,
              name: "城区",
            },
            {
              id: 256,
              pid: 253,
              name: "矿区",
            },
            {
              id: 257,
              pid: 253,
              name: "郊区",
            },
            {
              id: 258,
              pid: 253,
              name: "平定县",
            },
            {
              id: 259,
              pid: 253,
              name: "盂县",
            },
          ],
        },
        {
          id: 260,
          pid: 228,
          name: "长治市",
          children: [
            {
              id: 262,
              pid: 260,
              name: "潞州区",
            },
            {
              id: 263,
              pid: 260,
              name: "上党区",
            },
            {
              id: 264,
              pid: 260,
              name: "襄垣县",
            },
            {
              id: 265,
              pid: 260,
              name: "屯留区",
            },
            {
              id: 266,
              pid: 260,
              name: "平顺县",
            },
            {
              id: 267,
              pid: 260,
              name: "黎城县",
            },
            {
              id: 268,
              pid: 260,
              name: "壶关县",
            },
            {
              id: 269,
              pid: 260,
              name: "长子县",
            },
            {
              id: 270,
              pid: 260,
              name: "武乡县",
            },
            {
              id: 271,
              pid: 260,
              name: "沁县",
            },
            {
              id: 272,
              pid: 260,
              name: "沁源县",
            },
            {
              id: 273,
              pid: 260,
              name: "潞城区",
            },
          ],
        },
        {
          id: 274,
          pid: 228,
          name: "晋城市",
          children: [
            {
              id: 276,
              pid: 274,
              name: "城区",
            },
            {
              id: 277,
              pid: 274,
              name: "沁水县",
            },
            {
              id: 278,
              pid: 274,
              name: "阳城县",
            },
            {
              id: 279,
              pid: 274,
              name: "陵川县",
            },
            {
              id: 280,
              pid: 274,
              name: "泽州县",
            },
            {
              id: 281,
              pid: 274,
              name: "高平市",
            },
          ],
        },
        {
          id: 282,
          pid: 228,
          name: "朔州市",
          children: [
            {
              id: 284,
              pid: 282,
              name: "朔城区",
            },
            {
              id: 285,
              pid: 282,
              name: "平鲁区",
            },
            {
              id: 286,
              pid: 282,
              name: "山阴县",
            },
            {
              id: 287,
              pid: 282,
              name: "应县",
            },
            {
              id: 288,
              pid: 282,
              name: "右玉县",
            },
            {
              id: 289,
              pid: 282,
              name: "怀仁市",
            },
          ],
        },
        {
          id: 290,
          pid: 228,
          name: "晋中市",
          children: [
            {
              id: 292,
              pid: 290,
              name: "榆次区",
            },
            {
              id: 293,
              pid: 290,
              name: "榆社县",
            },
            {
              id: 294,
              pid: 290,
              name: "左权县",
            },
            {
              id: 295,
              pid: 290,
              name: "和顺县",
            },
            {
              id: 296,
              pid: 290,
              name: "昔阳县",
            },
            {
              id: 297,
              pid: 290,
              name: "寿阳县",
            },
            {
              id: 298,
              pid: 290,
              name: "太谷区",
            },
            {
              id: 299,
              pid: 290,
              name: "祁县",
            },
            {
              id: 300,
              pid: 290,
              name: "平遥县",
            },
            {
              id: 301,
              pid: 290,
              name: "灵石县",
            },
            {
              id: 302,
              pid: 290,
              name: "介休市",
            },
          ],
        },
        {
          id: 303,
          pid: 228,
          name: "运城市",
          children: [
            {
              id: 305,
              pid: 303,
              name: "盐湖区",
            },
            {
              id: 306,
              pid: 303,
              name: "临猗县",
            },
            {
              id: 307,
              pid: 303,
              name: "万荣县",
            },
            {
              id: 308,
              pid: 303,
              name: "闻喜县",
            },
            {
              id: 309,
              pid: 303,
              name: "稷山县",
            },
            {
              id: 310,
              pid: 303,
              name: "新绛县",
            },
            {
              id: 311,
              pid: 303,
              name: "绛县",
            },
            {
              id: 312,
              pid: 303,
              name: "垣曲县",
            },
            {
              id: 313,
              pid: 303,
              name: "夏县",
            },
            {
              id: 314,
              pid: 303,
              name: "平陆县",
            },
            {
              id: 315,
              pid: 303,
              name: "芮城县",
            },
            {
              id: 316,
              pid: 303,
              name: "永济市",
            },
            {
              id: 317,
              pid: 303,
              name: "河津市",
            },
          ],
        },
        {
          id: 318,
          pid: 228,
          name: "忻州市",
          children: [
            {
              id: 320,
              pid: 318,
              name: "忻府区",
            },
            {
              id: 321,
              pid: 318,
              name: "定襄县",
            },
            {
              id: 322,
              pid: 318,
              name: "五台县",
            },
            {
              id: 323,
              pid: 318,
              name: "代县",
            },
            {
              id: 324,
              pid: 318,
              name: "繁峙县",
            },
            {
              id: 325,
              pid: 318,
              name: "宁武县",
            },
            {
              id: 326,
              pid: 318,
              name: "静乐县",
            },
            {
              id: 327,
              pid: 318,
              name: "神池县",
            },
            {
              id: 328,
              pid: 318,
              name: "五寨县",
            },
            {
              id: 329,
              pid: 318,
              name: "岢岚县",
            },
            {
              id: 330,
              pid: 318,
              name: "河曲县",
            },
            {
              id: 331,
              pid: 318,
              name: "保德县",
            },
            {
              id: 332,
              pid: 318,
              name: "偏关县",
            },
            {
              id: 333,
              pid: 318,
              name: "原平市",
            },
          ],
        },
        {
          id: 334,
          pid: 228,
          name: "临汾市",
          children: [
            {
              id: 336,
              pid: 334,
              name: "尧都区",
            },
            {
              id: 337,
              pid: 334,
              name: "曲沃县",
            },
            {
              id: 338,
              pid: 334,
              name: "翼城县",
            },
            {
              id: 339,
              pid: 334,
              name: "襄汾县",
            },
            {
              id: 340,
              pid: 334,
              name: "洪洞县",
            },
            {
              id: 341,
              pid: 334,
              name: "古县",
            },
            {
              id: 342,
              pid: 334,
              name: "安泽县",
            },
            {
              id: 343,
              pid: 334,
              name: "浮山县",
            },
            {
              id: 344,
              pid: 334,
              name: "吉县",
            },
            {
              id: 345,
              pid: 334,
              name: "乡宁县",
            },
            {
              id: 346,
              pid: 334,
              name: "大宁县",
            },
            {
              id: 347,
              pid: 334,
              name: "隰县",
            },
            {
              id: 348,
              pid: 334,
              name: "永和县",
            },
            {
              id: 349,
              pid: 334,
              name: "蒲县",
            },
            {
              id: 350,
              pid: 334,
              name: "汾西县",
            },
            {
              id: 351,
              pid: 334,
              name: "侯马市",
            },
            {
              id: 352,
              pid: 334,
              name: "霍州市",
            },
          ],
        },
        {
          id: 353,
          pid: 228,
          name: "吕梁市",
          children: [
            {
              id: 355,
              pid: 353,
              name: "离石区",
            },
            {
              id: 356,
              pid: 353,
              name: "文水县",
            },
            {
              id: 357,
              pid: 353,
              name: "交城县",
            },
            {
              id: 358,
              pid: 353,
              name: "兴县",
            },
            {
              id: 359,
              pid: 353,
              name: "临县",
            },
            {
              id: 360,
              pid: 353,
              name: "柳林县",
            },
            {
              id: 361,
              pid: 353,
              name: "石楼县",
            },
            {
              id: 362,
              pid: 353,
              name: "岚县",
            },
            {
              id: 363,
              pid: 353,
              name: "方山县",
            },
            {
              id: 364,
              pid: 353,
              name: "中阳县",
            },
            {
              id: 365,
              pid: 353,
              name: "交口县",
            },
            {
              id: 366,
              pid: 353,
              name: "孝义市",
            },
            {
              id: 367,
              pid: 353,
              name: "汾阳市",
            },
          ],
        },
      ],
    },
    {
      id: 368,
      pid: 1,
      name: "内蒙古自治区",
      children: [
        {
          id: 369,
          pid: 368,
          name: "呼和浩特市",
          children: [
            {
              id: 371,
              pid: 369,
              name: "新城区",
            },
            {
              id: 372,
              pid: 369,
              name: "回民区",
            },
            {
              id: 373,
              pid: 369,
              name: "玉泉区",
            },
            {
              id: 374,
              pid: 369,
              name: "赛罕区",
            },
            {
              id: 375,
              pid: 369,
              name: "土默特左旗",
            },
            {
              id: 376,
              pid: 369,
              name: "托克托县",
            },
            {
              id: 377,
              pid: 369,
              name: "和林格尔县",
            },
            {
              id: 378,
              pid: 369,
              name: "清水河县",
            },
            {
              id: 379,
              pid: 369,
              name: "武川县",
            },
          ],
        },
        {
          id: 380,
          pid: 368,
          name: "包头市",
          children: [
            {
              id: 382,
              pid: 380,
              name: "东河区",
            },
            {
              id: 383,
              pid: 380,
              name: "昆都仑区",
            },
            {
              id: 384,
              pid: 380,
              name: "青山区",
            },
            {
              id: 385,
              pid: 380,
              name: "石拐区",
            },
            {
              id: 386,
              pid: 380,
              name: "白云鄂博矿区",
            },
            {
              id: 387,
              pid: 380,
              name: "九原区",
            },
            {
              id: 388,
              pid: 380,
              name: "土默特右旗",
            },
            {
              id: 389,
              pid: 380,
              name: "固阳县",
            },
            {
              id: 390,
              pid: 380,
              name: "达尔罕茂明安联合旗",
            },
          ],
        },
        {
          id: 391,
          pid: 368,
          name: "乌海市",
          children: [
            {
              id: 393,
              pid: 391,
              name: "海勃湾区",
            },
            {
              id: 394,
              pid: 391,
              name: "海南区",
            },
            {
              id: 395,
              pid: 391,
              name: "乌达区",
            },
          ],
        },
        {
          id: 396,
          pid: 368,
          name: "赤峰市",
          children: [
            {
              id: 398,
              pid: 396,
              name: "红山区",
            },
            {
              id: 399,
              pid: 396,
              name: "元宝山区",
            },
            {
              id: 400,
              pid: 396,
              name: "松山区",
            },
            {
              id: 401,
              pid: 396,
              name: "阿鲁科尔沁旗",
            },
            {
              id: 402,
              pid: 396,
              name: "巴林左旗",
            },
            {
              id: 403,
              pid: 396,
              name: "巴林右旗",
            },
            {
              id: 404,
              pid: 396,
              name: "林西县",
            },
            {
              id: 405,
              pid: 396,
              name: "克什克腾旗",
            },
            {
              id: 406,
              pid: 396,
              name: "翁牛特旗",
            },
            {
              id: 407,
              pid: 396,
              name: "喀喇沁旗",
            },
            {
              id: 408,
              pid: 396,
              name: "宁城县",
            },
            {
              id: 409,
              pid: 396,
              name: "敖汉旗",
            },
          ],
        },
        {
          id: 410,
          pid: 368,
          name: "通辽市",
          children: [
            {
              id: 412,
              pid: 410,
              name: "科尔沁区",
            },
            {
              id: 413,
              pid: 410,
              name: "科尔沁左翼中旗",
            },
            {
              id: 414,
              pid: 410,
              name: "科尔沁左翼后旗",
            },
            {
              id: 415,
              pid: 410,
              name: "开鲁县",
            },
            {
              id: 416,
              pid: 410,
              name: "库伦旗",
            },
            {
              id: 417,
              pid: 410,
              name: "奈曼旗",
            },
            {
              id: 418,
              pid: 410,
              name: "扎鲁特旗",
            },
            {
              id: 419,
              pid: 410,
              name: "霍林郭勒市",
            },
          ],
        },
        {
          id: 420,
          pid: 368,
          name: "鄂尔多斯市",
          children: [
            {
              id: 422,
              pid: 420,
              name: "东胜区",
            },
            {
              id: 423,
              pid: 420,
              name: "康巴什区",
            },
            {
              id: 424,
              pid: 420,
              name: "达拉特旗",
            },
            {
              id: 425,
              pid: 420,
              name: "准格尔旗",
            },
            {
              id: 426,
              pid: 420,
              name: "鄂托克前旗",
            },
            {
              id: 427,
              pid: 420,
              name: "鄂托克旗",
            },
            {
              id: 428,
              pid: 420,
              name: "杭锦旗",
            },
            {
              id: 429,
              pid: 420,
              name: "乌审旗",
            },
            {
              id: 430,
              pid: 420,
              name: "伊金霍洛旗",
            },
          ],
        },
        {
          id: 431,
          pid: 368,
          name: "呼伦贝尔市",
          children: [
            {
              id: 433,
              pid: 431,
              name: "海拉尔区",
            },
            {
              id: 434,
              pid: 431,
              name: "扎赉诺尔区",
            },
            {
              id: 435,
              pid: 431,
              name: "阿荣旗",
            },
            {
              id: 436,
              pid: 431,
              name: "莫力达瓦达斡尔族自治旗",
            },
            {
              id: 437,
              pid: 431,
              name: "鄂伦春自治旗",
            },
            {
              id: 438,
              pid: 431,
              name: "鄂温克族自治旗",
            },
            {
              id: 439,
              pid: 431,
              name: "陈巴尔虎旗",
            },
            {
              id: 440,
              pid: 431,
              name: "新巴尔虎左旗",
            },
            {
              id: 441,
              pid: 431,
              name: "新巴尔虎右旗",
            },
            {
              id: 442,
              pid: 431,
              name: "满洲里市",
            },
            {
              id: 443,
              pid: 431,
              name: "牙克石市",
            },
            {
              id: 444,
              pid: 431,
              name: "扎兰屯市",
            },
            {
              id: 445,
              pid: 431,
              name: "额尔古纳市",
            },
            {
              id: 446,
              pid: 431,
              name: "根河市",
            },
          ],
        },
        {
          id: 447,
          pid: 368,
          name: "巴彦淖尔市",
          children: [
            {
              id: 449,
              pid: 447,
              name: "临河区",
            },
            {
              id: 450,
              pid: 447,
              name: "五原县",
            },
            {
              id: 451,
              pid: 447,
              name: "磴口县",
            },
            {
              id: 452,
              pid: 447,
              name: "乌拉特前旗",
            },
            {
              id: 453,
              pid: 447,
              name: "乌拉特中旗",
            },
            {
              id: 454,
              pid: 447,
              name: "乌拉特后旗",
            },
            {
              id: 455,
              pid: 447,
              name: "杭锦后旗",
            },
          ],
        },
        {
          id: 456,
          pid: 368,
          name: "乌兰察布市",
          children: [
            {
              id: 458,
              pid: 456,
              name: "集宁区",
            },
            {
              id: 459,
              pid: 456,
              name: "卓资县",
            },
            {
              id: 460,
              pid: 456,
              name: "化德县",
            },
            {
              id: 461,
              pid: 456,
              name: "商都县",
            },
            {
              id: 462,
              pid: 456,
              name: "兴和县",
            },
            {
              id: 463,
              pid: 456,
              name: "凉城县",
            },
            {
              id: 464,
              pid: 456,
              name: "察哈尔右翼前旗",
            },
            {
              id: 465,
              pid: 456,
              name: "察哈尔右翼中旗",
            },
            {
              id: 466,
              pid: 456,
              name: "察哈尔右翼后旗",
            },
            {
              id: 467,
              pid: 456,
              name: "四子王旗",
            },
            {
              id: 468,
              pid: 456,
              name: "丰镇市",
            },
          ],
        },
        {
          id: 469,
          pid: 368,
          name: "兴安盟",
          children: [
            {
              id: 470,
              pid: 469,
              name: "乌兰浩特市",
            },
            {
              id: 471,
              pid: 469,
              name: "阿尔山市",
            },
            {
              id: 472,
              pid: 469,
              name: "科尔沁右翼前旗",
            },
            {
              id: 473,
              pid: 469,
              name: "科尔沁右翼中旗",
            },
            {
              id: 474,
              pid: 469,
              name: "扎赉特旗",
            },
            {
              id: 475,
              pid: 469,
              name: "突泉县",
            },
          ],
        },
        {
          id: 476,
          pid: 368,
          name: "锡林郭勒盟",
          children: [
            {
              id: 477,
              pid: 476,
              name: "二连浩特市",
            },
            {
              id: 478,
              pid: 476,
              name: "锡林浩特市",
            },
            {
              id: 479,
              pid: 476,
              name: "阿巴嘎旗",
            },
            {
              id: 480,
              pid: 476,
              name: "苏尼特左旗",
            },
            {
              id: 481,
              pid: 476,
              name: "苏尼特右旗",
            },
            {
              id: 482,
              pid: 476,
              name: "东乌珠穆沁旗",
            },
            {
              id: 483,
              pid: 476,
              name: "西乌珠穆沁旗",
            },
            {
              id: 484,
              pid: 476,
              name: "太仆寺旗",
            },
            {
              id: 485,
              pid: 476,
              name: "镶黄旗",
            },
            {
              id: 486,
              pid: 476,
              name: "正镶白旗",
            },
            {
              id: 487,
              pid: 476,
              name: "正蓝旗",
            },
            {
              id: 488,
              pid: 476,
              name: "多伦县",
            },
          ],
        },
        {
          id: 489,
          pid: 368,
          name: "阿拉善盟",
          children: [
            {
              id: 490,
              pid: 489,
              name: "阿拉善左旗",
            },
            {
              id: 491,
              pid: 489,
              name: "阿拉善右旗",
            },
            {
              id: 492,
              pid: 489,
              name: "额济纳旗",
            },
          ],
        },
      ],
    },
    {
      id: 493,
      pid: 1,
      name: "辽宁省",
      children: [
        {
          id: 494,
          pid: 493,
          name: "沈阳市",
          children: [
            {
              id: 496,
              pid: 494,
              name: "和平区",
            },
            {
              id: 497,
              pid: 494,
              name: "沈河区",
            },
            {
              id: 498,
              pid: 494,
              name: "大东区",
            },
            {
              id: 499,
              pid: 494,
              name: "皇姑区",
            },
            {
              id: 500,
              pid: 494,
              name: "铁西区",
            },
            {
              id: 501,
              pid: 494,
              name: "苏家屯区",
            },
            {
              id: 502,
              pid: 494,
              name: "浑南区",
            },
            {
              id: 503,
              pid: 494,
              name: "沈北新区",
            },
            {
              id: 504,
              pid: 494,
              name: "于洪区",
            },
            {
              id: 505,
              pid: 494,
              name: "辽中区",
            },
            {
              id: 506,
              pid: 494,
              name: "康平县",
            },
            {
              id: 507,
              pid: 494,
              name: "法库县",
            },
            {
              id: 508,
              pid: 494,
              name: "新民市",
            },
          ],
        },
        {
          id: 509,
          pid: 493,
          name: "大连市",
          children: [
            {
              id: 511,
              pid: 509,
              name: "中山区",
            },
            {
              id: 512,
              pid: 509,
              name: "西岗区",
            },
            {
              id: 513,
              pid: 509,
              name: "沙河口区",
            },
            {
              id: 514,
              pid: 509,
              name: "甘井子区",
            },
            {
              id: 515,
              pid: 509,
              name: "旅顺口区",
            },
            {
              id: 516,
              pid: 509,
              name: "金州区",
            },
            {
              id: 517,
              pid: 509,
              name: "普兰店区",
            },
            {
              id: 518,
              pid: 509,
              name: "长海县",
            },
            {
              id: 519,
              pid: 509,
              name: "瓦房店市",
            },
            {
              id: 520,
              pid: 509,
              name: "庄河市",
            },
          ],
        },
        {
          id: 521,
          pid: 493,
          name: "鞍山市",
          children: [
            {
              id: 523,
              pid: 521,
              name: "铁东区",
            },
            {
              id: 524,
              pid: 521,
              name: "铁西区",
            },
            {
              id: 525,
              pid: 521,
              name: "立山区",
            },
            {
              id: 526,
              pid: 521,
              name: "千山区",
            },
            {
              id: 527,
              pid: 521,
              name: "台安县",
            },
            {
              id: 528,
              pid: 521,
              name: "岫岩满族自治县",
            },
            {
              id: 529,
              pid: 521,
              name: "海城市",
            },
          ],
        },
        {
          id: 530,
          pid: 493,
          name: "抚顺市",
          children: [
            {
              id: 532,
              pid: 530,
              name: "新抚区",
            },
            {
              id: 533,
              pid: 530,
              name: "东洲区",
            },
            {
              id: 534,
              pid: 530,
              name: "望花区",
            },
            {
              id: 535,
              pid: 530,
              name: "顺城区",
            },
            {
              id: 536,
              pid: 530,
              name: "抚顺县",
            },
            {
              id: 537,
              pid: 530,
              name: "新宾满族自治县",
            },
            {
              id: 538,
              pid: 530,
              name: "清原满族自治县",
            },
          ],
        },
        {
          id: 539,
          pid: 493,
          name: "本溪市",
          children: [
            {
              id: 541,
              pid: 539,
              name: "平山区",
            },
            {
              id: 542,
              pid: 539,
              name: "溪湖区",
            },
            {
              id: 543,
              pid: 539,
              name: "明山区",
            },
            {
              id: 544,
              pid: 539,
              name: "南芬区",
            },
            {
              id: 545,
              pid: 539,
              name: "本溪满族自治县",
            },
            {
              id: 546,
              pid: 539,
              name: "桓仁满族自治县",
            },
          ],
        },
        {
          id: 547,
          pid: 493,
          name: "丹东市",
          children: [
            {
              id: 549,
              pid: 547,
              name: "元宝区",
            },
            {
              id: 550,
              pid: 547,
              name: "振兴区",
            },
            {
              id: 551,
              pid: 547,
              name: "振安区",
            },
            {
              id: 552,
              pid: 547,
              name: "宽甸满族自治县",
            },
            {
              id: 553,
              pid: 547,
              name: "东港市",
            },
            {
              id: 554,
              pid: 547,
              name: "凤城市",
            },
          ],
        },
        {
          id: 555,
          pid: 493,
          name: "锦州市",
          children: [
            {
              id: 557,
              pid: 555,
              name: "古塔区",
            },
            {
              id: 558,
              pid: 555,
              name: "凌河区",
            },
            {
              id: 559,
              pid: 555,
              name: "太和区",
            },
            {
              id: 560,
              pid: 555,
              name: "黑山县",
            },
            {
              id: 561,
              pid: 555,
              name: "义县",
            },
            {
              id: 562,
              pid: 555,
              name: "凌海市",
            },
            {
              id: 563,
              pid: 555,
              name: "北镇市",
            },
          ],
        },
        {
          id: 564,
          pid: 493,
          name: "营口市",
          children: [
            {
              id: 566,
              pid: 564,
              name: "站前区",
            },
            {
              id: 567,
              pid: 564,
              name: "西市区",
            },
            {
              id: 568,
              pid: 564,
              name: "鲅鱼圈区",
            },
            {
              id: 569,
              pid: 564,
              name: "老边区",
            },
            {
              id: 570,
              pid: 564,
              name: "盖州市",
            },
            {
              id: 571,
              pid: 564,
              name: "大石桥市",
            },
          ],
        },
        {
          id: 572,
          pid: 493,
          name: "阜新市",
          children: [
            {
              id: 574,
              pid: 572,
              name: "海州区",
            },
            {
              id: 575,
              pid: 572,
              name: "新邱区",
            },
            {
              id: 576,
              pid: 572,
              name: "太平区",
            },
            {
              id: 577,
              pid: 572,
              name: "清河门区",
            },
            {
              id: 578,
              pid: 572,
              name: "细河区",
            },
            {
              id: 579,
              pid: 572,
              name: "阜新蒙古族自治县",
            },
            {
              id: 580,
              pid: 572,
              name: "彰武县",
            },
          ],
        },
        {
          id: 581,
          pid: 493,
          name: "辽阳市",
          children: [
            {
              id: 583,
              pid: 581,
              name: "白塔区",
            },
            {
              id: 584,
              pid: 581,
              name: "文圣区",
            },
            {
              id: 585,
              pid: 581,
              name: "宏伟区",
            },
            {
              id: 586,
              pid: 581,
              name: "弓长岭区",
            },
            {
              id: 587,
              pid: 581,
              name: "太子河区",
            },
            {
              id: 588,
              pid: 581,
              name: "辽阳县",
            },
            {
              id: 589,
              pid: 581,
              name: "灯塔市",
            },
          ],
        },
        {
          id: 590,
          pid: 493,
          name: "盘锦市",
          children: [
            {
              id: 592,
              pid: 590,
              name: "双台子区",
            },
            {
              id: 593,
              pid: 590,
              name: "兴隆台区",
            },
            {
              id: 594,
              pid: 590,
              name: "大洼区",
            },
            {
              id: 595,
              pid: 590,
              name: "盘山县",
            },
          ],
        },
        {
          id: 596,
          pid: 493,
          name: "铁岭市",
          children: [
            {
              id: 598,
              pid: 596,
              name: "银州区",
            },
            {
              id: 599,
              pid: 596,
              name: "清河区",
            },
            {
              id: 600,
              pid: 596,
              name: "铁岭县",
            },
            {
              id: 601,
              pid: 596,
              name: "西丰县",
            },
            {
              id: 602,
              pid: 596,
              name: "昌图县",
            },
            {
              id: 603,
              pid: 596,
              name: "调兵山市",
            },
            {
              id: 604,
              pid: 596,
              name: "开原市",
            },
          ],
        },
        {
          id: 605,
          pid: 493,
          name: "朝阳市",
          children: [
            {
              id: 607,
              pid: 605,
              name: "双塔区",
            },
            {
              id: 608,
              pid: 605,
              name: "龙城区",
            },
            {
              id: 609,
              pid: 605,
              name: "朝阳县",
            },
            {
              id: 610,
              pid: 605,
              name: "建平县",
            },
            {
              id: 611,
              pid: 605,
              name: "喀喇沁左翼蒙古族自治县",
            },
            {
              id: 612,
              pid: 605,
              name: "北票市",
            },
            {
              id: 613,
              pid: 605,
              name: "凌源市",
            },
          ],
        },
        {
          id: 614,
          pid: 493,
          name: "葫芦岛市",
          children: [
            {
              id: 616,
              pid: 614,
              name: "连山区",
            },
            {
              id: 617,
              pid: 614,
              name: "龙港区",
            },
            {
              id: 618,
              pid: 614,
              name: "南票区",
            },
            {
              id: 619,
              pid: 614,
              name: "绥中县",
            },
            {
              id: 620,
              pid: 614,
              name: "建昌县",
            },
            {
              id: 621,
              pid: 614,
              name: "兴城市",
            },
          ],
        },
      ],
    },
    {
      id: 622,
      pid: 1,
      name: "吉林省",
      children: [
        {
          id: 623,
          pid: 622,
          name: "长春市",
          children: [
            {
              id: 625,
              pid: 623,
              name: "南关区",
            },
            {
              id: 626,
              pid: 623,
              name: "宽城区",
            },
            {
              id: 627,
              pid: 623,
              name: "朝阳区",
            },
            {
              id: 628,
              pid: 623,
              name: "二道区",
            },
            {
              id: 629,
              pid: 623,
              name: "绿园区",
            },
            {
              id: 630,
              pid: 623,
              name: "双阳区",
            },
            {
              id: 631,
              pid: 623,
              name: "九台区",
            },
            {
              id: 632,
              pid: 623,
              name: "农安县",
            },
            {
              id: 633,
              pid: 623,
              name: "榆树市",
            },
            {
              id: 634,
              pid: 623,
              name: "德惠市",
            },
            {
              id: 652,
              pid: 623,
              name: "公主岭市",
            },
          ],
        },
        {
          id: 635,
          pid: 622,
          name: "吉林市",
          children: [
            {
              id: 637,
              pid: 635,
              name: "昌邑区",
            },
            {
              id: 638,
              pid: 635,
              name: "龙潭区",
            },
            {
              id: 639,
              pid: 635,
              name: "船营区",
            },
            {
              id: 640,
              pid: 635,
              name: "丰满区",
            },
            {
              id: 641,
              pid: 635,
              name: "永吉县",
            },
            {
              id: 642,
              pid: 635,
              name: "蛟河市",
            },
            {
              id: 643,
              pid: 635,
              name: "桦甸市",
            },
            {
              id: 644,
              pid: 635,
              name: "舒兰市",
            },
            {
              id: 645,
              pid: 635,
              name: "磐石市",
            },
          ],
        },
        {
          id: 646,
          pid: 622,
          name: "四平市",
          children: [
            {
              id: 648,
              pid: 646,
              name: "铁西区",
            },
            {
              id: 649,
              pid: 646,
              name: "铁东区",
            },
            {
              id: 650,
              pid: 646,
              name: "梨树县",
            },
            {
              id: 651,
              pid: 646,
              name: "伊通满族自治县",
            },
            {
              id: 653,
              pid: 646,
              name: "双辽市",
            },
          ],
        },
        {
          id: 654,
          pid: 622,
          name: "辽源市",
          children: [
            {
              id: 656,
              pid: 654,
              name: "龙山区",
            },
            {
              id: 657,
              pid: 654,
              name: "西安区",
            },
            {
              id: 658,
              pid: 654,
              name: "东丰县",
            },
            {
              id: 659,
              pid: 654,
              name: "东辽县",
            },
          ],
        },
        {
          id: 660,
          pid: 622,
          name: "通化市",
          children: [
            {
              id: 662,
              pid: 660,
              name: "东昌区",
            },
            {
              id: 663,
              pid: 660,
              name: "二道江区",
            },
            {
              id: 664,
              pid: 660,
              name: "通化县",
            },
            {
              id: 665,
              pid: 660,
              name: "辉南县",
            },
            {
              id: 666,
              pid: 660,
              name: "柳河县",
            },
            {
              id: 667,
              pid: 660,
              name: "梅河口市",
            },
            {
              id: 668,
              pid: 660,
              name: "集安市",
            },
          ],
        },
        {
          id: 669,
          pid: 622,
          name: "白山市",
          children: [
            {
              id: 671,
              pid: 669,
              name: "浑江区",
            },
            {
              id: 672,
              pid: 669,
              name: "江源区",
            },
            {
              id: 673,
              pid: 669,
              name: "抚松县",
            },
            {
              id: 674,
              pid: 669,
              name: "靖宇县",
            },
            {
              id: 675,
              pid: 669,
              name: "长白朝鲜族自治县",
            },
            {
              id: 676,
              pid: 669,
              name: "临江市",
            },
          ],
        },
        {
          id: 677,
          pid: 622,
          name: "松原市",
          children: [
            {
              id: 679,
              pid: 677,
              name: "宁江区",
            },
            {
              id: 680,
              pid: 677,
              name: "前郭尔罗斯蒙古族自治县",
            },
            {
              id: 681,
              pid: 677,
              name: "长岭县",
            },
            {
              id: 682,
              pid: 677,
              name: "乾安县",
            },
            {
              id: 683,
              pid: 677,
              name: "扶余市",
            },
          ],
        },
        {
          id: 684,
          pid: 622,
          name: "白城市",
          children: [
            {
              id: 686,
              pid: 684,
              name: "洮北区",
            },
            {
              id: 687,
              pid: 684,
              name: "镇赉县",
            },
            {
              id: 688,
              pid: 684,
              name: "通榆县",
            },
            {
              id: 689,
              pid: 684,
              name: "洮南市",
            },
            {
              id: 690,
              pid: 684,
              name: "大安市",
            },
          ],
        },
        {
          id: 691,
          pid: 622,
          name: "延边朝鲜族自治州",
          children: [
            {
              id: 692,
              pid: 691,
              name: "延吉市",
            },
            {
              id: 693,
              pid: 691,
              name: "图们市",
            },
            {
              id: 694,
              pid: 691,
              name: "敦化市",
            },
            {
              id: 695,
              pid: 691,
              name: "珲春市",
            },
            {
              id: 696,
              pid: 691,
              name: "龙井市",
            },
            {
              id: 697,
              pid: 691,
              name: "和龙市",
            },
            {
              id: 698,
              pid: 691,
              name: "汪清县",
            },
            {
              id: 699,
              pid: 691,
              name: "安图县",
            },
          ],
        },
      ],
    },
    {
      id: 700,
      pid: 1,
      name: "黑龙江省",
      children: [
        {
          id: 701,
          pid: 700,
          name: "哈尔滨市",
          children: [
            {
              id: 703,
              pid: 701,
              name: "道里区",
            },
            {
              id: 704,
              pid: 701,
              name: "南岗区",
            },
            {
              id: 705,
              pid: 701,
              name: "道外区",
            },
            {
              id: 706,
              pid: 701,
              name: "平房区",
            },
            {
              id: 707,
              pid: 701,
              name: "松北区",
            },
            {
              id: 708,
              pid: 701,
              name: "香坊区",
            },
            {
              id: 709,
              pid: 701,
              name: "呼兰区",
            },
            {
              id: 710,
              pid: 701,
              name: "阿城区",
            },
            {
              id: 711,
              pid: 701,
              name: "双城区",
            },
            {
              id: 712,
              pid: 701,
              name: "依兰县",
            },
            {
              id: 713,
              pid: 701,
              name: "方正县",
            },
            {
              id: 714,
              pid: 701,
              name: "宾县",
            },
            {
              id: 715,
              pid: 701,
              name: "巴彦县",
            },
            {
              id: 716,
              pid: 701,
              name: "木兰县",
            },
            {
              id: 717,
              pid: 701,
              name: "通河县",
            },
            {
              id: 718,
              pid: 701,
              name: "延寿县",
            },
            {
              id: 719,
              pid: 701,
              name: "尚志市",
            },
            {
              id: 720,
              pid: 701,
              name: "五常市",
            },
          ],
        },
        {
          id: 721,
          pid: 700,
          name: "齐齐哈尔市",
          children: [
            {
              id: 723,
              pid: 721,
              name: "龙沙区",
            },
            {
              id: 724,
              pid: 721,
              name: "建华区",
            },
            {
              id: 725,
              pid: 721,
              name: "铁锋区",
            },
            {
              id: 726,
              pid: 721,
              name: "昂昂溪区",
            },
            {
              id: 727,
              pid: 721,
              name: "富拉尔基区",
            },
            {
              id: 728,
              pid: 721,
              name: "碾子山区",
            },
            {
              id: 729,
              pid: 721,
              name: "梅里斯达斡尔族区",
            },
            {
              id: 730,
              pid: 721,
              name: "龙江县",
            },
            {
              id: 731,
              pid: 721,
              name: "依安县",
            },
            {
              id: 732,
              pid: 721,
              name: "泰来县",
            },
            {
              id: 733,
              pid: 721,
              name: "甘南县",
            },
            {
              id: 734,
              pid: 721,
              name: "富裕县",
            },
            {
              id: 735,
              pid: 721,
              name: "克山县",
            },
            {
              id: 736,
              pid: 721,
              name: "克东县",
            },
            {
              id: 737,
              pid: 721,
              name: "拜泉县",
            },
            {
              id: 738,
              pid: 721,
              name: "讷河市",
            },
          ],
        },
        {
          id: 739,
          pid: 700,
          name: "鸡西市",
          children: [
            {
              id: 741,
              pid: 739,
              name: "鸡冠区",
            },
            {
              id: 742,
              pid: 739,
              name: "恒山区",
            },
            {
              id: 743,
              pid: 739,
              name: "滴道区",
            },
            {
              id: 744,
              pid: 739,
              name: "梨树区",
            },
            {
              id: 745,
              pid: 739,
              name: "城子河区",
            },
            {
              id: 746,
              pid: 739,
              name: "麻山区",
            },
            {
              id: 747,
              pid: 739,
              name: "鸡东县",
            },
            {
              id: 748,
              pid: 739,
              name: "虎林市",
            },
            {
              id: 749,
              pid: 739,
              name: "密山市",
            },
          ],
        },
        {
          id: 750,
          pid: 700,
          name: "鹤岗市",
          children: [
            {
              id: 752,
              pid: 750,
              name: "向阳区",
            },
            {
              id: 753,
              pid: 750,
              name: "工农区",
            },
            {
              id: 754,
              pid: 750,
              name: "南山区",
            },
            {
              id: 755,
              pid: 750,
              name: "兴安区",
            },
            {
              id: 756,
              pid: 750,
              name: "东山区",
            },
            {
              id: 757,
              pid: 750,
              name: "兴山区",
            },
            {
              id: 758,
              pid: 750,
              name: "萝北县",
            },
            {
              id: 759,
              pid: 750,
              name: "绥滨县",
            },
          ],
        },
        {
          id: 760,
          pid: 700,
          name: "双鸭山市",
          children: [
            {
              id: 762,
              pid: 760,
              name: "尖山区",
            },
            {
              id: 763,
              pid: 760,
              name: "岭东区",
            },
            {
              id: 764,
              pid: 760,
              name: "四方台区",
            },
            {
              id: 765,
              pid: 760,
              name: "宝山区",
            },
            {
              id: 766,
              pid: 760,
              name: "集贤县",
            },
            {
              id: 767,
              pid: 760,
              name: "友谊县",
            },
            {
              id: 768,
              pid: 760,
              name: "宝清县",
            },
            {
              id: 769,
              pid: 760,
              name: "饶河县",
            },
          ],
        },
        {
          id: 770,
          pid: 700,
          name: "大庆市",
          children: [
            {
              id: 772,
              pid: 770,
              name: "萨尔图区",
            },
            {
              id: 773,
              pid: 770,
              name: "龙凤区",
            },
            {
              id: 774,
              pid: 770,
              name: "让胡路区",
            },
            {
              id: 775,
              pid: 770,
              name: "红岗区",
            },
            {
              id: 776,
              pid: 770,
              name: "大同区",
            },
            {
              id: 777,
              pid: 770,
              name: "肇州县",
            },
            {
              id: 778,
              pid: 770,
              name: "肇源县",
            },
            {
              id: 779,
              pid: 770,
              name: "林甸县",
            },
            {
              id: 780,
              pid: 770,
              name: "杜尔伯特蒙古族自治县",
            },
          ],
        },
        {
          id: 781,
          pid: 700,
          name: "伊春市",
          children: [
            {
              id: 783,
              pid: 781,
              name: "汤旺河区",
            },
            {
              id: 784,
              pid: 781,
              name: "伊美区",
            },
            {
              id: 785,
              pid: 781,
              name: "乌翠区",
            },
            {
              id: 786,
              pid: 781,
              name: "友好区",
            },
            {
              id: 787,
              pid: 781,
              name: "嘉荫县",
            },
            {
              id: 788,
              pid: 781,
              name: "汤旺县",
            },
            {
              id: 789,
              pid: 781,
              name: "丰林县",
            },
            {
              id: 790,
              pid: 781,
              name: "大箐山县",
            },
            {
              id: 791,
              pid: 781,
              name: "南岔县",
            },
            {
              id: 792,
              pid: 781,
              name: "金林区",
            },
            {
              id: 793,
              pid: 781,
              name: "铁力市",
            },
          ],
        },
        {
          id: 794,
          pid: 700,
          name: "佳木斯市",
          children: [
            {
              id: 796,
              pid: 794,
              name: "向阳区",
            },
            {
              id: 797,
              pid: 794,
              name: "前进区",
            },
            {
              id: 798,
              pid: 794,
              name: "东风区",
            },
            {
              id: 799,
              pid: 794,
              name: "郊区",
            },
            {
              id: 800,
              pid: 794,
              name: "桦南县",
            },
            {
              id: 801,
              pid: 794,
              name: "桦川县",
            },
            {
              id: 802,
              pid: 794,
              name: "汤原县",
            },
            {
              id: 803,
              pid: 794,
              name: "同江市",
            },
            {
              id: 804,
              pid: 794,
              name: "富锦市",
            },
            {
              id: 805,
              pid: 794,
              name: "抚远市",
            },
          ],
        },
        {
          id: 806,
          pid: 700,
          name: "七台河市",
          children: [
            {
              id: 808,
              pid: 806,
              name: "新兴区",
            },
            {
              id: 809,
              pid: 806,
              name: "桃山区",
            },
            {
              id: 810,
              pid: 806,
              name: "茄子河区",
            },
            {
              id: 811,
              pid: 806,
              name: "勃利县",
            },
          ],
        },
        {
          id: 812,
          pid: 700,
          name: "牡丹江市",
          children: [
            {
              id: 814,
              pid: 812,
              name: "东安区",
            },
            {
              id: 815,
              pid: 812,
              name: "阳明区",
            },
            {
              id: 816,
              pid: 812,
              name: "爱民区",
            },
            {
              id: 817,
              pid: 812,
              name: "西安区",
            },
            {
              id: 818,
              pid: 812,
              name: "林口县",
            },
            {
              id: 819,
              pid: 812,
              name: "绥芬河市",
            },
            {
              id: 820,
              pid: 812,
              name: "海林市",
            },
            {
              id: 821,
              pid: 812,
              name: "宁安市",
            },
            {
              id: 822,
              pid: 812,
              name: "穆棱市",
            },
            {
              id: 823,
              pid: 812,
              name: "东宁市",
            },
          ],
        },
        {
          id: 824,
          pid: 700,
          name: "黑河市",
          children: [
            {
              id: 826,
              pid: 824,
              name: "爱辉区",
            },
            {
              id: 827,
              pid: 824,
              name: "嫩江市",
            },
            {
              id: 828,
              pid: 824,
              name: "逊克县",
            },
            {
              id: 829,
              pid: 824,
              name: "孙吴县",
            },
            {
              id: 830,
              pid: 824,
              name: "北安市",
            },
            {
              id: 831,
              pid: 824,
              name: "五大连池市",
            },
          ],
        },
        {
          id: 832,
          pid: 700,
          name: "绥化市",
          children: [
            {
              id: 834,
              pid: 832,
              name: "北林区",
            },
            {
              id: 835,
              pid: 832,
              name: "望奎县",
            },
            {
              id: 836,
              pid: 832,
              name: "兰西县",
            },
            {
              id: 837,
              pid: 832,
              name: "青冈县",
            },
            {
              id: 838,
              pid: 832,
              name: "庆安县",
            },
            {
              id: 839,
              pid: 832,
              name: "明水县",
            },
            {
              id: 840,
              pid: 832,
              name: "绥棱县",
            },
            {
              id: 841,
              pid: 832,
              name: "安达市",
            },
            {
              id: 842,
              pid: 832,
              name: "肇东市",
            },
            {
              id: 843,
              pid: 832,
              name: "海伦市",
            },
          ],
        },
        {
          id: 844,
          pid: 700,
          name: "大兴安岭地区",
          children: [
            {
              id: 845,
              pid: 844,
              name: "加格达奇区",
            },
            {
              id: 846,
              pid: 844,
              name: "呼玛县",
            },
            {
              id: 847,
              pid: 844,
              name: "塔河县",
            },
            {
              id: 848,
              pid: 844,
              name: "漠河市",
            },
          ],
        },
      ],
    },
    {
      id: 849,
      pid: 1,
      name: "上海市",
      children: [
        {
          id: 850,
          pid: 849,
          name: "上海市",
          children: [
            {
              id: 851,
              pid: 850,
              name: "黄浦区",
            },
            {
              id: 852,
              pid: 850,
              name: "徐汇区",
            },
            {
              id: 853,
              pid: 850,
              name: "长宁区",
            },
            {
              id: 854,
              pid: 850,
              name: "静安区",
            },
            {
              id: 855,
              pid: 850,
              name: "普陀区",
            },
            {
              id: 856,
              pid: 850,
              name: "虹口区",
            },
            {
              id: 857,
              pid: 850,
              name: "杨浦区",
            },
            {
              id: 858,
              pid: 850,
              name: "闵行区",
            },
            {
              id: 859,
              pid: 850,
              name: "宝山区",
            },
            {
              id: 860,
              pid: 850,
              name: "嘉定区",
            },
            {
              id: 861,
              pid: 850,
              name: "浦东新区",
            },
            {
              id: 862,
              pid: 850,
              name: "金山区",
            },
            {
              id: 863,
              pid: 850,
              name: "松江区",
            },
            {
              id: 864,
              pid: 850,
              name: "青浦区",
            },
            {
              id: 865,
              pid: 850,
              name: "奉贤区",
            },
            {
              id: 866,
              pid: 850,
              name: "崇明区",
            },
          ],
        },
      ],
    },
    {
      id: 867,
      pid: 1,
      name: "江苏省",
      children: [
        {
          id: 868,
          pid: 867,
          name: "南京市",
          children: [
            {
              id: 870,
              pid: 868,
              name: "玄武区",
            },
            {
              id: 871,
              pid: 868,
              name: "秦淮区",
            },
            {
              id: 872,
              pid: 868,
              name: "建邺区",
            },
            {
              id: 873,
              pid: 868,
              name: "鼓楼区",
            },
            {
              id: 874,
              pid: 868,
              name: "浦口区",
            },
            {
              id: 875,
              pid: 868,
              name: "栖霞区",
            },
            {
              id: 876,
              pid: 868,
              name: "雨花台区",
            },
            {
              id: 877,
              pid: 868,
              name: "江宁区",
            },
            {
              id: 878,
              pid: 868,
              name: "六合区",
            },
            {
              id: 879,
              pid: 868,
              name: "溧水区",
            },
            {
              id: 880,
              pid: 868,
              name: "高淳区",
            },
          ],
        },
        {
          id: 881,
          pid: 867,
          name: "无锡市",
          children: [
            {
              id: 883,
              pid: 881,
              name: "锡山区",
            },
            {
              id: 884,
              pid: 881,
              name: "惠山区",
            },
            {
              id: 885,
              pid: 881,
              name: "滨湖区",
            },
            {
              id: 886,
              pid: 881,
              name: "梁溪区",
            },
            {
              id: 887,
              pid: 881,
              name: "新吴区",
            },
            {
              id: 888,
              pid: 881,
              name: "江阴市",
            },
            {
              id: 889,
              pid: 881,
              name: "宜兴市",
            },
          ],
        },
        {
          id: 890,
          pid: 867,
          name: "徐州市",
          children: [
            {
              id: 892,
              pid: 890,
              name: "鼓楼区",
            },
            {
              id: 893,
              pid: 890,
              name: "云龙区",
            },
            {
              id: 894,
              pid: 890,
              name: "贾汪区",
            },
            {
              id: 895,
              pid: 890,
              name: "泉山区",
            },
            {
              id: 896,
              pid: 890,
              name: "铜山区",
            },
            {
              id: 897,
              pid: 890,
              name: "丰县",
            },
            {
              id: 898,
              pid: 890,
              name: "沛县",
            },
            {
              id: 899,
              pid: 890,
              name: "睢宁县",
            },
            {
              id: 900,
              pid: 890,
              name: "新沂市",
            },
            {
              id: 901,
              pid: 890,
              name: "邳州市",
            },
          ],
        },
        {
          id: 902,
          pid: 867,
          name: "常州市",
          children: [
            {
              id: 904,
              pid: 902,
              name: "天宁区",
            },
            {
              id: 905,
              pid: 902,
              name: "钟楼区",
            },
            {
              id: 906,
              pid: 902,
              name: "新北区",
            },
            {
              id: 907,
              pid: 902,
              name: "武进区",
            },
            {
              id: 908,
              pid: 902,
              name: "金坛区",
            },
            {
              id: 909,
              pid: 902,
              name: "溧阳市",
            },
          ],
        },
        {
          id: 910,
          pid: 867,
          name: "苏州市",
          children: [
            {
              id: 912,
              pid: 910,
              name: "虎丘区",
            },
            {
              id: 913,
              pid: 910,
              name: "吴中区",
            },
            {
              id: 914,
              pid: 910,
              name: "相城区",
            },
            {
              id: 915,
              pid: 910,
              name: "姑苏区",
            },
            {
              id: 916,
              pid: 910,
              name: "吴江区",
            },
            {
              id: 917,
              pid: 910,
              name: "常熟市",
            },
            {
              id: 918,
              pid: 910,
              name: "张家港市",
            },
            {
              id: 919,
              pid: 910,
              name: "昆山市",
            },
            {
              id: 920,
              pid: 910,
              name: "太仓市",
            },
          ],
        },
        {
          id: 921,
          pid: 867,
          name: "南通市",
          children: [
            {
              id: 923,
              pid: 921,
              name: "崇川区",
            },
            {
              id: 924,
              pid: 921,
              name: "通州区",
            },
            {
              id: 925,
              pid: 921,
              name: "海安市",
            },
            {
              id: 926,
              pid: 921,
              name: "如东县",
            },
            {
              id: 927,
              pid: 921,
              name: "启东市",
            },
            {
              id: 928,
              pid: 921,
              name: "如皋市",
            },
            {
              id: 929,
              pid: 921,
              name: "海门区",
            },
          ],
        },
        {
          id: 930,
          pid: 867,
          name: "连云港市",
          children: [
            {
              id: 932,
              pid: 930,
              name: "连云区",
            },
            {
              id: 933,
              pid: 930,
              name: "海州区",
            },
            {
              id: 934,
              pid: 930,
              name: "赣榆区",
            },
            {
              id: 935,
              pid: 930,
              name: "东海县",
            },
            {
              id: 936,
              pid: 930,
              name: "灌云县",
            },
            {
              id: 937,
              pid: 930,
              name: "灌南县",
            },
          ],
        },
        {
          id: 938,
          pid: 867,
          name: "淮安市",
          children: [
            {
              id: 940,
              pid: 938,
              name: "淮安区",
            },
            {
              id: 941,
              pid: 938,
              name: "淮阴区",
            },
            {
              id: 942,
              pid: 938,
              name: "清江浦区",
            },
            {
              id: 943,
              pid: 938,
              name: "洪泽区",
            },
            {
              id: 944,
              pid: 938,
              name: "涟水县",
            },
            {
              id: 945,
              pid: 938,
              name: "盱眙县",
            },
            {
              id: 946,
              pid: 938,
              name: "金湖县",
            },
          ],
        },
        {
          id: 947,
          pid: 867,
          name: "盐城市",
          children: [
            {
              id: 949,
              pid: 947,
              name: "亭湖区",
            },
            {
              id: 950,
              pid: 947,
              name: "盐都区",
            },
            {
              id: 951,
              pid: 947,
              name: "大丰区",
            },
            {
              id: 952,
              pid: 947,
              name: "响水县",
            },
            {
              id: 953,
              pid: 947,
              name: "滨海县",
            },
            {
              id: 954,
              pid: 947,
              name: "阜宁县",
            },
            {
              id: 955,
              pid: 947,
              name: "射阳县",
            },
            {
              id: 956,
              pid: 947,
              name: "建湖县",
            },
            {
              id: 957,
              pid: 947,
              name: "东台市",
            },
          ],
        },
        {
          id: 958,
          pid: 867,
          name: "扬州市",
          children: [
            {
              id: 960,
              pid: 958,
              name: "广陵区",
            },
            {
              id: 961,
              pid: 958,
              name: "邗江区",
            },
            {
              id: 962,
              pid: 958,
              name: "江都区",
            },
            {
              id: 963,
              pid: 958,
              name: "宝应县",
            },
            {
              id: 964,
              pid: 958,
              name: "仪征市",
            },
            {
              id: 965,
              pid: 958,
              name: "高邮市",
            },
          ],
        },
        {
          id: 966,
          pid: 867,
          name: "镇江市",
          children: [
            {
              id: 968,
              pid: 966,
              name: "京口区",
            },
            {
              id: 969,
              pid: 966,
              name: "润州区",
            },
            {
              id: 970,
              pid: 966,
              name: "丹徒区",
            },
            {
              id: 971,
              pid: 966,
              name: "丹阳市",
            },
            {
              id: 972,
              pid: 966,
              name: "扬中市",
            },
            {
              id: 973,
              pid: 966,
              name: "句容市",
            },
          ],
        },
        {
          id: 974,
          pid: 867,
          name: "泰州市",
          children: [
            {
              id: 976,
              pid: 974,
              name: "海陵区",
            },
            {
              id: 977,
              pid: 974,
              name: "高港区",
            },
            {
              id: 978,
              pid: 974,
              name: "姜堰区",
            },
            {
              id: 979,
              pid: 974,
              name: "兴化市",
            },
            {
              id: 980,
              pid: 974,
              name: "靖江市",
            },
            {
              id: 981,
              pid: 974,
              name: "泰兴市",
            },
          ],
        },
        {
          id: 982,
          pid: 867,
          name: "宿迁市",
          children: [
            {
              id: 984,
              pid: 982,
              name: "宿城区",
            },
            {
              id: 985,
              pid: 982,
              name: "宿豫区",
            },
            {
              id: 986,
              pid: 982,
              name: "沭阳县",
            },
            {
              id: 987,
              pid: 982,
              name: "泗阳县",
            },
            {
              id: 988,
              pid: 982,
              name: "泗洪县",
            },
          ],
        },
      ],
    },
    {
      id: 989,
      pid: 1,
      name: "浙江省",
      children: [
        {
          id: 990,
          pid: 989,
          name: "杭州市",
          children: [
            {
              id: 3925,
              pid: 990,
              name: "钱塘区",
            },
            {
              id: 992,
              pid: 990,
              name: "上城区",
            },
            {
              id: 993,
              pid: 990,
              name: "下城区",
            },
            {
              id: 994,
              pid: 990,
              name: "江干区",
            },
            {
              id: 995,
              pid: 990,
              name: "拱墅区",
            },
            {
              id: 996,
              pid: 990,
              name: "西湖区",
            },
            {
              id: 997,
              pid: 990,
              name: "滨江区",
            },
            {
              id: 998,
              pid: 990,
              name: "萧山区",
            },
            {
              id: 999,
              pid: 990,
              name: "余杭区",
            },
            {
              id: 1e3,
              pid: 990,
              name: "富阳区",
            },
            {
              id: 1001,
              pid: 990,
              name: "临安区",
            },
            {
              id: 3928,
              pid: 990,
              name: "临平区",
            },
            {
              id: 1002,
              pid: 990,
              name: "桐庐县",
            },
            {
              id: 1003,
              pid: 990,
              name: "淳安县",
            },
            {
              id: 1004,
              pid: 990,
              name: "建德市",
            },
          ],
        },
        {
          id: 1005,
          pid: 989,
          name: "宁波市",
          children: [
            {
              id: 1007,
              pid: 1005,
              name: "海曙区",
            },
            {
              id: 1008,
              pid: 1005,
              name: "江北区",
            },
            {
              id: 1009,
              pid: 1005,
              name: "北仑区",
            },
            {
              id: 1010,
              pid: 1005,
              name: "镇海区",
            },
            {
              id: 1011,
              pid: 1005,
              name: "鄞州区",
            },
            {
              id: 1012,
              pid: 1005,
              name: "奉化区",
            },
            {
              id: 1013,
              pid: 1005,
              name: "象山县",
            },
            {
              id: 1014,
              pid: 1005,
              name: "宁海县",
            },
            {
              id: 1015,
              pid: 1005,
              name: "余姚市",
            },
            {
              id: 1016,
              pid: 1005,
              name: "慈溪市",
            },
          ],
        },
        {
          id: 1017,
          pid: 989,
          name: "温州市",
          children: [
            {
              id: 1019,
              pid: 1017,
              name: "鹿城区",
            },
            {
              id: 1020,
              pid: 1017,
              name: "龙湾区",
            },
            {
              id: 1021,
              pid: 1017,
              name: "瓯海区",
            },
            {
              id: 1022,
              pid: 1017,
              name: "洞头区",
            },
            {
              id: 1023,
              pid: 1017,
              name: "永嘉县",
            },
            {
              id: 1024,
              pid: 1017,
              name: "平阳县",
            },
            {
              id: 1025,
              pid: 1017,
              name: "苍南县",
            },
            {
              id: 1026,
              pid: 1017,
              name: "文成县",
            },
            {
              id: 1027,
              pid: 1017,
              name: "泰顺县",
            },
            {
              id: 1028,
              pid: 1017,
              name: "瑞安市",
            },
            {
              id: 1029,
              pid: 1017,
              name: "乐清市",
            },
            {
              id: 1030,
              pid: 1017,
              name: "龙港市",
            },
          ],
        },
        {
          id: 1031,
          pid: 989,
          name: "嘉兴市",
          children: [
            {
              id: 1033,
              pid: 1031,
              name: "南湖区",
            },
            {
              id: 1034,
              pid: 1031,
              name: "秀洲区",
            },
            {
              id: 1035,
              pid: 1031,
              name: "嘉善县",
            },
            {
              id: 1036,
              pid: 1031,
              name: "海盐县",
            },
            {
              id: 1037,
              pid: 1031,
              name: "海宁市",
            },
            {
              id: 1038,
              pid: 1031,
              name: "平湖市",
            },
            {
              id: 1039,
              pid: 1031,
              name: "桐乡市",
            },
          ],
        },
        {
          id: 1040,
          pid: 989,
          name: "湖州市",
          children: [
            {
              id: 1042,
              pid: 1040,
              name: "吴兴区",
            },
            {
              id: 1043,
              pid: 1040,
              name: "南浔区",
            },
            {
              id: 1044,
              pid: 1040,
              name: "德清县",
            },
            {
              id: 1045,
              pid: 1040,
              name: "长兴县",
            },
            {
              id: 1046,
              pid: 1040,
              name: "安吉县",
            },
          ],
        },
        {
          id: 1047,
          pid: 989,
          name: "绍兴市",
          children: [
            {
              id: 1049,
              pid: 1047,
              name: "越城区",
            },
            {
              id: 1050,
              pid: 1047,
              name: "柯桥区",
            },
            {
              id: 1051,
              pid: 1047,
              name: "上虞区",
            },
            {
              id: 1052,
              pid: 1047,
              name: "新昌县",
            },
            {
              id: 1053,
              pid: 1047,
              name: "诸暨市",
            },
            {
              id: 1054,
              pid: 1047,
              name: "嵊州市",
            },
          ],
        },
        {
          id: 1055,
          pid: 989,
          name: "金华市",
          children: [
            {
              id: 1057,
              pid: 1055,
              name: "婺城区",
            },
            {
              id: 1058,
              pid: 1055,
              name: "金东区",
            },
            {
              id: 1059,
              pid: 1055,
              name: "武义县",
            },
            {
              id: 1060,
              pid: 1055,
              name: "浦江县",
            },
            {
              id: 1061,
              pid: 1055,
              name: "磐安县",
            },
            {
              id: 1062,
              pid: 1055,
              name: "兰溪市",
            },
            {
              id: 1063,
              pid: 1055,
              name: "义乌市",
            },
            {
              id: 1064,
              pid: 1055,
              name: "东阳市",
            },
            {
              id: 1065,
              pid: 1055,
              name: "永康市",
            },
          ],
        },
        {
          id: 1066,
          pid: 989,
          name: "衢州市",
          children: [
            {
              id: 1068,
              pid: 1066,
              name: "柯城区",
            },
            {
              id: 1069,
              pid: 1066,
              name: "衢江区",
            },
            {
              id: 1070,
              pid: 1066,
              name: "常山县",
            },
            {
              id: 1071,
              pid: 1066,
              name: "开化县",
            },
            {
              id: 1072,
              pid: 1066,
              name: "龙游县",
            },
            {
              id: 1073,
              pid: 1066,
              name: "江山市",
            },
          ],
        },
        {
          id: 1074,
          pid: 989,
          name: "舟山市",
          children: [
            {
              id: 1076,
              pid: 1074,
              name: "定海区",
            },
            {
              id: 1077,
              pid: 1074,
              name: "普陀区",
            },
            {
              id: 1078,
              pid: 1074,
              name: "岱山县",
            },
            {
              id: 1079,
              pid: 1074,
              name: "嵊泗县",
            },
          ],
        },
        {
          id: 1080,
          pid: 989,
          name: "台州市",
          children: [
            {
              id: 1082,
              pid: 1080,
              name: "椒江区",
            },
            {
              id: 1083,
              pid: 1080,
              name: "黄岩区",
            },
            {
              id: 1084,
              pid: 1080,
              name: "路桥区",
            },
            {
              id: 1085,
              pid: 1080,
              name: "三门县",
            },
            {
              id: 1086,
              pid: 1080,
              name: "天台县",
            },
            {
              id: 1087,
              pid: 1080,
              name: "仙居县",
            },
            {
              id: 1088,
              pid: 1080,
              name: "温岭市",
            },
            {
              id: 1089,
              pid: 1080,
              name: "临海市",
            },
            {
              id: 1090,
              pid: 1080,
              name: "玉环市",
            },
          ],
        },
        {
          id: 1091,
          pid: 989,
          name: "丽水市",
          children: [
            {
              id: 1093,
              pid: 1091,
              name: "莲都区",
            },
            {
              id: 1094,
              pid: 1091,
              name: "青田县",
            },
            {
              id: 1095,
              pid: 1091,
              name: "缙云县",
            },
            {
              id: 1096,
              pid: 1091,
              name: "遂昌县",
            },
            {
              id: 1097,
              pid: 1091,
              name: "松阳县",
            },
            {
              id: 1098,
              pid: 1091,
              name: "云和县",
            },
            {
              id: 1099,
              pid: 1091,
              name: "庆元县",
            },
            {
              id: 1100,
              pid: 1091,
              name: "景宁畲族自治县",
            },
            {
              id: 1101,
              pid: 1091,
              name: "龙泉市",
            },
          ],
        },
      ],
    },
    {
      id: 1102,
      pid: 1,
      name: "安徽省",
      children: [
        {
          id: 1103,
          pid: 1102,
          name: "合肥市",
          children: [
            {
              id: 1105,
              pid: 1103,
              name: "瑶海区",
            },
            {
              id: 1106,
              pid: 1103,
              name: "庐阳区",
            },
            {
              id: 1107,
              pid: 1103,
              name: "蜀山区",
            },
            {
              id: 1108,
              pid: 1103,
              name: "包河区",
            },
            {
              id: 1109,
              pid: 1103,
              name: "长丰县",
            },
            {
              id: 1110,
              pid: 1103,
              name: "肥东县",
            },
            {
              id: 1111,
              pid: 1103,
              name: "肥西县",
            },
            {
              id: 1112,
              pid: 1103,
              name: "庐江县",
            },
            {
              id: 1113,
              pid: 1103,
              name: "巢湖市",
            },
          ],
        },
        {
          id: 1114,
          pid: 1102,
          name: "芜湖市",
          children: [
            {
              id: 1116,
              pid: 1114,
              name: "镜湖区",
            },
            {
              id: 1117,
              pid: 1114,
              name: "弋江区",
            },
            {
              id: 1118,
              pid: 1114,
              name: "鸠江区",
            },
            {
              id: 1119,
              pid: 1114,
              name: "湾沚区",
            },
            {
              id: 1120,
              pid: 1114,
              name: "繁昌区",
            },
            {
              id: 1121,
              pid: 1114,
              name: "南陵县",
            },
            {
              id: 1122,
              pid: 1114,
              name: "无为市",
            },
          ],
        },
        {
          id: 1123,
          pid: 1102,
          name: "蚌埠市",
          children: [
            {
              id: 1125,
              pid: 1123,
              name: "龙子湖区",
            },
            {
              id: 1126,
              pid: 1123,
              name: "蚌山区",
            },
            {
              id: 1127,
              pid: 1123,
              name: "禹会区",
            },
            {
              id: 1128,
              pid: 1123,
              name: "淮上区",
            },
            {
              id: 1129,
              pid: 1123,
              name: "怀远县",
            },
            {
              id: 1130,
              pid: 1123,
              name: "五河县",
            },
            {
              id: 1131,
              pid: 1123,
              name: "固镇县",
            },
          ],
        },
        {
          id: 1132,
          pid: 1102,
          name: "淮南市",
          children: [
            {
              id: 1134,
              pid: 1132,
              name: "大通区",
            },
            {
              id: 1135,
              pid: 1132,
              name: "田家庵区",
            },
            {
              id: 1136,
              pid: 1132,
              name: "谢家集区",
            },
            {
              id: 1137,
              pid: 1132,
              name: "八公山区",
            },
            {
              id: 1138,
              pid: 1132,
              name: "潘集区",
            },
            {
              id: 1139,
              pid: 1132,
              name: "凤台县",
            },
            {
              id: 1140,
              pid: 1132,
              name: "寿县",
            },
          ],
        },
        {
          id: 1141,
          pid: 1102,
          name: "马鞍山市",
          children: [
            {
              id: 1143,
              pid: 1141,
              name: "花山区",
            },
            {
              id: 1144,
              pid: 1141,
              name: "雨山区",
            },
            {
              id: 1145,
              pid: 1141,
              name: "博望区",
            },
            {
              id: 1146,
              pid: 1141,
              name: "当涂县",
            },
            {
              id: 1147,
              pid: 1141,
              name: "含山县",
            },
            {
              id: 1148,
              pid: 1141,
              name: "和县",
            },
          ],
        },
        {
          id: 1149,
          pid: 1102,
          name: "淮北市",
          children: [
            {
              id: 1151,
              pid: 1149,
              name: "杜集区",
            },
            {
              id: 1152,
              pid: 1149,
              name: "相山区",
            },
            {
              id: 1153,
              pid: 1149,
              name: "烈山区",
            },
            {
              id: 1154,
              pid: 1149,
              name: "濉溪县",
            },
          ],
        },
        {
          id: 1155,
          pid: 1102,
          name: "铜陵市",
          children: [
            {
              id: 1157,
              pid: 1155,
              name: "铜官区",
            },
            {
              id: 1158,
              pid: 1155,
              name: "义安区",
            },
            {
              id: 1159,
              pid: 1155,
              name: "郊区",
            },
            {
              id: 1160,
              pid: 1155,
              name: "枞阳县",
            },
          ],
        },
        {
          id: 1161,
          pid: 1102,
          name: "安庆市",
          children: [
            {
              id: 1163,
              pid: 1161,
              name: "迎江区",
            },
            {
              id: 1164,
              pid: 1161,
              name: "大观区",
            },
            {
              id: 1165,
              pid: 1161,
              name: "宜秀区",
            },
            {
              id: 1166,
              pid: 1161,
              name: "怀宁县",
            },
            {
              id: 1167,
              pid: 1161,
              name: "潜山市",
            },
            {
              id: 1168,
              pid: 1161,
              name: "太湖县",
            },
            {
              id: 1169,
              pid: 1161,
              name: "宿松县",
            },
            {
              id: 1170,
              pid: 1161,
              name: "望江县",
            },
            {
              id: 1171,
              pid: 1161,
              name: "岳西县",
            },
            {
              id: 1172,
              pid: 1161,
              name: "桐城市",
            },
          ],
        },
        {
          id: 1173,
          pid: 1102,
          name: "黄山市",
          children: [
            {
              id: 1175,
              pid: 1173,
              name: "屯溪区",
            },
            {
              id: 1176,
              pid: 1173,
              name: "黄山区",
            },
            {
              id: 1177,
              pid: 1173,
              name: "徽州区",
            },
            {
              id: 1178,
              pid: 1173,
              name: "歙县",
            },
            {
              id: 1179,
              pid: 1173,
              name: "休宁县",
            },
            {
              id: 1180,
              pid: 1173,
              name: "黟县",
            },
            {
              id: 1181,
              pid: 1173,
              name: "祁门县",
            },
          ],
        },
        {
          id: 1182,
          pid: 1102,
          name: "滁州市",
          children: [
            {
              id: 1184,
              pid: 1182,
              name: "琅琊区",
            },
            {
              id: 1185,
              pid: 1182,
              name: "南谯区",
            },
            {
              id: 1186,
              pid: 1182,
              name: "来安县",
            },
            {
              id: 1187,
              pid: 1182,
              name: "全椒县",
            },
            {
              id: 1188,
              pid: 1182,
              name: "定远县",
            },
            {
              id: 1189,
              pid: 1182,
              name: "凤阳县",
            },
            {
              id: 1190,
              pid: 1182,
              name: "天长市",
            },
            {
              id: 1191,
              pid: 1182,
              name: "明光市",
            },
          ],
        },
        {
          id: 1192,
          pid: 1102,
          name: "阜阳市",
          children: [
            {
              id: 1194,
              pid: 1192,
              name: "颍州区",
            },
            {
              id: 1195,
              pid: 1192,
              name: "颍东区",
            },
            {
              id: 1196,
              pid: 1192,
              name: "颍泉区",
            },
            {
              id: 1197,
              pid: 1192,
              name: "临泉县",
            },
            {
              id: 1198,
              pid: 1192,
              name: "太和县",
            },
            {
              id: 1199,
              pid: 1192,
              name: "阜南县",
            },
            {
              id: 1200,
              pid: 1192,
              name: "颍上县",
            },
            {
              id: 1201,
              pid: 1192,
              name: "界首市",
            },
          ],
        },
        {
          id: 1202,
          pid: 1102,
          name: "宿州市",
          children: [
            {
              id: 1204,
              pid: 1202,
              name: "埇桥区",
            },
            {
              id: 1205,
              pid: 1202,
              name: "砀山县",
            },
            {
              id: 1206,
              pid: 1202,
              name: "萧县",
            },
            {
              id: 1207,
              pid: 1202,
              name: "灵璧县",
            },
            {
              id: 1208,
              pid: 1202,
              name: "泗县",
            },
          ],
        },
        {
          id: 1209,
          pid: 1102,
          name: "六安市",
          children: [
            {
              id: 1211,
              pid: 1209,
              name: "金安区",
            },
            {
              id: 1212,
              pid: 1209,
              name: "裕安区",
            },
            {
              id: 1213,
              pid: 1209,
              name: "叶集区",
            },
            {
              id: 1214,
              pid: 1209,
              name: "霍邱县",
            },
            {
              id: 1215,
              pid: 1209,
              name: "舒城县",
            },
            {
              id: 1216,
              pid: 1209,
              name: "金寨县",
            },
            {
              id: 1217,
              pid: 1209,
              name: "霍山县",
            },
          ],
        },
        {
          id: 1218,
          pid: 1102,
          name: "亳州市",
          children: [
            {
              id: 1220,
              pid: 1218,
              name: "谯城区",
            },
            {
              id: 1221,
              pid: 1218,
              name: "涡阳县",
            },
            {
              id: 1222,
              pid: 1218,
              name: "蒙城县",
            },
            {
              id: 1223,
              pid: 1218,
              name: "利辛县",
            },
          ],
        },
        {
          id: 1224,
          pid: 1102,
          name: "池州市",
          children: [
            {
              id: 1226,
              pid: 1224,
              name: "贵池区",
            },
            {
              id: 1227,
              pid: 1224,
              name: "东至县",
            },
            {
              id: 1228,
              pid: 1224,
              name: "石台县",
            },
            {
              id: 1229,
              pid: 1224,
              name: "青阳县",
            },
          ],
        },
        {
          id: 1230,
          pid: 1102,
          name: "宣城市",
          children: [
            {
              id: 1232,
              pid: 1230,
              name: "宣州区",
            },
            {
              id: 1233,
              pid: 1230,
              name: "郎溪县",
            },
            {
              id: 1234,
              pid: 1230,
              name: "广德市",
            },
            {
              id: 1235,
              pid: 1230,
              name: "泾县",
            },
            {
              id: 1236,
              pid: 1230,
              name: "绩溪县",
            },
            {
              id: 1237,
              pid: 1230,
              name: "旌德县",
            },
            {
              id: 1238,
              pid: 1230,
              name: "宁国市",
            },
          ],
        },
      ],
    },
    {
      id: 1239,
      pid: 1,
      name: "福建省",
      children: [
        {
          id: 1240,
          pid: 1239,
          name: "福州市",
          children: [
            {
              id: 1242,
              pid: 1240,
              name: "鼓楼区",
            },
            {
              id: 1243,
              pid: 1240,
              name: "台江区",
            },
            {
              id: 1244,
              pid: 1240,
              name: "仓山区",
            },
            {
              id: 1245,
              pid: 1240,
              name: "马尾区",
            },
            {
              id: 1246,
              pid: 1240,
              name: "晋安区",
            },
            {
              id: 1247,
              pid: 1240,
              name: "长乐区",
            },
            {
              id: 1248,
              pid: 1240,
              name: "闽侯县",
            },
            {
              id: 1249,
              pid: 1240,
              name: "连江县",
            },
            {
              id: 1250,
              pid: 1240,
              name: "罗源县",
            },
            {
              id: 1251,
              pid: 1240,
              name: "闽清县",
            },
            {
              id: 1252,
              pid: 1240,
              name: "永泰县",
            },
            {
              id: 1253,
              pid: 1240,
              name: "平潭县",
            },
            {
              id: 1254,
              pid: 1240,
              name: "福清市",
            },
          ],
        },
        {
          id: 1255,
          pid: 1239,
          name: "厦门市",
          children: [
            {
              id: 1257,
              pid: 1255,
              name: "思明区",
            },
            {
              id: 1258,
              pid: 1255,
              name: "海沧区",
            },
            {
              id: 1259,
              pid: 1255,
              name: "湖里区",
            },
            {
              id: 1260,
              pid: 1255,
              name: "集美区",
            },
            {
              id: 1261,
              pid: 1255,
              name: "同安区",
            },
            {
              id: 1262,
              pid: 1255,
              name: "翔安区",
            },
          ],
        },
        {
          id: 1263,
          pid: 1239,
          name: "莆田市",
          children: [
            {
              id: 1265,
              pid: 1263,
              name: "城厢区",
            },
            {
              id: 1266,
              pid: 1263,
              name: "涵江区",
            },
            {
              id: 1267,
              pid: 1263,
              name: "荔城区",
            },
            {
              id: 1268,
              pid: 1263,
              name: "秀屿区",
            },
            {
              id: 1269,
              pid: 1263,
              name: "仙游县",
            },
          ],
        },
        {
          id: 1270,
          pid: 1239,
          name: "三明市",
          children: [
            {
              id: 1272,
              pid: 1270,
              name: "梅列区",
            },
            {
              id: 1273,
              pid: 1270,
              name: "三元区",
            },
            {
              id: 1274,
              pid: 1270,
              name: "明溪县",
            },
            {
              id: 1275,
              pid: 1270,
              name: "清流县",
            },
            {
              id: 1276,
              pid: 1270,
              name: "宁化县",
            },
            {
              id: 1277,
              pid: 1270,
              name: "大田县",
            },
            {
              id: 1278,
              pid: 1270,
              name: "尤溪县",
            },
            {
              id: 1279,
              pid: 1270,
              name: "沙县",
            },
            {
              id: 1280,
              pid: 1270,
              name: "将乐县",
            },
            {
              id: 1281,
              pid: 1270,
              name: "泰宁县",
            },
            {
              id: 1282,
              pid: 1270,
              name: "建宁县",
            },
            {
              id: 1283,
              pid: 1270,
              name: "永安市",
            },
          ],
        },
        {
          id: 1284,
          pid: 1239,
          name: "泉州市",
          children: [
            {
              id: 1286,
              pid: 1284,
              name: "鲤城区",
            },
            {
              id: 1287,
              pid: 1284,
              name: "丰泽区",
            },
            {
              id: 1288,
              pid: 1284,
              name: "洛江区",
            },
            {
              id: 1289,
              pid: 1284,
              name: "泉港区",
            },
            {
              id: 1290,
              pid: 1284,
              name: "惠安县",
            },
            {
              id: 1291,
              pid: 1284,
              name: "安溪县",
            },
            {
              id: 1292,
              pid: 1284,
              name: "永春县",
            },
            {
              id: 1293,
              pid: 1284,
              name: "德化县",
            },
            {
              id: 1294,
              pid: 1284,
              name: "金门县",
            },
            {
              id: 1295,
              pid: 1284,
              name: "石狮市",
            },
            {
              id: 1296,
              pid: 1284,
              name: "晋江市",
            },
            {
              id: 1297,
              pid: 1284,
              name: "南安市",
            },
          ],
        },
        {
          id: 1298,
          pid: 1239,
          name: "漳州市",
          children: [
            {
              id: 1300,
              pid: 1298,
              name: "芗城区",
            },
            {
              id: 1301,
              pid: 1298,
              name: "龙文区",
            },
            {
              id: 1302,
              pid: 1298,
              name: "云霄县",
            },
            {
              id: 1303,
              pid: 1298,
              name: "漳浦县",
            },
            {
              id: 1304,
              pid: 1298,
              name: "诏安县",
            },
            {
              id: 1305,
              pid: 1298,
              name: "长泰县",
            },
            {
              id: 1306,
              pid: 1298,
              name: "东山县",
            },
            {
              id: 1307,
              pid: 1298,
              name: "南靖县",
            },
            {
              id: 1308,
              pid: 1298,
              name: "平和县",
            },
            {
              id: 1309,
              pid: 1298,
              name: "华安县",
            },
            {
              id: 1310,
              pid: 1298,
              name: "龙海市",
            },
          ],
        },
        {
          id: 1311,
          pid: 1239,
          name: "南平市",
          children: [
            {
              id: 1313,
              pid: 1311,
              name: "延平区",
            },
            {
              id: 1314,
              pid: 1311,
              name: "建阳区",
            },
            {
              id: 1315,
              pid: 1311,
              name: "顺昌县",
            },
            {
              id: 1316,
              pid: 1311,
              name: "浦城县",
            },
            {
              id: 1317,
              pid: 1311,
              name: "光泽县",
            },
            {
              id: 1318,
              pid: 1311,
              name: "松溪县",
            },
            {
              id: 1319,
              pid: 1311,
              name: "政和县",
            },
            {
              id: 1320,
              pid: 1311,
              name: "邵武市",
            },
            {
              id: 1321,
              pid: 1311,
              name: "武夷山市",
            },
            {
              id: 1322,
              pid: 1311,
              name: "建瓯市",
            },
          ],
        },
        {
          id: 1323,
          pid: 1239,
          name: "龙岩市",
          children: [
            {
              id: 1325,
              pid: 1323,
              name: "新罗区",
            },
            {
              id: 1326,
              pid: 1323,
              name: "永定区",
            },
            {
              id: 1327,
              pid: 1323,
              name: "长汀县",
            },
            {
              id: 1328,
              pid: 1323,
              name: "上杭县",
            },
            {
              id: 1329,
              pid: 1323,
              name: "武平县",
            },
            {
              id: 1330,
              pid: 1323,
              name: "连城县",
            },
            {
              id: 1331,
              pid: 1323,
              name: "漳平市",
            },
          ],
        },
        {
          id: 1332,
          pid: 1239,
          name: "宁德市",
          children: [
            {
              id: 1334,
              pid: 1332,
              name: "蕉城区",
            },
            {
              id: 1335,
              pid: 1332,
              name: "霞浦县",
            },
            {
              id: 1336,
              pid: 1332,
              name: "古田县",
            },
            {
              id: 1337,
              pid: 1332,
              name: "屏南县",
            },
            {
              id: 1338,
              pid: 1332,
              name: "寿宁县",
            },
            {
              id: 1339,
              pid: 1332,
              name: "周宁县",
            },
            {
              id: 1340,
              pid: 1332,
              name: "柘荣县",
            },
            {
              id: 1341,
              pid: 1332,
              name: "福安市",
            },
            {
              id: 1342,
              pid: 1332,
              name: "福鼎市",
            },
          ],
        },
      ],
    },
    {
      id: 1343,
      pid: 1,
      name: "江西省",
      children: [
        {
          id: 1344,
          pid: 1343,
          name: "南昌市",
          children: [
            {
              id: 1346,
              pid: 1344,
              name: "东湖区",
            },
            {
              id: 1347,
              pid: 1344,
              name: "西湖区",
            },
            {
              id: 1348,
              pid: 1344,
              name: "青云谱区",
            },
            {
              id: 1349,
              pid: 1344,
              name: "青山湖区",
            },
            {
              id: 1350,
              pid: 1344,
              name: "红谷滩区",
            },
            {
              id: 1351,
              pid: 1344,
              name: "新建区",
            },
            {
              id: 1352,
              pid: 1344,
              name: "南昌县",
            },
            {
              id: 1353,
              pid: 1344,
              name: "安义县",
            },
            {
              id: 1354,
              pid: 1344,
              name: "进贤县",
            },
          ],
        },
        {
          id: 1355,
          pid: 1343,
          name: "景德镇市",
          children: [
            {
              id: 1357,
              pid: 1355,
              name: "昌江区",
            },
            {
              id: 1358,
              pid: 1355,
              name: "珠山区",
            },
            {
              id: 1359,
              pid: 1355,
              name: "浮梁县",
            },
            {
              id: 1360,
              pid: 1355,
              name: "乐平市",
            },
          ],
        },
        {
          id: 1361,
          pid: 1343,
          name: "萍乡市",
          children: [
            {
              id: 1363,
              pid: 1361,
              name: "安源区",
            },
            {
              id: 1364,
              pid: 1361,
              name: "湘东区",
            },
            {
              id: 1365,
              pid: 1361,
              name: "莲花县",
            },
            {
              id: 1366,
              pid: 1361,
              name: "上栗县",
            },
            {
              id: 1367,
              pid: 1361,
              name: "芦溪县",
            },
          ],
        },
        {
          id: 1368,
          pid: 1343,
          name: "九江市",
          children: [
            {
              id: 1370,
              pid: 1368,
              name: "濂溪区",
            },
            {
              id: 1371,
              pid: 1368,
              name: "浔阳区",
            },
            {
              id: 1372,
              pid: 1368,
              name: "柴桑区",
            },
            {
              id: 1373,
              pid: 1368,
              name: "武宁县",
            },
            {
              id: 1374,
              pid: 1368,
              name: "修水县",
            },
            {
              id: 1375,
              pid: 1368,
              name: "永修县",
            },
            {
              id: 1376,
              pid: 1368,
              name: "德安县",
            },
            {
              id: 1377,
              pid: 1368,
              name: "都昌县",
            },
            {
              id: 1378,
              pid: 1368,
              name: "湖口县",
            },
            {
              id: 1379,
              pid: 1368,
              name: "彭泽县",
            },
            {
              id: 1380,
              pid: 1368,
              name: "瑞昌市",
            },
            {
              id: 1381,
              pid: 1368,
              name: "共青城市",
            },
            {
              id: 1382,
              pid: 1368,
              name: "庐山市",
            },
          ],
        },
        {
          id: 1383,
          pid: 1343,
          name: "新余市",
          children: [
            {
              id: 1385,
              pid: 1383,
              name: "渝水区",
            },
            {
              id: 1386,
              pid: 1383,
              name: "分宜县",
            },
          ],
        },
        {
          id: 1387,
          pid: 1343,
          name: "鹰潭市",
          children: [
            {
              id: 1389,
              pid: 1387,
              name: "月湖区",
            },
            {
              id: 1390,
              pid: 1387,
              name: "余江区",
            },
            {
              id: 1391,
              pid: 1387,
              name: "贵溪市",
            },
          ],
        },
        {
          id: 1392,
          pid: 1343,
          name: "赣州市",
          children: [
            {
              id: 1394,
              pid: 1392,
              name: "章贡区",
            },
            {
              id: 1395,
              pid: 1392,
              name: "南康区",
            },
            {
              id: 1396,
              pid: 1392,
              name: "赣县区",
            },
            {
              id: 1397,
              pid: 1392,
              name: "信丰县",
            },
            {
              id: 1398,
              pid: 1392,
              name: "大余县",
            },
            {
              id: 1399,
              pid: 1392,
              name: "上犹县",
            },
            {
              id: 1400,
              pid: 1392,
              name: "崇义县",
            },
            {
              id: 1401,
              pid: 1392,
              name: "安远县",
            },
            {
              id: 1402,
              pid: 1392,
              name: "龙南市",
            },
            {
              id: 1403,
              pid: 1392,
              name: "定南县",
            },
            {
              id: 1404,
              pid: 1392,
              name: "全南县",
            },
            {
              id: 1405,
              pid: 1392,
              name: "宁都县",
            },
            {
              id: 1406,
              pid: 1392,
              name: "于都县",
            },
            {
              id: 1407,
              pid: 1392,
              name: "兴国县",
            },
            {
              id: 1408,
              pid: 1392,
              name: "会昌县",
            },
            {
              id: 1409,
              pid: 1392,
              name: "寻乌县",
            },
            {
              id: 1410,
              pid: 1392,
              name: "石城县",
            },
            {
              id: 1411,
              pid: 1392,
              name: "瑞金市",
            },
          ],
        },
        {
          id: 1412,
          pid: 1343,
          name: "吉安市",
          children: [
            {
              id: 1414,
              pid: 1412,
              name: "吉州区",
            },
            {
              id: 1415,
              pid: 1412,
              name: "青原区",
            },
            {
              id: 1416,
              pid: 1412,
              name: "吉安县",
            },
            {
              id: 1417,
              pid: 1412,
              name: "吉水县",
            },
            {
              id: 1418,
              pid: 1412,
              name: "峡江县",
            },
            {
              id: 1419,
              pid: 1412,
              name: "新干县",
            },
            {
              id: 1420,
              pid: 1412,
              name: "永丰县",
            },
            {
              id: 1421,
              pid: 1412,
              name: "泰和县",
            },
            {
              id: 1422,
              pid: 1412,
              name: "遂川县",
            },
            {
              id: 1423,
              pid: 1412,
              name: "万安县",
            },
            {
              id: 1424,
              pid: 1412,
              name: "安福县",
            },
            {
              id: 1425,
              pid: 1412,
              name: "永新县",
            },
            {
              id: 1426,
              pid: 1412,
              name: "井冈山市",
            },
          ],
        },
        {
          id: 1427,
          pid: 1343,
          name: "宜春市",
          children: [
            {
              id: 1429,
              pid: 1427,
              name: "袁州区",
            },
            {
              id: 1430,
              pid: 1427,
              name: "奉新县",
            },
            {
              id: 1431,
              pid: 1427,
              name: "万载县",
            },
            {
              id: 1432,
              pid: 1427,
              name: "上高县",
            },
            {
              id: 1433,
              pid: 1427,
              name: "宜丰县",
            },
            {
              id: 1434,
              pid: 1427,
              name: "靖安县",
            },
            {
              id: 1435,
              pid: 1427,
              name: "铜鼓县",
            },
            {
              id: 1436,
              pid: 1427,
              name: "丰城市",
            },
            {
              id: 1437,
              pid: 1427,
              name: "樟树市",
            },
            {
              id: 1438,
              pid: 1427,
              name: "高安市",
            },
          ],
        },
        {
          id: 1439,
          pid: 1343,
          name: "抚州市",
          children: [
            {
              id: 1441,
              pid: 1439,
              name: "临川区",
            },
            {
              id: 1442,
              pid: 1439,
              name: "东乡区",
            },
            {
              id: 1443,
              pid: 1439,
              name: "南城县",
            },
            {
              id: 1444,
              pid: 1439,
              name: "黎川县",
            },
            {
              id: 1445,
              pid: 1439,
              name: "南丰县",
            },
            {
              id: 1446,
              pid: 1439,
              name: "崇仁县",
            },
            {
              id: 1447,
              pid: 1439,
              name: "乐安县",
            },
            {
              id: 1448,
              pid: 1439,
              name: "宜黄县",
            },
            {
              id: 1449,
              pid: 1439,
              name: "金溪县",
            },
            {
              id: 1450,
              pid: 1439,
              name: "资溪县",
            },
            {
              id: 1451,
              pid: 1439,
              name: "广昌县",
            },
          ],
        },
        {
          id: 1452,
          pid: 1343,
          name: "上饶市",
          children: [
            {
              id: 1454,
              pid: 1452,
              name: "信州区",
            },
            {
              id: 1455,
              pid: 1452,
              name: "广丰区",
            },
            {
              id: 1456,
              pid: 1452,
              name: "广信区",
            },
            {
              id: 1457,
              pid: 1452,
              name: "玉山县",
            },
            {
              id: 1458,
              pid: 1452,
              name: "铅山县",
            },
            {
              id: 1459,
              pid: 1452,
              name: "横峰县",
            },
            {
              id: 1460,
              pid: 1452,
              name: "弋阳县",
            },
            {
              id: 1461,
              pid: 1452,
              name: "余干县",
            },
            {
              id: 1462,
              pid: 1452,
              name: "鄱阳县",
            },
            {
              id: 1463,
              pid: 1452,
              name: "万年县",
            },
            {
              id: 1464,
              pid: 1452,
              name: "婺源县",
            },
            {
              id: 1465,
              pid: 1452,
              name: "德兴市",
            },
          ],
        },
      ],
    },
    {
      id: 1466,
      pid: 1,
      name: "山东省",
      children: [
        {
          id: 1467,
          pid: 1466,
          name: "济南市",
          children: [
            {
              id: 1469,
              pid: 1467,
              name: "历下区",
            },
            {
              id: 1470,
              pid: 1467,
              name: "市中区",
            },
            {
              id: 1471,
              pid: 1467,
              name: "槐荫区",
            },
            {
              id: 1472,
              pid: 1467,
              name: "天桥区",
            },
            {
              id: 1473,
              pid: 1467,
              name: "历城区",
            },
            {
              id: 1474,
              pid: 1467,
              name: "长清区",
            },
            {
              id: 1475,
              pid: 1467,
              name: "章丘区",
            },
            {
              id: 1476,
              pid: 1467,
              name: "平阴县",
            },
            {
              id: 1477,
              pid: 1467,
              name: "济阳区",
            },
            {
              id: 1478,
              pid: 1467,
              name: "商河县",
            },
            {
              id: 1576,
              pid: 1467,
              name: "莱芜区",
            },
            {
              id: 1577,
              pid: 1467,
              name: "钢城区",
            },
          ],
        },
        {
          id: 1479,
          pid: 1466,
          name: "青岛市",
          children: [
            {
              id: 1481,
              pid: 1479,
              name: "市南区",
            },
            {
              id: 1482,
              pid: 1479,
              name: "市北区",
            },
            {
              id: 1483,
              pid: 1479,
              name: "黄岛区",
            },
            {
              id: 1484,
              pid: 1479,
              name: "崂山区",
            },
            {
              id: 1485,
              pid: 1479,
              name: "李沧区",
            },
            {
              id: 1486,
              pid: 1479,
              name: "城阳区",
            },
            {
              id: 1487,
              pid: 1479,
              name: "即墨区",
            },
            {
              id: 1488,
              pid: 1479,
              name: "胶州市",
            },
            {
              id: 1489,
              pid: 1479,
              name: "平度市",
            },
            {
              id: 1490,
              pid: 1479,
              name: "莱西市",
            },
          ],
        },
        {
          id: 1491,
          pid: 1466,
          name: "淄博市",
          children: [
            {
              id: 1493,
              pid: 1491,
              name: "淄川区",
            },
            {
              id: 1494,
              pid: 1491,
              name: "张店区",
            },
            {
              id: 1495,
              pid: 1491,
              name: "博山区",
            },
            {
              id: 1496,
              pid: 1491,
              name: "临淄区",
            },
            {
              id: 1497,
              pid: 1491,
              name: "周村区",
            },
            {
              id: 1498,
              pid: 1491,
              name: "桓台县",
            },
            {
              id: 1499,
              pid: 1491,
              name: "高青县",
            },
            {
              id: 1500,
              pid: 1491,
              name: "沂源县",
            },
          ],
        },
        {
          id: 1501,
          pid: 1466,
          name: "枣庄市",
          children: [
            {
              id: 1503,
              pid: 1501,
              name: "市中区",
            },
            {
              id: 1504,
              pid: 1501,
              name: "薛城区",
            },
            {
              id: 1505,
              pid: 1501,
              name: "峄城区",
            },
            {
              id: 1506,
              pid: 1501,
              name: "台儿庄区",
            },
            {
              id: 1507,
              pid: 1501,
              name: "山亭区",
            },
            {
              id: 1508,
              pid: 1501,
              name: "滕州市",
            },
          ],
        },
        {
          id: 1509,
          pid: 1466,
          name: "东营市",
          children: [
            {
              id: 1511,
              pid: 1509,
              name: "东营区",
            },
            {
              id: 1512,
              pid: 1509,
              name: "河口区",
            },
            {
              id: 1513,
              pid: 1509,
              name: "垦利区",
            },
            {
              id: 1514,
              pid: 1509,
              name: "利津县",
            },
            {
              id: 1515,
              pid: 1509,
              name: "广饶县",
            },
          ],
        },
        {
          id: 1516,
          pid: 1466,
          name: "烟台市",
          children: [
            {
              id: 1518,
              pid: 1516,
              name: "芝罘区",
            },
            {
              id: 1519,
              pid: 1516,
              name: "福山区",
            },
            {
              id: 1520,
              pid: 1516,
              name: "牟平区",
            },
            {
              id: 1521,
              pid: 1516,
              name: "莱山区",
            },
            {
              id: 1522,
              pid: 1516,
              name: "蓬莱区",
            },
            {
              id: 1523,
              pid: 1516,
              name: "龙口市",
            },
            {
              id: 1524,
              pid: 1516,
              name: "莱阳市",
            },
            {
              id: 1525,
              pid: 1516,
              name: "莱州市",
            },
            {
              id: 1526,
              pid: 1516,
              name: "招远市",
            },
            {
              id: 1527,
              pid: 1516,
              name: "栖霞市",
            },
            {
              id: 1528,
              pid: 1516,
              name: "海阳市",
            },
          ],
        },
        {
          id: 1529,
          pid: 1466,
          name: "潍坊市",
          children: [
            {
              id: 1531,
              pid: 1529,
              name: "潍城区",
            },
            {
              id: 1532,
              pid: 1529,
              name: "寒亭区",
            },
            {
              id: 1533,
              pid: 1529,
              name: "坊子区",
            },
            {
              id: 1534,
              pid: 1529,
              name: "奎文区",
            },
            {
              id: 1535,
              pid: 1529,
              name: "临朐县",
            },
            {
              id: 1536,
              pid: 1529,
              name: "昌乐县",
            },
            {
              id: 1537,
              pid: 1529,
              name: "青州市",
            },
            {
              id: 1538,
              pid: 1529,
              name: "诸城市",
            },
            {
              id: 1539,
              pid: 1529,
              name: "寿光市",
            },
            {
              id: 1540,
              pid: 1529,
              name: "安丘市",
            },
            {
              id: 1541,
              pid: 1529,
              name: "高密市",
            },
            {
              id: 1542,
              pid: 1529,
              name: "昌邑市",
            },
          ],
        },
        {
          id: 1543,
          pid: 1466,
          name: "济宁市",
          children: [
            {
              id: 1545,
              pid: 1543,
              name: "任城区",
            },
            {
              id: 1546,
              pid: 1543,
              name: "兖州区",
            },
            {
              id: 1547,
              pid: 1543,
              name: "微山县",
            },
            {
              id: 1548,
              pid: 1543,
              name: "鱼台县",
            },
            {
              id: 1549,
              pid: 1543,
              name: "金乡县",
            },
            {
              id: 1550,
              pid: 1543,
              name: "嘉祥县",
            },
            {
              id: 1551,
              pid: 1543,
              name: "汶上县",
            },
            {
              id: 1552,
              pid: 1543,
              name: "泗水县",
            },
            {
              id: 1553,
              pid: 1543,
              name: "梁山县",
            },
            {
              id: 1554,
              pid: 1543,
              name: "曲阜市",
            },
            {
              id: 1555,
              pid: 1543,
              name: "邹城市",
            },
          ],
        },
        {
          id: 1556,
          pid: 1466,
          name: "泰安市",
          children: [
            {
              id: 1558,
              pid: 1556,
              name: "泰山区",
            },
            {
              id: 1559,
              pid: 1556,
              name: "岱岳区",
            },
            {
              id: 1560,
              pid: 1556,
              name: "宁阳县",
            },
            {
              id: 1561,
              pid: 1556,
              name: "东平县",
            },
            {
              id: 1562,
              pid: 1556,
              name: "新泰市",
            },
            {
              id: 1563,
              pid: 1556,
              name: "肥城市",
            },
          ],
        },
        {
          id: 1564,
          pid: 1466,
          name: "威海市",
          children: [
            {
              id: 1566,
              pid: 1564,
              name: "环翠区",
            },
            {
              id: 1567,
              pid: 1564,
              name: "文登区",
            },
            {
              id: 1568,
              pid: 1564,
              name: "荣成市",
            },
            {
              id: 1569,
              pid: 1564,
              name: "乳山市",
            },
          ],
        },
        {
          id: 1570,
          pid: 1466,
          name: "日照市",
          children: [
            {
              id: 1572,
              pid: 1570,
              name: "东港区",
            },
            {
              id: 1573,
              pid: 1570,
              name: "岚山区",
            },
            {
              id: 1574,
              pid: 1570,
              name: "五莲县",
            },
            {
              id: 1575,
              pid: 1570,
              name: "莒县",
            },
          ],
        },
        {
          id: 1578,
          pid: 1466,
          name: "临沂市",
          children: [
            {
              id: 1580,
              pid: 1578,
              name: "兰山区",
            },
            {
              id: 1581,
              pid: 1578,
              name: "罗庄区",
            },
            {
              id: 1582,
              pid: 1578,
              name: "河东区",
            },
            {
              id: 1583,
              pid: 1578,
              name: "沂南县",
            },
            {
              id: 1584,
              pid: 1578,
              name: "郯城县",
            },
            {
              id: 1585,
              pid: 1578,
              name: "沂水县",
            },
            {
              id: 1586,
              pid: 1578,
              name: "兰陵县",
            },
            {
              id: 1587,
              pid: 1578,
              name: "费县",
            },
            {
              id: 1588,
              pid: 1578,
              name: "平邑县",
            },
            {
              id: 1589,
              pid: 1578,
              name: "莒南县",
            },
            {
              id: 1590,
              pid: 1578,
              name: "蒙阴县",
            },
            {
              id: 1591,
              pid: 1578,
              name: "临沭县",
            },
          ],
        },
        {
          id: 1592,
          pid: 1466,
          name: "德州市",
          children: [
            {
              id: 1594,
              pid: 1592,
              name: "德城区",
            },
            {
              id: 1595,
              pid: 1592,
              name: "陵城区",
            },
            {
              id: 1596,
              pid: 1592,
              name: "宁津县",
            },
            {
              id: 1597,
              pid: 1592,
              name: "庆云县",
            },
            {
              id: 1598,
              pid: 1592,
              name: "临邑县",
            },
            {
              id: 1599,
              pid: 1592,
              name: "齐河县",
            },
            {
              id: 1600,
              pid: 1592,
              name: "平原县",
            },
            {
              id: 1601,
              pid: 1592,
              name: "夏津县",
            },
            {
              id: 1602,
              pid: 1592,
              name: "武城县",
            },
            {
              id: 1603,
              pid: 1592,
              name: "乐陵市",
            },
            {
              id: 1604,
              pid: 1592,
              name: "禹城市",
            },
          ],
        },
        {
          id: 1605,
          pid: 1466,
          name: "聊城市",
          children: [
            {
              id: 1607,
              pid: 1605,
              name: "东昌府区",
            },
            {
              id: 1608,
              pid: 1605,
              name: "阳谷县",
            },
            {
              id: 1609,
              pid: 1605,
              name: "莘县",
            },
            {
              id: 1610,
              pid: 1605,
              name: "茌平区",
            },
            {
              id: 1611,
              pid: 1605,
              name: "东阿县",
            },
            {
              id: 1612,
              pid: 1605,
              name: "冠县",
            },
            {
              id: 1613,
              pid: 1605,
              name: "高唐县",
            },
            {
              id: 1614,
              pid: 1605,
              name: "临清市",
            },
          ],
        },
        {
          id: 1615,
          pid: 1466,
          name: "滨州市",
          children: [
            {
              id: 1617,
              pid: 1615,
              name: "滨城区",
            },
            {
              id: 1618,
              pid: 1615,
              name: "沾化区",
            },
            {
              id: 1619,
              pid: 1615,
              name: "惠民县",
            },
            {
              id: 1620,
              pid: 1615,
              name: "阳信县",
            },
            {
              id: 1621,
              pid: 1615,
              name: "无棣县",
            },
            {
              id: 1622,
              pid: 1615,
              name: "博兴县",
            },
            {
              id: 1623,
              pid: 1615,
              name: "邹平市",
            },
          ],
        },
        {
          id: 1624,
          pid: 1466,
          name: "菏泽市",
          children: [
            {
              id: 1626,
              pid: 1624,
              name: "牡丹区",
            },
            {
              id: 1627,
              pid: 1624,
              name: "定陶区",
            },
            {
              id: 1628,
              pid: 1624,
              name: "曹县",
            },
            {
              id: 1629,
              pid: 1624,
              name: "单县",
            },
            {
              id: 1630,
              pid: 1624,
              name: "成武县",
            },
            {
              id: 1631,
              pid: 1624,
              name: "巨野县",
            },
            {
              id: 1632,
              pid: 1624,
              name: "郓城县",
            },
            {
              id: 1633,
              pid: 1624,
              name: "鄄城县",
            },
            {
              id: 1634,
              pid: 1624,
              name: "东明县",
            },
          ],
        },
      ],
    },
    {
      id: 1635,
      pid: 1,
      name: "河南省",
      children: [
        {
          id: 1636,
          pid: 1635,
          name: "郑州市",
          children: [
            {
              id: 1638,
              pid: 1636,
              name: "中原区",
            },
            {
              id: 1639,
              pid: 1636,
              name: "二七区",
            },
            {
              id: 1640,
              pid: 1636,
              name: "管城回族区",
            },
            {
              id: 1641,
              pid: 1636,
              name: "金水区",
            },
            {
              id: 1642,
              pid: 1636,
              name: "上街区",
            },
            {
              id: 1643,
              pid: 1636,
              name: "惠济区",
            },
            {
              id: 1644,
              pid: 1636,
              name: "中牟县",
            },
            {
              id: 1645,
              pid: 1636,
              name: "巩义市",
            },
            {
              id: 1646,
              pid: 1636,
              name: "荥阳市",
            },
            {
              id: 1647,
              pid: 1636,
              name: "新密市",
            },
            {
              id: 1648,
              pid: 1636,
              name: "新郑市",
            },
            {
              id: 1649,
              pid: 1636,
              name: "登封市",
            },
          ],
        },
        {
          id: 1650,
          pid: 1635,
          name: "开封市",
          children: [
            {
              id: 1652,
              pid: 1650,
              name: "龙亭区",
            },
            {
              id: 1653,
              pid: 1650,
              name: "顺河回族区",
            },
            {
              id: 1654,
              pid: 1650,
              name: "鼓楼区",
            },
            {
              id: 1655,
              pid: 1650,
              name: "禹王台区",
            },
            {
              id: 1656,
              pid: 1650,
              name: "祥符区",
            },
            {
              id: 1657,
              pid: 1650,
              name: "杞县",
            },
            {
              id: 1658,
              pid: 1650,
              name: "通许县",
            },
            {
              id: 1659,
              pid: 1650,
              name: "尉氏县",
            },
            {
              id: 1660,
              pid: 1650,
              name: "兰考县",
            },
          ],
        },
        {
          id: 1661,
          pid: 1635,
          name: "洛阳市",
          children: [
            {
              id: 1663,
              pid: 1661,
              name: "老城区",
            },
            {
              id: 1664,
              pid: 1661,
              name: "西工区",
            },
            {
              id: 1665,
              pid: 1661,
              name: "瀍河回族区",
            },
            {
              id: 1666,
              pid: 1661,
              name: "涧西区",
            },
            {
              id: 1667,
              pid: 1661,
              name: "孟津区",
            },
            {
              id: 1668,
              pid: 1661,
              name: "洛龙区",
            },
            {
              id: 1669,
              pid: 1661,
              name: "新安县",
            },
            {
              id: 1670,
              pid: 1661,
              name: "栾川县",
            },
            {
              id: 1671,
              pid: 1661,
              name: "嵩县",
            },
            {
              id: 1672,
              pid: 1661,
              name: "汝阳县",
            },
            {
              id: 1673,
              pid: 1661,
              name: "宜阳县",
            },
            {
              id: 1674,
              pid: 1661,
              name: "洛宁县",
            },
            {
              id: 1675,
              pid: 1661,
              name: "伊川县",
            },
            {
              id: 1676,
              pid: 1661,
              name: "偃师区",
            },
          ],
        },
        {
          id: 1677,
          pid: 1635,
          name: "平顶山市",
          children: [
            {
              id: 1679,
              pid: 1677,
              name: "新华区",
            },
            {
              id: 1680,
              pid: 1677,
              name: "卫东区",
            },
            {
              id: 1681,
              pid: 1677,
              name: "石龙区",
            },
            {
              id: 1682,
              pid: 1677,
              name: "湛河区",
            },
            {
              id: 1683,
              pid: 1677,
              name: "宝丰县",
            },
            {
              id: 1684,
              pid: 1677,
              name: "叶县",
            },
            {
              id: 1685,
              pid: 1677,
              name: "鲁山县",
            },
            {
              id: 1686,
              pid: 1677,
              name: "郏县",
            },
            {
              id: 1687,
              pid: 1677,
              name: "舞钢市",
            },
            {
              id: 1688,
              pid: 1677,
              name: "汝州市",
            },
          ],
        },
        {
          id: 1689,
          pid: 1635,
          name: "安阳市",
          children: [
            {
              id: 1691,
              pid: 1689,
              name: "文峰区",
            },
            {
              id: 1692,
              pid: 1689,
              name: "北关区",
            },
            {
              id: 1693,
              pid: 1689,
              name: "殷都区",
            },
            {
              id: 1694,
              pid: 1689,
              name: "龙安区",
            },
            {
              id: 1695,
              pid: 1689,
              name: "安阳县",
            },
            {
              id: 1696,
              pid: 1689,
              name: "汤阴县",
            },
            {
              id: 1697,
              pid: 1689,
              name: "滑县",
            },
            {
              id: 1698,
              pid: 1689,
              name: "内黄县",
            },
            {
              id: 1699,
              pid: 1689,
              name: "林州市",
            },
          ],
        },
        {
          id: 1700,
          pid: 1635,
          name: "鹤壁市",
          children: [
            {
              id: 1702,
              pid: 1700,
              name: "鹤山区",
            },
            {
              id: 1703,
              pid: 1700,
              name: "山城区",
            },
            {
              id: 1704,
              pid: 1700,
              name: "淇滨区",
            },
            {
              id: 1705,
              pid: 1700,
              name: "浚县",
            },
            {
              id: 1706,
              pid: 1700,
              name: "淇县",
            },
          ],
        },
        {
          id: 1707,
          pid: 1635,
          name: "新乡市",
          children: [
            {
              id: 1709,
              pid: 1707,
              name: "红旗区",
            },
            {
              id: 1710,
              pid: 1707,
              name: "卫滨区",
            },
            {
              id: 1711,
              pid: 1707,
              name: "凤泉区",
            },
            {
              id: 1712,
              pid: 1707,
              name: "牧野区",
            },
            {
              id: 1713,
              pid: 1707,
              name: "新乡县",
            },
            {
              id: 1714,
              pid: 1707,
              name: "获嘉县",
            },
            {
              id: 1715,
              pid: 1707,
              name: "原阳县",
            },
            {
              id: 1716,
              pid: 1707,
              name: "延津县",
            },
            {
              id: 1717,
              pid: 1707,
              name: "封丘县",
            },
            {
              id: 1718,
              pid: 1707,
              name: "长垣市",
            },
            {
              id: 1719,
              pid: 1707,
              name: "卫辉市",
            },
            {
              id: 1720,
              pid: 1707,
              name: "辉县市",
            },
          ],
        },
        {
          id: 1721,
          pid: 1635,
          name: "焦作市",
          children: [
            {
              id: 1723,
              pid: 1721,
              name: "解放区",
            },
            {
              id: 1724,
              pid: 1721,
              name: "中站区",
            },
            {
              id: 1725,
              pid: 1721,
              name: "马村区",
            },
            {
              id: 1726,
              pid: 1721,
              name: "山阳区",
            },
            {
              id: 1727,
              pid: 1721,
              name: "修武县",
            },
            {
              id: 1728,
              pid: 1721,
              name: "博爱县",
            },
            {
              id: 1729,
              pid: 1721,
              name: "武陟县",
            },
            {
              id: 1730,
              pid: 1721,
              name: "温县",
            },
            {
              id: 1731,
              pid: 1721,
              name: "沁阳市",
            },
            {
              id: 1732,
              pid: 1721,
              name: "孟州市",
            },
          ],
        },
        {
          id: 1733,
          pid: 1635,
          name: "濮阳市",
          children: [
            {
              id: 1735,
              pid: 1733,
              name: "华龙区",
            },
            {
              id: 1736,
              pid: 1733,
              name: "清丰县",
            },
            {
              id: 1737,
              pid: 1733,
              name: "南乐县",
            },
            {
              id: 1738,
              pid: 1733,
              name: "范县",
            },
            {
              id: 1739,
              pid: 1733,
              name: "台前县",
            },
            {
              id: 1740,
              pid: 1733,
              name: "濮阳县",
            },
          ],
        },
        {
          id: 1741,
          pid: 1635,
          name: "许昌市",
          children: [
            {
              id: 1743,
              pid: 1741,
              name: "魏都区",
            },
            {
              id: 1744,
              pid: 1741,
              name: "建安区",
            },
            {
              id: 1745,
              pid: 1741,
              name: "鄢陵县",
            },
            {
              id: 1746,
              pid: 1741,
              name: "襄城县",
            },
            {
              id: 1747,
              pid: 1741,
              name: "禹州市",
            },
            {
              id: 1748,
              pid: 1741,
              name: "长葛市",
            },
          ],
        },
        {
          id: 1749,
          pid: 1635,
          name: "漯河市",
          children: [
            {
              id: 1751,
              pid: 1749,
              name: "源汇区",
            },
            {
              id: 1752,
              pid: 1749,
              name: "郾城区",
            },
            {
              id: 1753,
              pid: 1749,
              name: "召陵区",
            },
            {
              id: 1754,
              pid: 1749,
              name: "舞阳县",
            },
            {
              id: 1755,
              pid: 1749,
              name: "临颍县",
            },
          ],
        },
        {
          id: 1756,
          pid: 1635,
          name: "三门峡市",
          children: [
            {
              id: 1758,
              pid: 1756,
              name: "湖滨区",
            },
            {
              id: 1759,
              pid: 1756,
              name: "陕州区",
            },
            {
              id: 1760,
              pid: 1756,
              name: "渑池县",
            },
            {
              id: 1761,
              pid: 1756,
              name: "卢氏县",
            },
            {
              id: 1762,
              pid: 1756,
              name: "义马市",
            },
            {
              id: 1763,
              pid: 1756,
              name: "灵宝市",
            },
          ],
        },
        {
          id: 1764,
          pid: 1635,
          name: "南阳市",
          children: [
            {
              id: 1766,
              pid: 1764,
              name: "宛城区",
            },
            {
              id: 1767,
              pid: 1764,
              name: "卧龙区",
            },
            {
              id: 1768,
              pid: 1764,
              name: "南召县",
            },
            {
              id: 1769,
              pid: 1764,
              name: "方城县",
            },
            {
              id: 1770,
              pid: 1764,
              name: "西峡县",
            },
            {
              id: 1771,
              pid: 1764,
              name: "镇平县",
            },
            {
              id: 1772,
              pid: 1764,
              name: "内乡县",
            },
            {
              id: 1773,
              pid: 1764,
              name: "淅川县",
            },
            {
              id: 1774,
              pid: 1764,
              name: "社旗县",
            },
            {
              id: 1775,
              pid: 1764,
              name: "唐河县",
            },
            {
              id: 1776,
              pid: 1764,
              name: "新野县",
            },
            {
              id: 1777,
              pid: 1764,
              name: "桐柏县",
            },
            {
              id: 1778,
              pid: 1764,
              name: "邓州市",
            },
          ],
        },
        {
          id: 1779,
          pid: 1635,
          name: "商丘市",
          children: [
            {
              id: 1781,
              pid: 1779,
              name: "梁园区",
            },
            {
              id: 1782,
              pid: 1779,
              name: "睢阳区",
            },
            {
              id: 1783,
              pid: 1779,
              name: "民权县",
            },
            {
              id: 1784,
              pid: 1779,
              name: "睢县",
            },
            {
              id: 1785,
              pid: 1779,
              name: "宁陵县",
            },
            {
              id: 1786,
              pid: 1779,
              name: "柘城县",
            },
            {
              id: 1787,
              pid: 1779,
              name: "虞城县",
            },
            {
              id: 1788,
              pid: 1779,
              name: "夏邑县",
            },
            {
              id: 1789,
              pid: 1779,
              name: "永城市",
            },
          ],
        },
        {
          id: 1790,
          pid: 1635,
          name: "信阳市",
          children: [
            {
              id: 1792,
              pid: 1790,
              name: "浉河区",
            },
            {
              id: 1793,
              pid: 1790,
              name: "平桥区",
            },
            {
              id: 1794,
              pid: 1790,
              name: "罗山县",
            },
            {
              id: 1795,
              pid: 1790,
              name: "光山县",
            },
            {
              id: 1796,
              pid: 1790,
              name: "新县",
            },
            {
              id: 1797,
              pid: 1790,
              name: "商城县",
            },
            {
              id: 1798,
              pid: 1790,
              name: "固始县",
            },
            {
              id: 1799,
              pid: 1790,
              name: "潢川县",
            },
            {
              id: 1800,
              pid: 1790,
              name: "淮滨县",
            },
            {
              id: 1801,
              pid: 1790,
              name: "息县",
            },
          ],
        },
        {
          id: 1802,
          pid: 1635,
          name: "周口市",
          children: [
            {
              id: 1804,
              pid: 1802,
              name: "川汇区",
            },
            {
              id: 1805,
              pid: 1802,
              name: "扶沟县",
            },
            {
              id: 1806,
              pid: 1802,
              name: "西华县",
            },
            {
              id: 1807,
              pid: 1802,
              name: "商水县",
            },
            {
              id: 1808,
              pid: 1802,
              name: "沈丘县",
            },
            {
              id: 1809,
              pid: 1802,
              name: "郸城县",
            },
            {
              id: 1810,
              pid: 1802,
              name: "淮阳区",
            },
            {
              id: 1811,
              pid: 1802,
              name: "太康县",
            },
            {
              id: 1812,
              pid: 1802,
              name: "鹿邑县",
            },
            {
              id: 1813,
              pid: 1802,
              name: "项城市",
            },
          ],
        },
        {
          id: 1814,
          pid: 1635,
          name: "驻马店市",
          children: [
            {
              id: 1816,
              pid: 1814,
              name: "驿城区",
            },
            {
              id: 1817,
              pid: 1814,
              name: "西平县",
            },
            {
              id: 1818,
              pid: 1814,
              name: "上蔡县",
            },
            {
              id: 1819,
              pid: 1814,
              name: "平舆县",
            },
            {
              id: 1820,
              pid: 1814,
              name: "正阳县",
            },
            {
              id: 1821,
              pid: 1814,
              name: "确山县",
            },
            {
              id: 1822,
              pid: 1814,
              name: "泌阳县",
            },
            {
              id: 1823,
              pid: 1814,
              name: "汝南县",
            },
            {
              id: 1824,
              pid: 1814,
              name: "遂平县",
            },
            {
              id: 1825,
              pid: 1814,
              name: "新蔡县",
            },
          ],
        },
        {
          id: 1826,
          pid: 1635,
          name: "济源市",
          children: [
            {
              id: 3909,
              pid: 1826,
              name: "济源市区",
            },
            {
              id: 3910,
              pid: 1826,
              name: "轵城镇",
            },
            {
              id: 3911,
              pid: 1826,
              name: "王屋镇",
            },
            {
              id: 3912,
              pid: 1826,
              name: "坡头镇",
            },
            {
              id: 3913,
              pid: 1826,
              name: "克井镇",
            },
            {
              id: 3914,
              pid: 1826,
              name: "承留镇",
            },
            {
              id: 3915,
              pid: 1826,
              name: "五龙口镇",
            },
            {
              id: 3916,
              pid: 1826,
              name: "梨林镇",
            },
            {
              id: 3917,
              pid: 1826,
              name: "下冶镇",
            },
            {
              id: 3918,
              pid: 1826,
              name: "邵原镇",
            },
            {
              id: 3919,
              pid: 1826,
              name: "大峪镇",
            },
            {
              id: 3920,
              pid: 1826,
              name: "思礼镇",
            },
          ],
        },
      ],
    },
    {
      id: 1827,
      pid: 1,
      name: "湖北省",
      children: [
        {
          id: 1828,
          pid: 1827,
          name: "武汉市",
          children: [
            {
              id: 1830,
              pid: 1828,
              name: "江岸区",
            },
            {
              id: 1831,
              pid: 1828,
              name: "江汉区",
            },
            {
              id: 1832,
              pid: 1828,
              name: "硚口区",
            },
            {
              id: 1833,
              pid: 1828,
              name: "汉阳区",
            },
            {
              id: 1834,
              pid: 1828,
              name: "武昌区",
            },
            {
              id: 1835,
              pid: 1828,
              name: "青山区",
            },
            {
              id: 1836,
              pid: 1828,
              name: "洪山区",
            },
            {
              id: 1837,
              pid: 1828,
              name: "东西湖区",
            },
            {
              id: 1838,
              pid: 1828,
              name: "汉南区",
            },
            {
              id: 1839,
              pid: 1828,
              name: "蔡甸区",
            },
            {
              id: 1840,
              pid: 1828,
              name: "江夏区",
            },
            {
              id: 1841,
              pid: 1828,
              name: "黄陂区",
            },
            {
              id: 1842,
              pid: 1828,
              name: "新洲区",
            },
          ],
        },
        {
          id: 1843,
          pid: 1827,
          name: "黄石市",
          children: [
            {
              id: 1845,
              pid: 1843,
              name: "黄石港区",
            },
            {
              id: 1846,
              pid: 1843,
              name: "西塞山区",
            },
            {
              id: 1847,
              pid: 1843,
              name: "下陆区",
            },
            {
              id: 1848,
              pid: 1843,
              name: "铁山区",
            },
            {
              id: 1849,
              pid: 1843,
              name: "阳新县",
            },
            {
              id: 1850,
              pid: 1843,
              name: "大冶市",
            },
          ],
        },
        {
          id: 1851,
          pid: 1827,
          name: "十堰市",
          children: [
            {
              id: 1853,
              pid: 1851,
              name: "茅箭区",
            },
            {
              id: 1854,
              pid: 1851,
              name: "张湾区",
            },
            {
              id: 1855,
              pid: 1851,
              name: "郧阳区",
            },
            {
              id: 1856,
              pid: 1851,
              name: "郧西县",
            },
            {
              id: 1857,
              pid: 1851,
              name: "竹山县",
            },
            {
              id: 1858,
              pid: 1851,
              name: "竹溪县",
            },
            {
              id: 1859,
              pid: 1851,
              name: "房县",
            },
            {
              id: 1860,
              pid: 1851,
              name: "丹江口市",
            },
          ],
        },
        {
          id: 1861,
          pid: 1827,
          name: "宜昌市",
          children: [
            {
              id: 1863,
              pid: 1861,
              name: "西陵区",
            },
            {
              id: 1864,
              pid: 1861,
              name: "伍家岗区",
            },
            {
              id: 1865,
              pid: 1861,
              name: "点军区",
            },
            {
              id: 1866,
              pid: 1861,
              name: "猇亭区",
            },
            {
              id: 1867,
              pid: 1861,
              name: "夷陵区",
            },
            {
              id: 1868,
              pid: 1861,
              name: "远安县",
            },
            {
              id: 1869,
              pid: 1861,
              name: "兴山县",
            },
            {
              id: 1870,
              pid: 1861,
              name: "秭归县",
            },
            {
              id: 1871,
              pid: 1861,
              name: "长阳土家族自治县",
            },
            {
              id: 1872,
              pid: 1861,
              name: "五峰土家族自治县",
            },
            {
              id: 1873,
              pid: 1861,
              name: "宜都市",
            },
            {
              id: 1874,
              pid: 1861,
              name: "当阳市",
            },
            {
              id: 1875,
              pid: 1861,
              name: "枝江市",
            },
          ],
        },
        {
          id: 1876,
          pid: 1827,
          name: "襄阳市",
          children: [
            {
              id: 1878,
              pid: 1876,
              name: "襄城区",
            },
            {
              id: 1879,
              pid: 1876,
              name: "樊城区",
            },
            {
              id: 1880,
              pid: 1876,
              name: "襄州区",
            },
            {
              id: 1881,
              pid: 1876,
              name: "南漳县",
            },
            {
              id: 1882,
              pid: 1876,
              name: "谷城县",
            },
            {
              id: 1883,
              pid: 1876,
              name: "保康县",
            },
            {
              id: 1884,
              pid: 1876,
              name: "老河口市",
            },
            {
              id: 1885,
              pid: 1876,
              name: "枣阳市",
            },
            {
              id: 1886,
              pid: 1876,
              name: "宜城市",
            },
          ],
        },
        {
          id: 1887,
          pid: 1827,
          name: "鄂州市",
          children: [
            {
              id: 1889,
              pid: 1887,
              name: "梁子湖区",
            },
            {
              id: 1890,
              pid: 1887,
              name: "华容区",
            },
            {
              id: 1891,
              pid: 1887,
              name: "鄂城区",
            },
          ],
        },
        {
          id: 1892,
          pid: 1827,
          name: "荆门市",
          children: [
            {
              id: 1894,
              pid: 1892,
              name: "东宝区",
            },
            {
              id: 1895,
              pid: 1892,
              name: "掇刀区",
            },
            {
              id: 1896,
              pid: 1892,
              name: "京山市",
            },
            {
              id: 1897,
              pid: 1892,
              name: "沙洋县",
            },
            {
              id: 1898,
              pid: 1892,
              name: "钟祥市",
            },
          ],
        },
        {
          id: 1899,
          pid: 1827,
          name: "孝感市",
          children: [
            {
              id: 1901,
              pid: 1899,
              name: "孝南区",
            },
            {
              id: 1902,
              pid: 1899,
              name: "孝昌县",
            },
            {
              id: 1903,
              pid: 1899,
              name: "大悟县",
            },
            {
              id: 1904,
              pid: 1899,
              name: "云梦县",
            },
            {
              id: 1905,
              pid: 1899,
              name: "应城市",
            },
            {
              id: 1906,
              pid: 1899,
              name: "安陆市",
            },
            {
              id: 1907,
              pid: 1899,
              name: "汉川市",
            },
          ],
        },
        {
          id: 1908,
          pid: 1827,
          name: "荆州市",
          children: [
            {
              id: 1910,
              pid: 1908,
              name: "沙市区",
            },
            {
              id: 1911,
              pid: 1908,
              name: "荆州区",
            },
            {
              id: 1912,
              pid: 1908,
              name: "公安县",
            },
            {
              id: 1913,
              pid: 1908,
              name: "监利市",
            },
            {
              id: 1914,
              pid: 1908,
              name: "江陵县",
            },
            {
              id: 1915,
              pid: 1908,
              name: "石首市",
            },
            {
              id: 1916,
              pid: 1908,
              name: "洪湖市",
            },
            {
              id: 1917,
              pid: 1908,
              name: "松滋市",
            },
          ],
        },
        {
          id: 1918,
          pid: 1827,
          name: "黄冈市",
          children: [
            {
              id: 1920,
              pid: 1918,
              name: "黄州区",
            },
            {
              id: 1921,
              pid: 1918,
              name: "团风县",
            },
            {
              id: 1922,
              pid: 1918,
              name: "红安县",
            },
            {
              id: 1923,
              pid: 1918,
              name: "罗田县",
            },
            {
              id: 1924,
              pid: 1918,
              name: "英山县",
            },
            {
              id: 1925,
              pid: 1918,
              name: "浠水县",
            },
            {
              id: 1926,
              pid: 1918,
              name: "蕲春县",
            },
            {
              id: 1927,
              pid: 1918,
              name: "黄梅县",
            },
            {
              id: 1928,
              pid: 1918,
              name: "麻城市",
            },
            {
              id: 1929,
              pid: 1918,
              name: "武穴市",
            },
          ],
        },
        {
          id: 1930,
          pid: 1827,
          name: "咸宁市",
          children: [
            {
              id: 1932,
              pid: 1930,
              name: "咸安区",
            },
            {
              id: 1933,
              pid: 1930,
              name: "嘉鱼县",
            },
            {
              id: 1934,
              pid: 1930,
              name: "通城县",
            },
            {
              id: 1935,
              pid: 1930,
              name: "崇阳县",
            },
            {
              id: 1936,
              pid: 1930,
              name: "通山县",
            },
            {
              id: 1937,
              pid: 1930,
              name: "赤壁市",
            },
          ],
        },
        {
          id: 1938,
          pid: 1827,
          name: "随州市",
          children: [
            {
              id: 1940,
              pid: 1938,
              name: "曾都区",
            },
            {
              id: 1941,
              pid: 1938,
              name: "随县",
            },
            {
              id: 1942,
              pid: 1938,
              name: "广水市",
            },
          ],
        },
        {
          id: 1943,
          pid: 1827,
          name: "恩施土家族苗族自治州",
          children: [
            {
              id: 1944,
              pid: 1943,
              name: "恩施市",
            },
            {
              id: 1945,
              pid: 1943,
              name: "利川市",
            },
            {
              id: 1946,
              pid: 1943,
              name: "建始县",
            },
            {
              id: 1947,
              pid: 1943,
              name: "巴东县",
            },
            {
              id: 1948,
              pid: 1943,
              name: "宣恩县",
            },
            {
              id: 1949,
              pid: 1943,
              name: "咸丰县",
            },
            {
              id: 1950,
              pid: 1943,
              name: "来凤县",
            },
            {
              id: 1951,
              pid: 1943,
              name: "鹤峰县",
            },
          ],
        },
        {
          id: 1952,
          pid: 1827,
          name: "仙桃市",
          children: [
            {
              id: 3525,
              pid: 1952,
              name: "郑场镇",
            },
            {
              id: 3526,
              pid: 1952,
              name: "毛嘴镇",
            },
            {
              id: 3527,
              pid: 1952,
              name: "三伏潭镇",
            },
            {
              id: 3528,
              pid: 1952,
              name: "胡场镇",
            },
            {
              id: 3529,
              pid: 1952,
              name: "西流河镇",
            },
            {
              id: 3530,
              pid: 1952,
              name: "沙湖镇",
            },
            {
              id: 3531,
              pid: 1952,
              name: "杨林尾镇",
            },
            {
              id: 3532,
              pid: 1952,
              name: "张沟镇",
            },
            {
              id: 3533,
              pid: 1952,
              name: "郭河镇",
            },
            {
              id: 3534,
              pid: 1952,
              name: "通海口镇",
            },
            {
              id: 3535,
              pid: 1952,
              name: "陈场镇",
            },
            {
              id: 3536,
              pid: 1952,
              name: "工业园区",
            },
            {
              id: 3537,
              pid: 1952,
              name: "沙湖原种场",
            },
            {
              id: 3538,
              pid: 1952,
              name: "排湖渔场",
            },
            {
              id: 3539,
              pid: 1952,
              name: "五湖渔场",
            },
            {
              id: 3540,
              pid: 1952,
              name: "刘家垸林场",
            },
            {
              id: 3541,
              pid: 1952,
              name: "畜禽良种场",
            },
            {
              id: 3542,
              pid: 1952,
              name: "豆河镇",
            },
            {
              id: 3543,
              pid: 1952,
              name: "长埫口镇",
            },
            {
              id: 3544,
              pid: 1952,
              name: "彭场镇",
            },
            {
              id: 3545,
              pid: 1952,
              name: "沔城镇",
            },
            {
              id: 3546,
              pid: 1952,
              name: "九合垸原种场",
            },
            {
              id: 3547,
              pid: 1952,
              name: "赵西垸林场",
            },
          ],
        },
        {
          id: 1953,
          pid: 1827,
          name: "潜江市",
          children: [
            {
              id: 3548,
              pid: 1953,
              name: "园林",
            },
            {
              id: 3549,
              pid: 1953,
              name: "周矶",
            },
            {
              id: 3550,
              pid: 1953,
              name: "广华",
            },
            {
              id: 3551,
              pid: 1953,
              name: "高石碑镇",
            },
            {
              id: 3552,
              pid: 1953,
              name: "积玉口镇",
            },
            {
              id: 3553,
              pid: 1953,
              name: "熊口镇",
            },
            {
              id: 3554,
              pid: 1953,
              name: "浩口镇",
            },
            {
              id: 3555,
              pid: 1953,
              name: "张金镇",
            },
            {
              id: 3556,
              pid: 1953,
              name: "西大垸管理区",
            },
            {
              id: 3557,
              pid: 1953,
              name: "后湖管理区",
            },
            {
              id: 3558,
              pid: 1953,
              name: "熊口管理区",
            },
            {
              id: 3559,
              pid: 1953,
              name: "总口管理区",
            },
            {
              id: 3560,
              pid: 1953,
              name: "杨市",
            },
            {
              id: 3561,
              pid: 1953,
              name: "泰丰",
            },
            {
              id: 3562,
              pid: 1953,
              name: "渔洋镇",
            },
            {
              id: 3563,
              pid: 1953,
              name: "老新镇",
            },
            {
              id: 3564,
              pid: 1953,
              name: "江汉石油管理局",
            },
            {
              id: 3565,
              pid: 1953,
              name: "周矶管理区",
            },
            {
              id: 3566,
              pid: 1953,
              name: "高场原种场",
            },
            {
              id: 3567,
              pid: 1953,
              name: "竹根滩镇",
            },
            {
              id: 3568,
              pid: 1953,
              name: "王场镇",
            },
            {
              id: 3569,
              pid: 1953,
              name: "龙湾镇",
            },
            {
              id: 3570,
              pid: 1953,
              name: "运粮湖管理区",
            },
            {
              id: 3571,
              pid: 1953,
              name: "浩口原种场",
            },
            {
              id: 3572,
              pid: 1953,
              name: "潜江经济开发区",
            },
          ],
        },
        {
          id: 1954,
          pid: 1827,
          name: "天门市",
          children: [
            {
              id: 3573,
              pid: 1954,
              name: "竟陵街道",
            },
            {
              id: 3574,
              pid: 1954,
              name: "杨林街道",
            },
            {
              id: 3575,
              pid: 1954,
              name: "多宝镇",
            },
            {
              id: 3576,
              pid: 1954,
              name: "拖市镇",
            },
            {
              id: 3577,
              pid: 1954,
              name: "蒋场镇",
            },
            {
              id: 3578,
              pid: 1954,
              name: "汪场镇",
            },
            {
              id: 3579,
              pid: 1954,
              name: "渔薪镇",
            },
            {
              id: 3580,
              pid: 1954,
              name: "岳口镇",
            },
            {
              id: 3581,
              pid: 1954,
              name: "横林镇",
            },
            {
              id: 3582,
              pid: 1954,
              name: "麻洋镇",
            },
            {
              id: 3583,
              pid: 1954,
              name: "多祥镇",
            },
            {
              id: 3584,
              pid: 1954,
              name: "干驿镇",
            },
            {
              id: 3585,
              pid: 1954,
              name: "卢市镇",
            },
            {
              id: 3586,
              pid: 1954,
              name: "小板镇",
            },
            {
              id: 3587,
              pid: 1954,
              name: "皂市镇",
            },
            {
              id: 3588,
              pid: 1954,
              name: "胡市镇",
            },
            {
              id: 3589,
              pid: 1954,
              name: "石河镇",
            },
            {
              id: 3590,
              pid: 1954,
              name: "蒋湖农场",
            },
            {
              id: 3591,
              pid: 1954,
              name: "白茅湖农场",
            },
            {
              id: 3592,
              pid: 1954,
              name: "侨乡街道开发区",
            },
            {
              id: 3593,
              pid: 1954,
              name: "佛子山镇",
            },
            {
              id: 3594,
              pid: 1954,
              name: "张港镇",
            },
            {
              id: 3595,
              pid: 1954,
              name: "黄潭镇",
            },
            {
              id: 3596,
              pid: 1954,
              name: "彭市镇",
            },
            {
              id: 3597,
              pid: 1954,
              name: "马湾镇",
            },
            {
              id: 3598,
              pid: 1954,
              name: "九真镇",
            },
            {
              id: 3599,
              pid: 1954,
              name: "净潭乡",
            },
            {
              id: 3600,
              pid: 1954,
              name: "沉湖管委会",
            },
          ],
        },
        {
          id: 1955,
          pid: 1827,
          name: "神农架林区",
          children: [
            {
              id: 3601,
              pid: 1955,
              name: "松柏镇",
            },
            {
              id: 3602,
              pid: 1955,
              name: "木鱼镇",
            },
            {
              id: 3603,
              pid: 1955,
              name: "红坪镇",
            },
            {
              id: 3604,
              pid: 1955,
              name: "新华镇",
            },
            {
              id: 3605,
              pid: 1955,
              name: "九湖乡",
            },
            {
              id: 3606,
              pid: 1955,
              name: "下谷坪乡",
            },
            {
              id: 3607,
              pid: 1955,
              name: "阳日镇",
            },
            {
              id: 3608,
              pid: 1955,
              name: "宋洛乡",
            },
          ],
        },
      ],
    },
    {
      id: 1956,
      pid: 1,
      name: "湖南省",
      children: [
        {
          id: 1957,
          pid: 1956,
          name: "长沙市",
          children: [
            {
              id: 1959,
              pid: 1957,
              name: "芙蓉区",
            },
            {
              id: 1960,
              pid: 1957,
              name: "天心区",
            },
            {
              id: 1961,
              pid: 1957,
              name: "岳麓区",
            },
            {
              id: 1962,
              pid: 1957,
              name: "开福区",
            },
            {
              id: 1963,
              pid: 1957,
              name: "雨花区",
            },
            {
              id: 1964,
              pid: 1957,
              name: "望城区",
            },
            {
              id: 1965,
              pid: 1957,
              name: "长沙县",
            },
            {
              id: 1966,
              pid: 1957,
              name: "浏阳市",
            },
            {
              id: 1967,
              pid: 1957,
              name: "宁乡市",
            },
          ],
        },
        {
          id: 1968,
          pid: 1956,
          name: "株洲市",
          children: [
            {
              id: 1970,
              pid: 1968,
              name: "荷塘区",
            },
            {
              id: 1971,
              pid: 1968,
              name: "芦淞区",
            },
            {
              id: 1972,
              pid: 1968,
              name: "石峰区",
            },
            {
              id: 1973,
              pid: 1968,
              name: "天元区",
            },
            {
              id: 1974,
              pid: 1968,
              name: "渌口区",
            },
            {
              id: 1975,
              pid: 1968,
              name: "攸县",
            },
            {
              id: 1976,
              pid: 1968,
              name: "茶陵县",
            },
            {
              id: 1977,
              pid: 1968,
              name: "炎陵县",
            },
            {
              id: 1978,
              pid: 1968,
              name: "醴陵市",
            },
          ],
        },
        {
          id: 1979,
          pid: 1956,
          name: "湘潭市",
          children: [
            {
              id: 1981,
              pid: 1979,
              name: "雨湖区",
            },
            {
              id: 1982,
              pid: 1979,
              name: "岳塘区",
            },
            {
              id: 1983,
              pid: 1979,
              name: "湘潭县",
            },
            {
              id: 1984,
              pid: 1979,
              name: "湘乡市",
            },
            {
              id: 1985,
              pid: 1979,
              name: "韶山市",
            },
          ],
        },
        {
          id: 1986,
          pid: 1956,
          name: "衡阳市",
          children: [
            {
              id: 1988,
              pid: 1986,
              name: "珠晖区",
            },
            {
              id: 1989,
              pid: 1986,
              name: "雁峰区",
            },
            {
              id: 1990,
              pid: 1986,
              name: "石鼓区",
            },
            {
              id: 1991,
              pid: 1986,
              name: "蒸湘区",
            },
            {
              id: 1992,
              pid: 1986,
              name: "南岳区",
            },
            {
              id: 1993,
              pid: 1986,
              name: "衡阳县",
            },
            {
              id: 1994,
              pid: 1986,
              name: "衡南县",
            },
            {
              id: 1995,
              pid: 1986,
              name: "衡山县",
            },
            {
              id: 1996,
              pid: 1986,
              name: "衡东县",
            },
            {
              id: 1997,
              pid: 1986,
              name: "祁东县",
            },
            {
              id: 1998,
              pid: 1986,
              name: "耒阳市",
            },
            {
              id: 1999,
              pid: 1986,
              name: "常宁市",
            },
          ],
        },
        {
          id: 2e3,
          pid: 1956,
          name: "邵阳市",
          children: [
            {
              id: 2002,
              pid: 2e3,
              name: "双清区",
            },
            {
              id: 2003,
              pid: 2e3,
              name: "大祥区",
            },
            {
              id: 2004,
              pid: 2e3,
              name: "北塔区",
            },
            {
              id: 2005,
              pid: 2e3,
              name: "邵东市",
            },
            {
              id: 2006,
              pid: 2e3,
              name: "新邵县",
            },
            {
              id: 2007,
              pid: 2e3,
              name: "邵阳县",
            },
            {
              id: 2008,
              pid: 2e3,
              name: "隆回县",
            },
            {
              id: 2009,
              pid: 2e3,
              name: "洞口县",
            },
            {
              id: 2010,
              pid: 2e3,
              name: "绥宁县",
            },
            {
              id: 2011,
              pid: 2e3,
              name: "新宁县",
            },
            {
              id: 2012,
              pid: 2e3,
              name: "城步苗族自治县",
            },
            {
              id: 2013,
              pid: 2e3,
              name: "武冈市",
            },
          ],
        },
        {
          id: 2014,
          pid: 1956,
          name: "岳阳市",
          children: [
            {
              id: 2016,
              pid: 2014,
              name: "岳阳楼区",
            },
            {
              id: 2017,
              pid: 2014,
              name: "云溪区",
            },
            {
              id: 2018,
              pid: 2014,
              name: "君山区",
            },
            {
              id: 2019,
              pid: 2014,
              name: "岳阳县",
            },
            {
              id: 2020,
              pid: 2014,
              name: "华容县",
            },
            {
              id: 2021,
              pid: 2014,
              name: "湘阴县",
            },
            {
              id: 2022,
              pid: 2014,
              name: "平江县",
            },
            {
              id: 2023,
              pid: 2014,
              name: "汨罗市",
            },
            {
              id: 2024,
              pid: 2014,
              name: "临湘市",
            },
          ],
        },
        {
          id: 2025,
          pid: 1956,
          name: "常德市",
          children: [
            {
              id: 2027,
              pid: 2025,
              name: "武陵区",
            },
            {
              id: 2028,
              pid: 2025,
              name: "鼎城区",
            },
            {
              id: 2029,
              pid: 2025,
              name: "安乡县",
            },
            {
              id: 2030,
              pid: 2025,
              name: "汉寿县",
            },
            {
              id: 2031,
              pid: 2025,
              name: "澧县",
            },
            {
              id: 2032,
              pid: 2025,
              name: "临澧县",
            },
            {
              id: 2033,
              pid: 2025,
              name: "桃源县",
            },
            {
              id: 2034,
              pid: 2025,
              name: "石门县",
            },
            {
              id: 2035,
              pid: 2025,
              name: "津市市",
            },
          ],
        },
        {
          id: 2036,
          pid: 1956,
          name: "张家界市",
          children: [
            {
              id: 2038,
              pid: 2036,
              name: "永定区",
            },
            {
              id: 2039,
              pid: 2036,
              name: "武陵源区",
            },
            {
              id: 2040,
              pid: 2036,
              name: "慈利县",
            },
            {
              id: 2041,
              pid: 2036,
              name: "桑植县",
            },
          ],
        },
        {
          id: 2042,
          pid: 1956,
          name: "益阳市",
          children: [
            {
              id: 2044,
              pid: 2042,
              name: "资阳区",
            },
            {
              id: 2045,
              pid: 2042,
              name: "赫山区",
            },
            {
              id: 2046,
              pid: 2042,
              name: "南县",
            },
            {
              id: 2047,
              pid: 2042,
              name: "桃江县",
            },
            {
              id: 2048,
              pid: 2042,
              name: "安化县",
            },
            {
              id: 2049,
              pid: 2042,
              name: "沅江市",
            },
          ],
        },
        {
          id: 2050,
          pid: 1956,
          name: "郴州市",
          children: [
            {
              id: 2052,
              pid: 2050,
              name: "北湖区",
            },
            {
              id: 2053,
              pid: 2050,
              name: "苏仙区",
            },
            {
              id: 2054,
              pid: 2050,
              name: "桂阳县",
            },
            {
              id: 2055,
              pid: 2050,
              name: "宜章县",
            },
            {
              id: 2056,
              pid: 2050,
              name: "永兴县",
            },
            {
              id: 2057,
              pid: 2050,
              name: "嘉禾县",
            },
            {
              id: 2058,
              pid: 2050,
              name: "临武县",
            },
            {
              id: 2059,
              pid: 2050,
              name: "汝城县",
            },
            {
              id: 2060,
              pid: 2050,
              name: "桂东县",
            },
            {
              id: 2061,
              pid: 2050,
              name: "安仁县",
            },
            {
              id: 2062,
              pid: 2050,
              name: "资兴市",
            },
          ],
        },
        {
          id: 2063,
          pid: 1956,
          name: "永州市",
          children: [
            {
              id: 2065,
              pid: 2063,
              name: "零陵区",
            },
            {
              id: 2066,
              pid: 2063,
              name: "冷水滩区",
            },
            {
              id: 2067,
              pid: 2063,
              name: "祁阳市",
            },
            {
              id: 2068,
              pid: 2063,
              name: "东安县",
            },
            {
              id: 2069,
              pid: 2063,
              name: "双牌县",
            },
            {
              id: 2070,
              pid: 2063,
              name: "道县",
            },
            {
              id: 2071,
              pid: 2063,
              name: "江永县",
            },
            {
              id: 2072,
              pid: 2063,
              name: "宁远县",
            },
            {
              id: 2073,
              pid: 2063,
              name: "蓝山县",
            },
            {
              id: 2074,
              pid: 2063,
              name: "新田县",
            },
            {
              id: 2075,
              pid: 2063,
              name: "江华瑶族自治县",
            },
          ],
        },
        {
          id: 2076,
          pid: 1956,
          name: "怀化市",
          children: [
            {
              id: 2078,
              pid: 2076,
              name: "鹤城区",
            },
            {
              id: 2079,
              pid: 2076,
              name: "中方县",
            },
            {
              id: 2080,
              pid: 2076,
              name: "沅陵县",
            },
            {
              id: 2081,
              pid: 2076,
              name: "辰溪县",
            },
            {
              id: 2082,
              pid: 2076,
              name: "溆浦县",
            },
            {
              id: 2083,
              pid: 2076,
              name: "会同县",
            },
            {
              id: 2084,
              pid: 2076,
              name: "麻阳苗族自治县",
            },
            {
              id: 2085,
              pid: 2076,
              name: "新晃侗族自治县",
            },
            {
              id: 2086,
              pid: 2076,
              name: "芷江侗族自治县",
            },
            {
              id: 2087,
              pid: 2076,
              name: "靖州苗族侗族自治县",
            },
            {
              id: 2088,
              pid: 2076,
              name: "通道侗族自治县",
            },
            {
              id: 2089,
              pid: 2076,
              name: "洪江市",
            },
          ],
        },
        {
          id: 2090,
          pid: 1956,
          name: "娄底市",
          children: [
            {
              id: 2092,
              pid: 2090,
              name: "娄星区",
            },
            {
              id: 2093,
              pid: 2090,
              name: "双峰县",
            },
            {
              id: 2094,
              pid: 2090,
              name: "新化县",
            },
            {
              id: 2095,
              pid: 2090,
              name: "冷水江市",
            },
            {
              id: 2096,
              pid: 2090,
              name: "涟源市",
            },
          ],
        },
        {
          id: 2097,
          pid: 1956,
          name: "湘西土家族苗族自治州",
          children: [
            {
              id: 2098,
              pid: 2097,
              name: "吉首市",
            },
            {
              id: 2099,
              pid: 2097,
              name: "泸溪县",
            },
            {
              id: 2100,
              pid: 2097,
              name: "凤凰县",
            },
            {
              id: 2101,
              pid: 2097,
              name: "花垣县",
            },
            {
              id: 2102,
              pid: 2097,
              name: "保靖县",
            },
            {
              id: 2103,
              pid: 2097,
              name: "古丈县",
            },
            {
              id: 2104,
              pid: 2097,
              name: "永顺县",
            },
            {
              id: 2105,
              pid: 2097,
              name: "龙山县",
            },
          ],
        },
      ],
    },
    {
      id: 2106,
      pid: 1,
      name: "广东省",
      children: [
        {
          id: 2107,
          pid: 2106,
          name: "广州市",
          children: [
            {
              id: 2109,
              pid: 2107,
              name: "荔湾区",
            },
            {
              id: 2110,
              pid: 2107,
              name: "越秀区",
            },
            {
              id: 2111,
              pid: 2107,
              name: "海珠区",
            },
            {
              id: 2112,
              pid: 2107,
              name: "天河区",
            },
            {
              id: 2113,
              pid: 2107,
              name: "白云区",
            },
            {
              id: 2114,
              pid: 2107,
              name: "黄埔区",
            },
            {
              id: 2115,
              pid: 2107,
              name: "番禺区",
            },
            {
              id: 2116,
              pid: 2107,
              name: "花都区",
            },
            {
              id: 2117,
              pid: 2107,
              name: "南沙区",
            },
            {
              id: 2118,
              pid: 2107,
              name: "从化区",
            },
            {
              id: 2119,
              pid: 2107,
              name: "增城区",
            },
          ],
        },
        {
          id: 2120,
          pid: 2106,
          name: "韶关市",
          children: [
            {
              id: 2122,
              pid: 2120,
              name: "武江区",
            },
            {
              id: 2123,
              pid: 2120,
              name: "浈江区",
            },
            {
              id: 2124,
              pid: 2120,
              name: "曲江区",
            },
            {
              id: 2125,
              pid: 2120,
              name: "始兴县",
            },
            {
              id: 2126,
              pid: 2120,
              name: "仁化县",
            },
            {
              id: 2127,
              pid: 2120,
              name: "翁源县",
            },
            {
              id: 2128,
              pid: 2120,
              name: "乳源瑶族自治县",
            },
            {
              id: 2129,
              pid: 2120,
              name: "新丰县",
            },
            {
              id: 2130,
              pid: 2120,
              name: "乐昌市",
            },
            {
              id: 2131,
              pid: 2120,
              name: "南雄市",
            },
          ],
        },
        {
          id: 2132,
          pid: 2106,
          name: "深圳市",
          children: [
            {
              id: 2134,
              pid: 2132,
              name: "罗湖区",
            },
            {
              id: 2135,
              pid: 2132,
              name: "福田区",
            },
            {
              id: 2136,
              pid: 2132,
              name: "南山区",
            },
            {
              id: 2137,
              pid: 2132,
              name: "宝安区",
            },
            {
              id: 2138,
              pid: 2132,
              name: "龙岗区",
            },
            {
              id: 2139,
              pid: 2132,
              name: "盐田区",
            },
            {
              id: 2140,
              pid: 2132,
              name: "龙华区",
            },
            {
              id: 2141,
              pid: 2132,
              name: "坪山区",
            },
            {
              id: 2142,
              pid: 2132,
              name: "光明区",
            },
          ],
        },
        {
          id: 2143,
          pid: 2106,
          name: "珠海市",
          children: [
            {
              id: 2145,
              pid: 2143,
              name: "香洲区",
            },
            {
              id: 2146,
              pid: 2143,
              name: "斗门区",
            },
            {
              id: 2147,
              pid: 2143,
              name: "金湾区",
            },
          ],
        },
        {
          id: 2148,
          pid: 2106,
          name: "汕头市",
          children: [
            {
              id: 2150,
              pid: 2148,
              name: "龙湖区",
            },
            {
              id: 2151,
              pid: 2148,
              name: "金平区",
            },
            {
              id: 2152,
              pid: 2148,
              name: "濠江区",
            },
            {
              id: 2153,
              pid: 2148,
              name: "潮阳区",
            },
            {
              id: 2154,
              pid: 2148,
              name: "潮南区",
            },
            {
              id: 2155,
              pid: 2148,
              name: "澄海区",
            },
            {
              id: 2156,
              pid: 2148,
              name: "南澳县",
            },
          ],
        },
        {
          id: 2157,
          pid: 2106,
          name: "佛山市",
          children: [
            {
              id: 2159,
              pid: 2157,
              name: "禅城区",
            },
            {
              id: 2160,
              pid: 2157,
              name: "南海区",
            },
            {
              id: 2161,
              pid: 2157,
              name: "顺德区",
            },
            {
              id: 2162,
              pid: 2157,
              name: "三水区",
            },
            {
              id: 2163,
              pid: 2157,
              name: "高明区",
            },
          ],
        },
        {
          id: 2164,
          pid: 2106,
          name: "江门市",
          children: [
            {
              id: 2166,
              pid: 2164,
              name: "蓬江区",
            },
            {
              id: 2167,
              pid: 2164,
              name: "江海区",
            },
            {
              id: 2168,
              pid: 2164,
              name: "新会区",
            },
            {
              id: 2169,
              pid: 2164,
              name: "台山市",
            },
            {
              id: 2170,
              pid: 2164,
              name: "开平市",
            },
            {
              id: 2171,
              pid: 2164,
              name: "鹤山市",
            },
            {
              id: 2172,
              pid: 2164,
              name: "恩平市",
            },
          ],
        },
        {
          id: 2173,
          pid: 2106,
          name: "湛江市",
          children: [
            {
              id: 2175,
              pid: 2173,
              name: "赤坎区",
            },
            {
              id: 2176,
              pid: 2173,
              name: "霞山区",
            },
            {
              id: 2177,
              pid: 2173,
              name: "坡头区",
            },
            {
              id: 2178,
              pid: 2173,
              name: "麻章区",
            },
            {
              id: 2179,
              pid: 2173,
              name: "遂溪县",
            },
            {
              id: 2180,
              pid: 2173,
              name: "徐闻县",
            },
            {
              id: 2181,
              pid: 2173,
              name: "廉江市",
            },
            {
              id: 2182,
              pid: 2173,
              name: "雷州市",
            },
            {
              id: 2183,
              pid: 2173,
              name: "吴川市",
            },
          ],
        },
        {
          id: 2184,
          pid: 2106,
          name: "茂名市",
          children: [
            {
              id: 2186,
              pid: 2184,
              name: "茂南区",
            },
            {
              id: 2187,
              pid: 2184,
              name: "电白区",
            },
            {
              id: 2188,
              pid: 2184,
              name: "高州市",
            },
            {
              id: 2189,
              pid: 2184,
              name: "化州市",
            },
            {
              id: 2190,
              pid: 2184,
              name: "信宜市",
            },
          ],
        },
        {
          id: 2191,
          pid: 2106,
          name: "肇庆市",
          children: [
            {
              id: 2193,
              pid: 2191,
              name: "端州区",
            },
            {
              id: 2194,
              pid: 2191,
              name: "鼎湖区",
            },
            {
              id: 2195,
              pid: 2191,
              name: "高要区",
            },
            {
              id: 2196,
              pid: 2191,
              name: "广宁县",
            },
            {
              id: 2197,
              pid: 2191,
              name: "怀集县",
            },
            {
              id: 2198,
              pid: 2191,
              name: "封开县",
            },
            {
              id: 2199,
              pid: 2191,
              name: "德庆县",
            },
            {
              id: 2200,
              pid: 2191,
              name: "四会市",
            },
          ],
        },
        {
          id: 2201,
          pid: 2106,
          name: "惠州市",
          children: [
            {
              id: 2203,
              pid: 2201,
              name: "惠城区",
            },
            {
              id: 2204,
              pid: 2201,
              name: "惠阳区",
            },
            {
              id: 2205,
              pid: 2201,
              name: "博罗县",
            },
            {
              id: 2206,
              pid: 2201,
              name: "惠东县",
            },
            {
              id: 2207,
              pid: 2201,
              name: "龙门县",
            },
          ],
        },
        {
          id: 2208,
          pid: 2106,
          name: "梅州市",
          children: [
            {
              id: 2210,
              pid: 2208,
              name: "梅江区",
            },
            {
              id: 2211,
              pid: 2208,
              name: "梅县区",
            },
            {
              id: 2212,
              pid: 2208,
              name: "大埔县",
            },
            {
              id: 2213,
              pid: 2208,
              name: "丰顺县",
            },
            {
              id: 2214,
              pid: 2208,
              name: "五华县",
            },
            {
              id: 2215,
              pid: 2208,
              name: "平远县",
            },
            {
              id: 2216,
              pid: 2208,
              name: "蕉岭县",
            },
            {
              id: 2217,
              pid: 2208,
              name: "兴宁市",
            },
          ],
        },
        {
          id: 2218,
          pid: 2106,
          name: "汕尾市",
          children: [
            {
              id: 2220,
              pid: 2218,
              name: "城区",
            },
            {
              id: 2221,
              pid: 2218,
              name: "海丰县",
            },
            {
              id: 2222,
              pid: 2218,
              name: "陆河县",
            },
            {
              id: 2223,
              pid: 2218,
              name: "陆丰市",
            },
          ],
        },
        {
          id: 2224,
          pid: 2106,
          name: "河源市",
          children: [
            {
              id: 2226,
              pid: 2224,
              name: "源城区",
            },
            {
              id: 2227,
              pid: 2224,
              name: "紫金县",
            },
            {
              id: 2228,
              pid: 2224,
              name: "龙川县",
            },
            {
              id: 2229,
              pid: 2224,
              name: "连平县",
            },
            {
              id: 2230,
              pid: 2224,
              name: "和平县",
            },
            {
              id: 2231,
              pid: 2224,
              name: "东源县",
            },
          ],
        },
        {
          id: 2232,
          pid: 2106,
          name: "阳江市",
          children: [
            {
              id: 2234,
              pid: 2232,
              name: "江城区",
            },
            {
              id: 2235,
              pid: 2232,
              name: "阳东区",
            },
            {
              id: 2236,
              pid: 2232,
              name: "阳西县",
            },
            {
              id: 2237,
              pid: 2232,
              name: "阳春市",
            },
          ],
        },
        {
          id: 2238,
          pid: 2106,
          name: "清远市",
          children: [
            {
              id: 2240,
              pid: 2238,
              name: "清城区",
            },
            {
              id: 2241,
              pid: 2238,
              name: "清新区",
            },
            {
              id: 2242,
              pid: 2238,
              name: "佛冈县",
            },
            {
              id: 2243,
              pid: 2238,
              name: "阳山县",
            },
            {
              id: 2244,
              pid: 2238,
              name: "连山壮族瑶族自治县",
            },
            {
              id: 2245,
              pid: 2238,
              name: "连南瑶族自治县",
            },
            {
              id: 2246,
              pid: 2238,
              name: "英德市",
            },
            {
              id: 2247,
              pid: 2238,
              name: "连州市",
            },
          ],
        },
        {
          id: 2248,
          pid: 2106,
          name: "东莞市",
          children: [
            {
              id: 3610,
              pid: 2248,
              name: "莞城区",
            },
            {
              id: 3611,
              pid: 2248,
              name: "南城区",
            },
            {
              id: 3612,
              pid: 2248,
              name: "横沥镇",
            },
            {
              id: 3613,
              pid: 2248,
              name: "厚街镇",
            },
            {
              id: 3614,
              pid: 2248,
              name: "万江区",
            },
            {
              id: 3615,
              pid: 2248,
              name: "凤岗镇",
            },
            {
              id: 3616,
              pid: 2248,
              name: "大朗镇",
            },
            {
              id: 3617,
              pid: 2248,
              name: "企石镇",
            },
            {
              id: 3618,
              pid: 2248,
              name: "茶山镇",
            },
            {
              id: 3619,
              pid: 2248,
              name: "虎门镇",
            },
            {
              id: 3620,
              pid: 2248,
              name: "道滘镇",
            },
            {
              id: 3621,
              pid: 2248,
              name: "沙田镇",
            },
            {
              id: 3622,
              pid: 2248,
              name: "石碣镇",
            },
            {
              id: 3623,
              pid: 2248,
              name: "洪梅镇",
            },
            {
              id: 3624,
              pid: 2248,
              name: "松山湖",
            },
            {
              id: 3625,
              pid: 2248,
              name: "中堂镇",
            },
            {
              id: 3626,
              pid: 2248,
              name: "谢岗镇",
            },
            {
              id: 3627,
              pid: 2248,
              name: "寮步镇",
            },
            {
              id: 3628,
              pid: 2248,
              name: "常平镇",
            },
            {
              id: 3629,
              pid: 2248,
              name: "塘厦镇",
            },
            {
              id: 3630,
              pid: 2248,
              name: "东城区",
            },
            {
              id: 3631,
              pid: 2248,
              name: "石排镇",
            },
            {
              id: 3632,
              pid: 2248,
              name: "石龙镇",
            },
            {
              id: 3633,
              pid: 2248,
              name: "望牛墩镇",
            },
            {
              id: 3634,
              pid: 2248,
              name: "长安镇",
            },
            {
              id: 3635,
              pid: 2248,
              name: "大岭山镇",
            },
            {
              id: 3636,
              pid: 2248,
              name: "樟木头镇",
            },
            {
              id: 3637,
              pid: 2248,
              name: "清溪镇",
            },
            {
              id: 3638,
              pid: 2248,
              name: "黄江镇",
            },
            {
              id: 3639,
              pid: 2248,
              name: "高埗镇",
            },
            {
              id: 3640,
              pid: 2248,
              name: "桥头镇",
            },
            {
              id: 3641,
              pid: 2248,
              name: "东坑镇",
            },
            {
              id: 3642,
              pid: 2248,
              name: "麻涌镇",
            },
          ],
        },
        {
          id: 2249,
          pid: 2106,
          name: "中山市",
          children: [
            {
              id: 3644,
              pid: 2249,
              name: "小榄镇",
            },
            {
              id: 3645,
              pid: 2249,
              name: "古镇",
            },
            {
              id: 3646,
              pid: 2249,
              name: "东凤镇",
            },
            {
              id: 3647,
              pid: 2249,
              name: "板芙镇",
            },
            {
              id: 3648,
              pid: 2249,
              name: "横栏镇",
            },
            {
              id: 3649,
              pid: 2249,
              name: "三角镇",
            },
            {
              id: 3650,
              pid: 2249,
              name: "南头镇",
            },
            {
              id: 3651,
              pid: 2249,
              name: "黄圃镇",
            },
            {
              id: 3652,
              pid: 2249,
              name: "五桂山镇",
            },
            {
              id: 3653,
              pid: 2249,
              name: "南朗镇",
            },
            {
              id: 3654,
              pid: 2249,
              name: "沙朗镇",
            },
            {
              id: 3655,
              pid: 2249,
              name: "东升镇",
            },
            {
              id: 3656,
              pid: 2249,
              name: "火炬开发区",
            },
            {
              id: 3657,
              pid: 2249,
              name: "民众镇",
            },
            {
              id: 3658,
              pid: 2249,
              name: "大涌镇",
            },
            {
              id: 3659,
              pid: 2249,
              name: "坦洲镇",
            },
            {
              id: 3660,
              pid: 2249,
              name: "三乡镇",
            },
            {
              id: 3661,
              pid: 2249,
              name: "港口镇",
            },
            {
              id: 3662,
              pid: 2249,
              name: "沙溪镇",
            },
            {
              id: 3663,
              pid: 2249,
              name: "阜沙镇",
            },
            {
              id: 3664,
              pid: 2249,
              name: "神湾镇",
            },
            {
              id: 3929,
              pid: 2249,
              name: "石岐区街道",
            },
            {
              id: 3930,
              pid: 2249,
              name: "东区街道",
            },
            {
              id: 3931,
              pid: 2249,
              name: "西区街道",
            },
            {
              id: 3932,
              pid: 2249,
              name: "南区街道",
            },
          ],
        },
        {
          id: 2251,
          pid: 2106,
          name: "潮州市",
          children: [
            {
              id: 2253,
              pid: 2251,
              name: "湘桥区",
            },
            {
              id: 2254,
              pid: 2251,
              name: "潮安区",
            },
            {
              id: 2255,
              pid: 2251,
              name: "饶平县",
            },
          ],
        },
        {
          id: 2256,
          pid: 2106,
          name: "揭阳市",
          children: [
            {
              id: 2258,
              pid: 2256,
              name: "榕城区",
            },
            {
              id: 2259,
              pid: 2256,
              name: "揭东区",
            },
            {
              id: 2260,
              pid: 2256,
              name: "揭西县",
            },
            {
              id: 2261,
              pid: 2256,
              name: "惠来县",
            },
            {
              id: 2262,
              pid: 2256,
              name: "普宁市",
            },
          ],
        },
        {
          id: 2263,
          pid: 2106,
          name: "云浮市",
          children: [
            {
              id: 2265,
              pid: 2263,
              name: "云城区",
            },
            {
              id: 2266,
              pid: 2263,
              name: "云安区",
            },
            {
              id: 2267,
              pid: 2263,
              name: "新兴县",
            },
            {
              id: 2268,
              pid: 2263,
              name: "郁南县",
            },
            {
              id: 2269,
              pid: 2263,
              name: "罗定市",
            },
          ],
        },
      ],
    },
    {
      id: 2270,
      pid: 1,
      name: "广西壮族自治区",
      children: [
        {
          id: 2271,
          pid: 2270,
          name: "南宁市",
          children: [
            {
              id: 2273,
              pid: 2271,
              name: "兴宁区",
            },
            {
              id: 2274,
              pid: 2271,
              name: "青秀区",
            },
            {
              id: 2275,
              pid: 2271,
              name: "江南区",
            },
            {
              id: 2276,
              pid: 2271,
              name: "西乡塘区",
            },
            {
              id: 2277,
              pid: 2271,
              name: "良庆区",
            },
            {
              id: 2278,
              pid: 2271,
              name: "邕宁区",
            },
            {
              id: 2279,
              pid: 2271,
              name: "武鸣区",
            },
            {
              id: 2280,
              pid: 2271,
              name: "隆安县",
            },
            {
              id: 2281,
              pid: 2271,
              name: "马山县",
            },
            {
              id: 2282,
              pid: 2271,
              name: "上林县",
            },
            {
              id: 2283,
              pid: 2271,
              name: "宾阳县",
            },
            {
              id: 2284,
              pid: 2271,
              name: "横县",
            },
          ],
        },
        {
          id: 2285,
          pid: 2270,
          name: "柳州市",
          children: [
            {
              id: 2287,
              pid: 2285,
              name: "城中区",
            },
            {
              id: 2288,
              pid: 2285,
              name: "鱼峰区",
            },
            {
              id: 2289,
              pid: 2285,
              name: "柳南区",
            },
            {
              id: 2290,
              pid: 2285,
              name: "柳北区",
            },
            {
              id: 2291,
              pid: 2285,
              name: "柳江区",
            },
            {
              id: 2292,
              pid: 2285,
              name: "柳城县",
            },
            {
              id: 2293,
              pid: 2285,
              name: "鹿寨县",
            },
            {
              id: 2294,
              pid: 2285,
              name: "融安县",
            },
            {
              id: 2295,
              pid: 2285,
              name: "融水苗族自治县",
            },
            {
              id: 2296,
              pid: 2285,
              name: "三江侗族自治县",
            },
          ],
        },
        {
          id: 2297,
          pid: 2270,
          name: "桂林市",
          children: [
            {
              id: 2299,
              pid: 2297,
              name: "秀峰区",
            },
            {
              id: 2300,
              pid: 2297,
              name: "叠彩区",
            },
            {
              id: 2301,
              pid: 2297,
              name: "象山区",
            },
            {
              id: 2302,
              pid: 2297,
              name: "七星区",
            },
            {
              id: 2303,
              pid: 2297,
              name: "雁山区",
            },
            {
              id: 2304,
              pid: 2297,
              name: "临桂区",
            },
            {
              id: 2305,
              pid: 2297,
              name: "阳朔县",
            },
            {
              id: 2306,
              pid: 2297,
              name: "灵川县",
            },
            {
              id: 2307,
              pid: 2297,
              name: "全州县",
            },
            {
              id: 2308,
              pid: 2297,
              name: "兴安县",
            },
            {
              id: 2309,
              pid: 2297,
              name: "永福县",
            },
            {
              id: 2310,
              pid: 2297,
              name: "灌阳县",
            },
            {
              id: 2311,
              pid: 2297,
              name: "龙胜各族自治县",
            },
            {
              id: 2312,
              pid: 2297,
              name: "资源县",
            },
            {
              id: 2313,
              pid: 2297,
              name: "平乐县",
            },
            {
              id: 2314,
              pid: 2297,
              name: "荔浦市",
            },
            {
              id: 2315,
              pid: 2297,
              name: "恭城瑶族自治县",
            },
          ],
        },
        {
          id: 2316,
          pid: 2270,
          name: "梧州市",
          children: [
            {
              id: 2318,
              pid: 2316,
              name: "万秀区",
            },
            {
              id: 2319,
              pid: 2316,
              name: "长洲区",
            },
            {
              id: 2320,
              pid: 2316,
              name: "龙圩区",
            },
            {
              id: 2321,
              pid: 2316,
              name: "苍梧县",
            },
            {
              id: 2322,
              pid: 2316,
              name: "藤县",
            },
            {
              id: 2323,
              pid: 2316,
              name: "蒙山县",
            },
            {
              id: 2324,
              pid: 2316,
              name: "岑溪市",
            },
          ],
        },
        {
          id: 2325,
          pid: 2270,
          name: "北海市",
          children: [
            {
              id: 2327,
              pid: 2325,
              name: "海城区",
            },
            {
              id: 2328,
              pid: 2325,
              name: "银海区",
            },
            {
              id: 2329,
              pid: 2325,
              name: "铁山港区",
            },
            {
              id: 2330,
              pid: 2325,
              name: "合浦县",
            },
          ],
        },
        {
          id: 2331,
          pid: 2270,
          name: "防城港市",
          children: [
            {
              id: 2333,
              pid: 2331,
              name: "港口区",
            },
            {
              id: 2334,
              pid: 2331,
              name: "防城区",
            },
            {
              id: 2335,
              pid: 2331,
              name: "上思县",
            },
            {
              id: 2336,
              pid: 2331,
              name: "东兴市",
            },
          ],
        },
        {
          id: 2337,
          pid: 2270,
          name: "钦州市",
          children: [
            {
              id: 2339,
              pid: 2337,
              name: "钦南区",
            },
            {
              id: 2340,
              pid: 2337,
              name: "钦北区",
            },
            {
              id: 2341,
              pid: 2337,
              name: "灵山县",
            },
            {
              id: 2342,
              pid: 2337,
              name: "浦北县",
            },
          ],
        },
        {
          id: 2343,
          pid: 2270,
          name: "贵港市",
          children: [
            {
              id: 2345,
              pid: 2343,
              name: "港北区",
            },
            {
              id: 2346,
              pid: 2343,
              name: "港南区",
            },
            {
              id: 2347,
              pid: 2343,
              name: "覃塘区",
            },
            {
              id: 2348,
              pid: 2343,
              name: "平南县",
            },
            {
              id: 2349,
              pid: 2343,
              name: "桂平市",
            },
          ],
        },
        {
          id: 2350,
          pid: 2270,
          name: "玉林市",
          children: [
            {
              id: 2352,
              pid: 2350,
              name: "玉州区",
            },
            {
              id: 2353,
              pid: 2350,
              name: "福绵区",
            },
            {
              id: 2354,
              pid: 2350,
              name: "容县",
            },
            {
              id: 2355,
              pid: 2350,
              name: "陆川县",
            },
            {
              id: 2356,
              pid: 2350,
              name: "博白县",
            },
            {
              id: 2357,
              pid: 2350,
              name: "兴业县",
            },
            {
              id: 2358,
              pid: 2350,
              name: "北流市",
            },
          ],
        },
        {
          id: 2359,
          pid: 2270,
          name: "百色市",
          children: [
            {
              id: 2361,
              pid: 2359,
              name: "右江区",
            },
            {
              id: 2362,
              pid: 2359,
              name: "田阳区",
            },
            {
              id: 2363,
              pid: 2359,
              name: "田东县",
            },
            {
              id: 2364,
              pid: 2359,
              name: "平果市",
            },
            {
              id: 2365,
              pid: 2359,
              name: "德保县",
            },
            {
              id: 2366,
              pid: 2359,
              name: "那坡县",
            },
            {
              id: 2367,
              pid: 2359,
              name: "凌云县",
            },
            {
              id: 2368,
              pid: 2359,
              name: "乐业县",
            },
            {
              id: 2369,
              pid: 2359,
              name: "田林县",
            },
            {
              id: 2370,
              pid: 2359,
              name: "西林县",
            },
            {
              id: 2371,
              pid: 2359,
              name: "隆林各族自治县",
            },
            {
              id: 2372,
              pid: 2359,
              name: "靖西市",
            },
          ],
        },
        {
          id: 2373,
          pid: 2270,
          name: "贺州市",
          children: [
            {
              id: 2375,
              pid: 2373,
              name: "八步区",
            },
            {
              id: 2376,
              pid: 2373,
              name: "平桂区",
            },
            {
              id: 2377,
              pid: 2373,
              name: "昭平县",
            },
            {
              id: 2378,
              pid: 2373,
              name: "钟山县",
            },
            {
              id: 2379,
              pid: 2373,
              name: "富川瑶族自治县",
            },
          ],
        },
        {
          id: 2380,
          pid: 2270,
          name: "河池市",
          children: [
            {
              id: 2382,
              pid: 2380,
              name: "金城江区",
            },
            {
              id: 2383,
              pid: 2380,
              name: "宜州区",
            },
            {
              id: 2384,
              pid: 2380,
              name: "南丹县",
            },
            {
              id: 2385,
              pid: 2380,
              name: "天峨县",
            },
            {
              id: 2386,
              pid: 2380,
              name: "凤山县",
            },
            {
              id: 2387,
              pid: 2380,
              name: "东兰县",
            },
            {
              id: 2388,
              pid: 2380,
              name: "罗城仫佬族自治县",
            },
            {
              id: 2389,
              pid: 2380,
              name: "环江毛南族自治县",
            },
            {
              id: 2390,
              pid: 2380,
              name: "巴马瑶族自治县",
            },
            {
              id: 2391,
              pid: 2380,
              name: "都安瑶族自治县",
            },
            {
              id: 2392,
              pid: 2380,
              name: "大化瑶族自治县",
            },
          ],
        },
        {
          id: 2393,
          pid: 2270,
          name: "来宾市",
          children: [
            {
              id: 2395,
              pid: 2393,
              name: "兴宾区",
            },
            {
              id: 2396,
              pid: 2393,
              name: "忻城县",
            },
            {
              id: 2397,
              pid: 2393,
              name: "象州县",
            },
            {
              id: 2398,
              pid: 2393,
              name: "武宣县",
            },
            {
              id: 2399,
              pid: 2393,
              name: "金秀瑶族自治县",
            },
            {
              id: 2400,
              pid: 2393,
              name: "合山市",
            },
          ],
        },
        {
          id: 2401,
          pid: 2270,
          name: "崇左市",
          children: [
            {
              id: 2403,
              pid: 2401,
              name: "江州区",
            },
            {
              id: 2404,
              pid: 2401,
              name: "扶绥县",
            },
            {
              id: 2405,
              pid: 2401,
              name: "宁明县",
            },
            {
              id: 2406,
              pid: 2401,
              name: "龙州县",
            },
            {
              id: 2407,
              pid: 2401,
              name: "大新县",
            },
            {
              id: 2408,
              pid: 2401,
              name: "天等县",
            },
            {
              id: 2409,
              pid: 2401,
              name: "凭祥市",
            },
          ],
        },
      ],
    },
    {
      id: 2410,
      pid: 1,
      name: "海南省",
      children: [
        {
          id: 2411,
          pid: 2410,
          name: "海口市",
          children: [
            {
              id: 2413,
              pid: 2411,
              name: "秀英区",
            },
            {
              id: 2414,
              pid: 2411,
              name: "龙华区",
            },
            {
              id: 2415,
              pid: 2411,
              name: "琼山区",
            },
            {
              id: 2416,
              pid: 2411,
              name: "美兰区",
            },
          ],
        },
        {
          id: 2417,
          pid: 2410,
          name: "三亚市",
          children: [
            {
              id: 2419,
              pid: 2417,
              name: "海棠区",
            },
            {
              id: 2420,
              pid: 2417,
              name: "吉阳区",
            },
            {
              id: 2421,
              pid: 2417,
              name: "天涯区",
            },
            {
              id: 2422,
              pid: 2417,
              name: "崖州区",
            },
          ],
        },
        {
          id: 2423,
          pid: 2410,
          name: "三沙市",
          children: [
            {
              id: 2424,
              pid: 2423,
              name: "西沙区",
            },
            {
              id: 2425,
              pid: 2423,
              name: "南沙区",
            },
          ],
        },
        {
          id: 2426,
          pid: 2410,
          name: "儋州市",
          children: [
            {
              id: 3665,
              pid: 2426,
              name: "儋州市",
            },
            {
              id: 3666,
              pid: 2426,
              name: "热作学院",
            },
            {
              id: 3667,
              pid: 2426,
              name: "西流农场",
            },
            {
              id: 3668,
              pid: 2426,
              name: "南丰镇",
            },
            {
              id: 3669,
              pid: 2426,
              name: "大成镇",
            },
            {
              id: 3670,
              pid: 2426,
              name: "光村镇",
            },
            {
              id: 3671,
              pid: 2426,
              name: "木棠镇",
            },
            {
              id: 3672,
              pid: 2426,
              name: "三都镇",
            },
            {
              id: 3673,
              pid: 2426,
              name: "白马井镇",
            },
            {
              id: 3674,
              pid: 2426,
              name: "中和镇",
            },
            {
              id: 3675,
              pid: 2426,
              name: "新州镇",
            },
            {
              id: 3676,
              pid: 2426,
              name: "洋浦经济开发区",
            },
            {
              id: 3677,
              pid: 2426,
              name: "蓝洋农场",
            },
            {
              id: 3678,
              pid: 2426,
              name: "八一农场",
            },
            {
              id: 3679,
              pid: 2426,
              name: "西庆农场",
            },
            {
              id: 3680,
              pid: 2426,
              name: "龙山农场",
            },
            {
              id: 3681,
              pid: 2426,
              name: "红岭农场",
            },
            {
              id: 3682,
              pid: 2426,
              name: "和庆镇",
            },
            {
              id: 3683,
              pid: 2426,
              name: "雅星镇",
            },
            {
              id: 3684,
              pid: 2426,
              name: "海头镇",
            },
            {
              id: 3685,
              pid: 2426,
              name: "王五镇",
            },
            {
              id: 3686,
              pid: 2426,
              name: "东成镇",
            },
            {
              id: 3687,
              pid: 2426,
              name: "西培农场",
            },
            {
              id: 3688,
              pid: 2426,
              name: "西华农场",
            },
            {
              id: 3689,
              pid: 2426,
              name: "新盈农场",
            },
            {
              id: 3690,
              pid: 2426,
              name: "富克镇",
            },
            {
              id: 3691,
              pid: 2426,
              name: "兰洋镇",
            },
            {
              id: 3692,
              pid: 2426,
              name: "峨蔓镇",
            },
            {
              id: 3693,
              pid: 2426,
              name: "排浦镇",
            },
            {
              id: 3694,
              pid: 2426,
              name: "西联农场",
            },
            {
              id: 3695,
              pid: 2426,
              name: "那大镇",
            },
          ],
        },
        {
          id: 2427,
          pid: 2410,
          name: "五指山市",
          children: [
            {
              id: 3696,
              pid: 2427,
              name: "五指山市",
            },
            {
              id: 3697,
              pid: 2427,
              name: "南圣镇",
            },
            {
              id: 3698,
              pid: 2427,
              name: "畅好乡",
            },
            {
              id: 3699,
              pid: 2427,
              name: "番阳镇",
            },
            {
              id: 3700,
              pid: 2427,
              name: "毛阳镇",
            },
            {
              id: 3701,
              pid: 2427,
              name: "畅好农场",
            },
            {
              id: 3702,
              pid: 2427,
              name: "通什镇",
            },
            {
              id: 3703,
              pid: 2427,
              name: "水满乡",
            },
            {
              id: 3704,
              pid: 2427,
              name: "毛道乡",
            },
          ],
        },
        {
          id: 2428,
          pid: 2410,
          name: "琼海市",
          children: [
            {
              id: 3705,
              pid: 2428,
              name: "琼海市",
            },
            {
              id: 3706,
              pid: 2428,
              name: "万泉镇",
            },
            {
              id: 3707,
              pid: 2428,
              name: "东红农场",
            },
            {
              id: 3708,
              pid: 2428,
              name: "阳江镇",
            },
            {
              id: 3709,
              pid: 2428,
              name: "龙江镇",
            },
            {
              id: 3710,
              pid: 2428,
              name: "塔洋镇",
            },
            {
              id: 3711,
              pid: 2428,
              name: "长坡镇",
            },
            {
              id: 3712,
              pid: 2428,
              name: "大路镇",
            },
            {
              id: 3713,
              pid: 2428,
              name: "彬村山华侨农场",
            },
            {
              id: 3714,
              pid: 2428,
              name: "东太农场",
            },
            {
              id: 3715,
              pid: 2428,
              name: "东升农场",
            },
            {
              id: 3716,
              pid: 2428,
              name: "南俸农场",
            },
            {
              id: 3717,
              pid: 2428,
              name: "嘉积镇",
            },
            {
              id: 3718,
              pid: 2428,
              name: "中原镇",
            },
            {
              id: 3719,
              pid: 2428,
              name: "石壁镇",
            },
            {
              id: 3720,
              pid: 2428,
              name: "潭门镇",
            },
            {
              id: 3721,
              pid: 2428,
              name: "会山镇",
            },
            {
              id: 3722,
              pid: 2428,
              name: "博鳌镇",
            },
          ],
        },
        {
          id: 2429,
          pid: 2410,
          name: "文昌市",
          children: [
            {
              id: 3723,
              pid: 2429,
              name: "文昌市",
            },
            {
              id: 3724,
              pid: 2429,
              name: "文城镇",
            },
            {
              id: 3725,
              pid: 2429,
              name: "蓬莱镇",
            },
            {
              id: 3726,
              pid: 2429,
              name: "潭牛镇",
            },
            {
              id: 3727,
              pid: 2429,
              name: "东阁镇",
            },
            {
              id: 3728,
              pid: 2429,
              name: "龙楼镇",
            },
            {
              id: 3729,
              pid: 2429,
              name: "昌洒镇",
            },
            {
              id: 3730,
              pid: 2429,
              name: "抱罗镇",
            },
            {
              id: 3731,
              pid: 2429,
              name: "锦山镇",
            },
            {
              id: 3732,
              pid: 2429,
              name: "公坡镇",
            },
            {
              id: 3733,
              pid: 2429,
              name: "南阳镇",
            },
            {
              id: 3734,
              pid: 2429,
              name: "新桥镇",
            },
            {
              id: 3735,
              pid: 2429,
              name: "宝芳乡",
            },
            {
              id: 3736,
              pid: 2429,
              name: "湖山乡",
            },
            {
              id: 3737,
              pid: 2429,
              name: "南阳农场",
            },
            {
              id: 3738,
              pid: 2429,
              name: "橡胶研究所",
            },
            {
              id: 3739,
              pid: 2429,
              name: "重兴镇",
            },
            {
              id: 3740,
              pid: 2429,
              name: "东路镇",
            },
            {
              id: 3741,
              pid: 2429,
              name: "东郊镇",
            },
            {
              id: 3742,
              pid: 2429,
              name: "翁田镇",
            },
            {
              id: 3743,
              pid: 2429,
              name: "铺前镇",
            },
            {
              id: 3744,
              pid: 2429,
              name: "清谰镇",
            },
            {
              id: 3745,
              pid: 2429,
              name: "头苑镇",
            },
            {
              id: 3746,
              pid: 2429,
              name: "东路农场",
            },
            {
              id: 3747,
              pid: 2429,
              name: "会文镇",
            },
            {
              id: 3748,
              pid: 2429,
              name: "文教镇",
            },
            {
              id: 3749,
              pid: 2429,
              name: "冯坡镇",
            },
            {
              id: 3750,
              pid: 2429,
              name: "迈号镇",
            },
            {
              id: 3751,
              pid: 2429,
              name: "龙马乡",
            },
            {
              id: 3752,
              pid: 2429,
              name: "罗豆农场",
            },
          ],
        },
        {
          id: 2430,
          pid: 2410,
          name: "万宁市",
          children: [
            {
              id: 3753,
              pid: 2430,
              name: "万宁市",
            },
            {
              id: 3754,
              pid: 2430,
              name: "兴隆镇",
            },
            {
              id: 3755,
              pid: 2430,
              name: "兴隆华侨农场",
            },
            {
              id: 3756,
              pid: 2430,
              name: "龙滚镇",
            },
            {
              id: 3757,
              pid: 2430,
              name: "后安镇",
            },
            {
              id: 3758,
              pid: 2430,
              name: "大茂镇",
            },
            {
              id: 3759,
              pid: 2430,
              name: "东澳镇",
            },
            {
              id: 3760,
              pid: 2430,
              name: "长丰镇",
            },
            {
              id: 3761,
              pid: 2430,
              name: "山根镇",
            },
            {
              id: 3762,
              pid: 2430,
              name: "南桥镇",
            },
            {
              id: 3763,
              pid: 2430,
              name: "三更罗镇",
            },
            {
              id: 3764,
              pid: 2430,
              name: "六连林场",
            },
            {
              id: 3765,
              pid: 2430,
              name: "东和农场",
            },
            {
              id: 3766,
              pid: 2430,
              name: "新中农场",
            },
            {
              id: 3767,
              pid: 2430,
              name: "南林农场",
            },
            {
              id: 3768,
              pid: 2430,
              name: "和乐镇",
            },
            {
              id: 3769,
              pid: 2430,
              name: "礼纪镇",
            },
            {
              id: 3770,
              pid: 2430,
              name: "北大镇",
            },
            {
              id: 3771,
              pid: 2430,
              name: "东兴农场",
            },
            {
              id: 3772,
              pid: 2430,
              name: "万城镇",
            },
          ],
        },
        {
          id: 2431,
          pid: 2410,
          name: "东方市",
          children: [
            {
              id: 3773,
              pid: 2431,
              name: "东方市",
            },
            {
              id: 3774,
              pid: 2431,
              name: "八所镇",
            },
            {
              id: 3775,
              pid: 2431,
              name: "东河镇",
            },
            {
              id: 3776,
              pid: 2431,
              name: "大田镇",
            },
            {
              id: 3777,
              pid: 2431,
              name: "板桥镇",
            },
            {
              id: 3778,
              pid: 2431,
              name: "三家镇",
            },
            {
              id: 3779,
              pid: 2431,
              name: "江边乡",
            },
            {
              id: 3780,
              pid: 2431,
              name: "天安乡",
            },
            {
              id: 3781,
              pid: 2431,
              name: "广坝农场",
            },
            {
              id: 3782,
              pid: 2431,
              name: "东方华侨农场",
            },
            {
              id: 3783,
              pid: 2431,
              name: "感城镇",
            },
            {
              id: 3784,
              pid: 2431,
              name: "四更镇",
            },
            {
              id: 3785,
              pid: 2431,
              name: "新龙镇",
            },
          ],
        },
        {
          id: 2432,
          pid: 2410,
          name: "定安县",
          children: [
            {
              id: 3786,
              pid: 2432,
              name: "定安县",
            },
            {
              id: 3787,
              pid: 2432,
              name: "龙河镇",
            },
            {
              id: 3788,
              pid: 2432,
              name: "富文镇",
            },
            {
              id: 3789,
              pid: 2432,
              name: "金鸡岭农场",
            },
            {
              id: 3790,
              pid: 2432,
              name: "新竹镇",
            },
            {
              id: 3791,
              pid: 2432,
              name: "岭口镇",
            },
            {
              id: 3792,
              pid: 2432,
              name: "定城镇",
            },
            {
              id: 3793,
              pid: 2432,
              name: "翰林镇",
            },
            {
              id: 3794,
              pid: 2432,
              name: "龙门镇",
            },
            {
              id: 3795,
              pid: 2432,
              name: "龙湖镇",
            },
            {
              id: 3796,
              pid: 2432,
              name: "城区",
            },
            {
              id: 3797,
              pid: 2432,
              name: "黄竹镇",
            },
            {
              id: 3798,
              pid: 2432,
              name: "南海农场",
            },
            {
              id: 3799,
              pid: 2432,
              name: "中瑞农场",
            },
            {
              id: 3800,
              pid: 2432,
              name: "雷鸣镇",
            },
          ],
        },
        {
          id: 2433,
          pid: 2410,
          name: "屯昌县",
          children: [
            {
              id: 3801,
              pid: 2433,
              name: "屯昌县",
            },
            {
              id: 3802,
              pid: 2433,
              name: "乌坡镇",
            },
            {
              id: 3803,
              pid: 2433,
              name: "县城内",
            },
            {
              id: 3804,
              pid: 2433,
              name: "屯城镇",
            },
            {
              id: 3805,
              pid: 2433,
              name: "枫木镇",
            },
            {
              id: 3806,
              pid: 2433,
              name: "南坤镇",
            },
            {
              id: 3807,
              pid: 2433,
              name: "坡心镇",
            },
            {
              id: 3808,
              pid: 2433,
              name: "南吕镇",
            },
            {
              id: 3809,
              pid: 2433,
              name: "中坤农场",
            },
            {
              id: 3810,
              pid: 2433,
              name: "西昌镇",
            },
            {
              id: 3811,
              pid: 2433,
              name: "新兴镇",
            },
            {
              id: 3812,
              pid: 2433,
              name: "中建农场",
            },
          ],
        },
        {
          id: 2434,
          pid: 2410,
          name: "澄迈县",
          children: [
            {
              id: 3813,
              pid: 2434,
              name: "澄迈县",
            },
            {
              id: 3814,
              pid: 2434,
              name: "城区",
            },
            {
              id: 3815,
              pid: 2434,
              name: "永发镇",
            },
            {
              id: 3816,
              pid: 2434,
              name: "仁兴镇",
            },
            {
              id: 3817,
              pid: 2434,
              name: "西达农场",
            },
            {
              id: 3818,
              pid: 2434,
              name: "文儒镇",
            },
            {
              id: 3819,
              pid: 2434,
              name: "瑞溪镇",
            },
            {
              id: 3820,
              pid: 2434,
              name: "桥头镇",
            },
            {
              id: 3821,
              pid: 2434,
              name: "金江镇",
            },
            {
              id: 3822,
              pid: 2434,
              name: "加乐镇",
            },
            {
              id: 3823,
              pid: 2434,
              name: "中兴镇",
            },
            {
              id: 3824,
              pid: 2434,
              name: "福山镇",
            },
            {
              id: 3825,
              pid: 2434,
              name: "大丰镇",
            },
            {
              id: 3826,
              pid: 2434,
              name: "红光农场",
            },
            {
              id: 3827,
              pid: 2434,
              name: "金安农场",
            },
            {
              id: 3828,
              pid: 2434,
              name: "老城镇",
            },
          ],
        },
        {
          id: 2435,
          pid: 2410,
          name: "临高县",
          children: [
            {
              id: 3829,
              pid: 2435,
              name: "临高县",
            },
            {
              id: 3830,
              pid: 2435,
              name: "东英镇",
            },
            {
              id: 3831,
              pid: 2435,
              name: "红华农场",
            },
            {
              id: 3832,
              pid: 2435,
              name: "加来镇",
            },
            {
              id: 3833,
              pid: 2435,
              name: "新盈镇",
            },
            {
              id: 3834,
              pid: 2435,
              name: "和舍镇",
            },
            {
              id: 3835,
              pid: 2435,
              name: "皇桐镇",
            },
            {
              id: 3836,
              pid: 2435,
              name: "多文镇",
            },
            {
              id: 3837,
              pid: 2435,
              name: "临城镇",
            },
            {
              id: 3838,
              pid: 2435,
              name: "调楼镇",
            },
            {
              id: 3839,
              pid: 2435,
              name: "南宝镇",
            },
            {
              id: 3840,
              pid: 2435,
              name: "博厚镇",
            },
            {
              id: 3841,
              pid: 2435,
              name: "城区",
            },
            {
              id: 3842,
              pid: 2435,
              name: "加来农场",
            },
            {
              id: 3843,
              pid: 2435,
              name: "波莲镇",
            },
          ],
        },
        {
          id: 2436,
          pid: 2410,
          name: "白沙黎族自治县",
          children: [
            {
              id: 3844,
              pid: 2436,
              name: "白沙黎族自治县",
            },
            {
              id: 3845,
              pid: 2436,
              name: "南开乡",
            },
            {
              id: 3846,
              pid: 2436,
              name: "青松乡",
            },
            {
              id: 3847,
              pid: 2436,
              name: "荣邦乡",
            },
            {
              id: 3848,
              pid: 2436,
              name: "白沙农场",
            },
            {
              id: 3849,
              pid: 2436,
              name: "龙江农场",
            },
            {
              id: 3850,
              pid: 2436,
              name: "邦溪农场",
            },
            {
              id: 3851,
              pid: 2436,
              name: "打安镇",
            },
            {
              id: 3852,
              pid: 2436,
              name: "元门乡",
            },
            {
              id: 3853,
              pid: 2436,
              name: "阜龙乡",
            },
            {
              id: 3854,
              pid: 2436,
              name: "金波乡",
            },
            {
              id: 3855,
              pid: 2436,
              name: "城区",
            },
            {
              id: 3856,
              pid: 2436,
              name: "牙叉镇",
            },
            {
              id: 3857,
              pid: 2436,
              name: "七坊镇",
            },
            {
              id: 3858,
              pid: 2436,
              name: "邦溪镇",
            },
            {
              id: 3859,
              pid: 2436,
              name: "细水乡",
            },
          ],
        },
        {
          id: 2437,
          pid: 2410,
          name: "昌江黎族自治县",
          children: [
            {
              id: 3860,
              pid: 2437,
              name: "昌江黎族自治县",
            },
            {
              id: 3861,
              pid: 2437,
              name: "城区",
            },
            {
              id: 3862,
              pid: 2437,
              name: "乌烈镇",
            },
            {
              id: 3863,
              pid: 2437,
              name: "石碌镇",
            },
            {
              id: 3864,
              pid: 2437,
              name: "十月田镇",
            },
            {
              id: 3865,
              pid: 2437,
              name: "昌化镇",
            },
            {
              id: 3866,
              pid: 2437,
              name: "霸王岭林场",
            },
            {
              id: 3867,
              pid: 2437,
              name: "海南矿业公司",
            },
            {
              id: 3868,
              pid: 2437,
              name: "红林农场",
            },
            {
              id: 3869,
              pid: 2437,
              name: "叉河镇",
            },
            {
              id: 3870,
              pid: 2437,
              name: "海尾镇",
            },
            {
              id: 3871,
              pid: 2437,
              name: "王下乡",
            },
            {
              id: 3872,
              pid: 2437,
              name: "七叉镇",
            },
          ],
        },
        {
          id: 2438,
          pid: 2410,
          name: "乐东黎族自治县",
          children: [
            {
              id: 3873,
              pid: 2438,
              name: "乐东黎族自治县",
            },
            {
              id: 3874,
              pid: 2438,
              name: "保国农场",
            },
            {
              id: 3875,
              pid: 2438,
              name: "尖峰镇",
            },
            {
              id: 3876,
              pid: 2438,
              name: "莺歌海盐场",
            },
            {
              id: 3877,
              pid: 2438,
              name: "千家镇",
            },
            {
              id: 3878,
              pid: 2438,
              name: "佛罗镇",
            },
            {
              id: 3879,
              pid: 2438,
              name: "山荣农场",
            },
            {
              id: 3880,
              pid: 2438,
              name: "抱由镇",
            },
            {
              id: 3881,
              pid: 2438,
              name: "大安镇",
            },
            {
              id: 3882,
              pid: 2438,
              name: "九所镇",
            },
            {
              id: 3883,
              pid: 2438,
              name: "黄流镇",
            },
            {
              id: 3884,
              pid: 2438,
              name: "莺歌海镇",
            },
            {
              id: 3885,
              pid: 2438,
              name: "尖峰岭林业公司",
            },
            {
              id: 3886,
              pid: 2438,
              name: "乐光农场",
            },
            {
              id: 3887,
              pid: 2438,
              name: "万冲镇",
            },
            {
              id: 3888,
              pid: 2438,
              name: "志仲镇",
            },
            {
              id: 3889,
              pid: 2438,
              name: "利国镇",
            },
            {
              id: 3890,
              pid: 2438,
              name: "城区",
            },
          ],
        },
        {
          id: 2439,
          pid: 2410,
          name: "陵水黎族自治县",
          children: [
            {
              id: 3891,
              pid: 2439,
              name: "陵水黎族自治县",
            },
            {
              id: 3892,
              pid: 2439,
              name: "南平镇",
            },
            {
              id: 3893,
              pid: 2439,
              name: "提蒙乡",
            },
            {
              id: 3894,
              pid: 2439,
              name: "椰林镇",
            },
            {
              id: 3895,
              pid: 2439,
              name: "三才镇",
            },
            {
              id: 3896,
              pid: 2439,
              name: "隆广镇",
            },
            {
              id: 3897,
              pid: 2439,
              name: "本号镇",
            },
            {
              id: 3898,
              pid: 2439,
              name: "黎安镇",
            },
            {
              id: 3899,
              pid: 2439,
              name: "群英乡",
            },
            {
              id: 3900,
              pid: 2439,
              name: "城区",
            },
            {
              id: 3901,
              pid: 2439,
              name: "东华镇",
            },
            {
              id: 3902,
              pid: 2439,
              name: "吊罗山林业公司",
            },
            {
              id: 3903,
              pid: 2439,
              name: "南平农场",
            },
            {
              id: 3904,
              pid: 2439,
              name: "光坡镇",
            },
            {
              id: 3905,
              pid: 2439,
              name: "英州镇",
            },
            {
              id: 3906,
              pid: 2439,
              name: "文罗镇",
            },
            {
              id: 3907,
              pid: 2439,
              name: "新村镇",
            },
            {
              id: 3908,
              pid: 2439,
              name: "岭门农场",
            },
          ],
        },
        {
          id: 2440,
          pid: 2410,
          name: "保亭黎族苗族自治县",
          children: [
            {
              id: 3924,
              pid: 2440,
              name: "保亭黎族苗族自治县",
            },
          ],
        },
        {
          id: 2441,
          pid: 2410,
          name: "琼中黎族苗族自治县",
          children: [
            {
              id: 3923,
              pid: 2441,
              name: "琼中黎族苗族自治县",
            },
          ],
        },
      ],
    },
    {
      id: 2442,
      pid: 1,
      name: "重庆市",
      children: [
        {
          id: 2443,
          pid: 2442,
          name: "重庆市",
          children: [
            {
              id: 2482,
              pid: 2443,
              name: "彭水县",
            },
            {
              id: 2444,
              pid: 2443,
              name: "万州区",
            },
            {
              id: 2445,
              pid: 2443,
              name: "涪陵区",
            },
            {
              id: 2446,
              pid: 2443,
              name: "渝中区",
            },
            {
              id: 2447,
              pid: 2443,
              name: "大渡口区",
            },
            {
              id: 2448,
              pid: 2443,
              name: "江北区",
            },
            {
              id: 2449,
              pid: 2443,
              name: "沙坪坝区",
            },
            {
              id: 2450,
              pid: 2443,
              name: "九龙坡区",
            },
            {
              id: 2451,
              pid: 2443,
              name: "南岸区",
            },
            {
              id: 2452,
              pid: 2443,
              name: "北碚区",
            },
            {
              id: 2453,
              pid: 2443,
              name: "綦江区",
            },
            {
              id: 2454,
              pid: 2443,
              name: "大足区",
            },
            {
              id: 2455,
              pid: 2443,
              name: "渝北区",
            },
            {
              id: 2456,
              pid: 2443,
              name: "巴南区",
            },
            {
              id: 2457,
              pid: 2443,
              name: "黔江区",
            },
            {
              id: 2458,
              pid: 2443,
              name: "长寿区",
            },
            {
              id: 2459,
              pid: 2443,
              name: "江津区",
            },
            {
              id: 2460,
              pid: 2443,
              name: "合川区",
            },
            {
              id: 2461,
              pid: 2443,
              name: "永川区",
            },
            {
              id: 2462,
              pid: 2443,
              name: "南川区",
            },
            {
              id: 2463,
              pid: 2443,
              name: "璧山区",
            },
            {
              id: 2464,
              pid: 2443,
              name: "铜梁区",
            },
            {
              id: 2465,
              pid: 2443,
              name: "潼南区",
            },
            {
              id: 2466,
              pid: 2443,
              name: "荣昌区",
            },
            {
              id: 2467,
              pid: 2443,
              name: "开州区",
            },
            {
              id: 2468,
              pid: 2443,
              name: "梁平区",
            },
            {
              id: 2469,
              pid: 2443,
              name: "武隆区",
            },
            {
              id: 2471,
              pid: 2443,
              name: "城口县",
            },
            {
              id: 2472,
              pid: 2443,
              name: "丰都县",
            },
            {
              id: 2473,
              pid: 2443,
              name: "垫江县",
            },
            {
              id: 2474,
              pid: 2443,
              name: "忠县",
            },
            {
              id: 2475,
              pid: 2443,
              name: "云阳县",
            },
            {
              id: 2476,
              pid: 2443,
              name: "奉节县",
            },
            {
              id: 2477,
              pid: 2443,
              name: "巫山县",
            },
            {
              id: 2478,
              pid: 2443,
              name: "巫溪县",
            },
            {
              id: 2479,
              pid: 2443,
              name: "石柱土家族自治县",
            },
            {
              id: 2480,
              pid: 2443,
              name: "秀山土家族苗族自治县",
            },
            {
              id: 2481,
              pid: 2443,
              name: "酉阳土家族苗族自治县",
            },
          ],
        },
      ],
    },
    {
      id: 2483,
      pid: 1,
      name: "四川省",
      children: [
        {
          id: 2484,
          pid: 2483,
          name: "成都市",
          children: [
            {
              id: 2486,
              pid: 2484,
              name: "锦江区",
            },
            {
              id: 2487,
              pid: 2484,
              name: "青羊区",
            },
            {
              id: 2488,
              pid: 2484,
              name: "金牛区",
            },
            {
              id: 2489,
              pid: 2484,
              name: "武侯区",
            },
            {
              id: 2490,
              pid: 2484,
              name: "成华区",
            },
            {
              id: 2491,
              pid: 2484,
              name: "龙泉驿区",
            },
            {
              id: 2492,
              pid: 2484,
              name: "青白江区",
            },
            {
              id: 2493,
              pid: 2484,
              name: "新都区",
            },
            {
              id: 2494,
              pid: 2484,
              name: "温江区",
            },
            {
              id: 2495,
              pid: 2484,
              name: "双流区",
            },
            {
              id: 2496,
              pid: 2484,
              name: "郫都区",
            },
            {
              id: 2497,
              pid: 2484,
              name: "金堂县",
            },
            {
              id: 2498,
              pid: 2484,
              name: "大邑县",
            },
            {
              id: 2499,
              pid: 2484,
              name: "蒲江县",
            },
            {
              id: 2500,
              pid: 2484,
              name: "新津区",
            },
            {
              id: 2501,
              pid: 2484,
              name: "都江堰市",
            },
            {
              id: 2502,
              pid: 2484,
              name: "彭州市",
            },
            {
              id: 2503,
              pid: 2484,
              name: "邛崃市",
            },
            {
              id: 2504,
              pid: 2484,
              name: "崇州市",
            },
            {
              id: 2505,
              pid: 2484,
              name: "简阳市",
            },
          ],
        },
        {
          id: 2506,
          pid: 2483,
          name: "自贡市",
          children: [
            {
              id: 2508,
              pid: 2506,
              name: "自流井区",
            },
            {
              id: 2509,
              pid: 2506,
              name: "贡井区",
            },
            {
              id: 2510,
              pid: 2506,
              name: "大安区",
            },
            {
              id: 2511,
              pid: 2506,
              name: "沿滩区",
            },
            {
              id: 2512,
              pid: 2506,
              name: "荣县",
            },
            {
              id: 2513,
              pid: 2506,
              name: "富顺县",
            },
          ],
        },
        {
          id: 2514,
          pid: 2483,
          name: "攀枝花市",
          children: [
            {
              id: 2516,
              pid: 2514,
              name: "东区",
            },
            {
              id: 2517,
              pid: 2514,
              name: "西区",
            },
            {
              id: 2518,
              pid: 2514,
              name: "仁和区",
            },
            {
              id: 2519,
              pid: 2514,
              name: "米易县",
            },
            {
              id: 2520,
              pid: 2514,
              name: "盐边县",
            },
          ],
        },
        {
          id: 2521,
          pid: 2483,
          name: "泸州市",
          children: [
            {
              id: 2523,
              pid: 2521,
              name: "江阳区",
            },
            {
              id: 2524,
              pid: 2521,
              name: "纳溪区",
            },
            {
              id: 2525,
              pid: 2521,
              name: "龙马潭区",
            },
            {
              id: 2526,
              pid: 2521,
              name: "泸县",
            },
            {
              id: 2527,
              pid: 2521,
              name: "合江县",
            },
            {
              id: 2528,
              pid: 2521,
              name: "叙永县",
            },
            {
              id: 2529,
              pid: 2521,
              name: "古蔺县",
            },
          ],
        },
        {
          id: 2530,
          pid: 2483,
          name: "德阳市",
          children: [
            {
              id: 2532,
              pid: 2530,
              name: "旌阳区",
            },
            {
              id: 2533,
              pid: 2530,
              name: "中江县",
            },
            {
              id: 2534,
              pid: 2530,
              name: "罗江区",
            },
            {
              id: 2535,
              pid: 2530,
              name: "广汉市",
            },
            {
              id: 2536,
              pid: 2530,
              name: "什邡市",
            },
            {
              id: 2537,
              pid: 2530,
              name: "绵竹市",
            },
          ],
        },
        {
          id: 2538,
          pid: 2483,
          name: "绵阳市",
          children: [
            {
              id: 2540,
              pid: 2538,
              name: "涪城区",
            },
            {
              id: 2541,
              pid: 2538,
              name: "游仙区",
            },
            {
              id: 2542,
              pid: 2538,
              name: "安州区",
            },
            {
              id: 2543,
              pid: 2538,
              name: "三台县",
            },
            {
              id: 2544,
              pid: 2538,
              name: "盐亭县",
            },
            {
              id: 2545,
              pid: 2538,
              name: "梓潼县",
            },
            {
              id: 2546,
              pid: 2538,
              name: "北川羌族自治县",
            },
            {
              id: 2547,
              pid: 2538,
              name: "平武县",
            },
            {
              id: 2548,
              pid: 2538,
              name: "江油市",
            },
          ],
        },
        {
          id: 2549,
          pid: 2483,
          name: "广元市",
          children: [
            {
              id: 2551,
              pid: 2549,
              name: "利州区",
            },
            {
              id: 2552,
              pid: 2549,
              name: "昭化区",
            },
            {
              id: 2553,
              pid: 2549,
              name: "朝天区",
            },
            {
              id: 2554,
              pid: 2549,
              name: "旺苍县",
            },
            {
              id: 2555,
              pid: 2549,
              name: "青川县",
            },
            {
              id: 2556,
              pid: 2549,
              name: "剑阁县",
            },
            {
              id: 2557,
              pid: 2549,
              name: "苍溪县",
            },
          ],
        },
        {
          id: 2558,
          pid: 2483,
          name: "遂宁市",
          children: [
            {
              id: 2560,
              pid: 2558,
              name: "船山区",
            },
            {
              id: 2561,
              pid: 2558,
              name: "安居区",
            },
            {
              id: 2562,
              pid: 2558,
              name: "蓬溪县",
            },
            {
              id: 2563,
              pid: 2558,
              name: "射洪市",
            },
            {
              id: 2564,
              pid: 2558,
              name: "大英县",
            },
          ],
        },
        {
          id: 2565,
          pid: 2483,
          name: "内江市",
          children: [
            {
              id: 2567,
              pid: 2565,
              name: "市中区",
            },
            {
              id: 2568,
              pid: 2565,
              name: "东兴区",
            },
            {
              id: 2569,
              pid: 2565,
              name: "威远县",
            },
            {
              id: 2570,
              pid: 2565,
              name: "资中县",
            },
            {
              id: 2571,
              pid: 2565,
              name: "隆昌市",
            },
          ],
        },
        {
          id: 2572,
          pid: 2483,
          name: "乐山市",
          children: [
            {
              id: 2574,
              pid: 2572,
              name: "市中区",
            },
            {
              id: 2575,
              pid: 2572,
              name: "沙湾区",
            },
            {
              id: 2576,
              pid: 2572,
              name: "五通桥区",
            },
            {
              id: 2577,
              pid: 2572,
              name: "金口河区",
            },
            {
              id: 2578,
              pid: 2572,
              name: "犍为县",
            },
            {
              id: 2579,
              pid: 2572,
              name: "井研县",
            },
            {
              id: 2580,
              pid: 2572,
              name: "夹江县",
            },
            {
              id: 2581,
              pid: 2572,
              name: "沐川县",
            },
            {
              id: 2582,
              pid: 2572,
              name: "峨边彝族自治县",
            },
            {
              id: 2583,
              pid: 2572,
              name: "马边彝族自治县",
            },
            {
              id: 2584,
              pid: 2572,
              name: "峨眉山市",
            },
          ],
        },
        {
          id: 2585,
          pid: 2483,
          name: "南充市",
          children: [
            {
              id: 2587,
              pid: 2585,
              name: "顺庆区",
            },
            {
              id: 2588,
              pid: 2585,
              name: "高坪区",
            },
            {
              id: 2589,
              pid: 2585,
              name: "嘉陵区",
            },
            {
              id: 2590,
              pid: 2585,
              name: "南部县",
            },
            {
              id: 2591,
              pid: 2585,
              name: "营山县",
            },
            {
              id: 2592,
              pid: 2585,
              name: "蓬安县",
            },
            {
              id: 2593,
              pid: 2585,
              name: "仪陇县",
            },
            {
              id: 2594,
              pid: 2585,
              name: "西充县",
            },
            {
              id: 2595,
              pid: 2585,
              name: "阆中市",
            },
          ],
        },
        {
          id: 2596,
          pid: 2483,
          name: "眉山市",
          children: [
            {
              id: 2598,
              pid: 2596,
              name: "东坡区",
            },
            {
              id: 2599,
              pid: 2596,
              name: "彭山区",
            },
            {
              id: 2600,
              pid: 2596,
              name: "仁寿县",
            },
            {
              id: 2601,
              pid: 2596,
              name: "洪雅县",
            },
            {
              id: 2602,
              pid: 2596,
              name: "丹棱县",
            },
            {
              id: 2603,
              pid: 2596,
              name: "青神县",
            },
          ],
        },
        {
          id: 2604,
          pid: 2483,
          name: "宜宾市",
          children: [
            {
              id: 2606,
              pid: 2604,
              name: "翠屏区",
            },
            {
              id: 2607,
              pid: 2604,
              name: "南溪区",
            },
            {
              id: 2608,
              pid: 2604,
              name: "叙州区",
            },
            {
              id: 2609,
              pid: 2604,
              name: "江安县",
            },
            {
              id: 2610,
              pid: 2604,
              name: "长宁县",
            },
            {
              id: 2611,
              pid: 2604,
              name: "高县",
            },
            {
              id: 2612,
              pid: 2604,
              name: "珙县",
            },
            {
              id: 2613,
              pid: 2604,
              name: "筠连县",
            },
            {
              id: 2614,
              pid: 2604,
              name: "兴文县",
            },
            {
              id: 2615,
              pid: 2604,
              name: "屏山县",
            },
          ],
        },
        {
          id: 2616,
          pid: 2483,
          name: "广安市",
          children: [
            {
              id: 2618,
              pid: 2616,
              name: "广安区",
            },
            {
              id: 2619,
              pid: 2616,
              name: "前锋区",
            },
            {
              id: 2620,
              pid: 2616,
              name: "岳池县",
            },
            {
              id: 2621,
              pid: 2616,
              name: "武胜县",
            },
            {
              id: 2622,
              pid: 2616,
              name: "邻水县",
            },
            {
              id: 2623,
              pid: 2616,
              name: "华蓥市",
            },
          ],
        },
        {
          id: 2624,
          pid: 2483,
          name: "达州市",
          children: [
            {
              id: 2626,
              pid: 2624,
              name: "通川区",
            },
            {
              id: 2627,
              pid: 2624,
              name: "达川区",
            },
            {
              id: 2628,
              pid: 2624,
              name: "宣汉县",
            },
            {
              id: 2629,
              pid: 2624,
              name: "开江县",
            },
            {
              id: 2630,
              pid: 2624,
              name: "大竹县",
            },
            {
              id: 2631,
              pid: 2624,
              name: "渠县",
            },
            {
              id: 2632,
              pid: 2624,
              name: "万源市",
            },
          ],
        },
        {
          id: 2633,
          pid: 2483,
          name: "雅安市",
          children: [
            {
              id: 2635,
              pid: 2633,
              name: "雨城区",
            },
            {
              id: 2636,
              pid: 2633,
              name: "名山区",
            },
            {
              id: 2637,
              pid: 2633,
              name: "荥经县",
            },
            {
              id: 2638,
              pid: 2633,
              name: "汉源县",
            },
            {
              id: 2639,
              pid: 2633,
              name: "石棉县",
            },
            {
              id: 2640,
              pid: 2633,
              name: "天全县",
            },
            {
              id: 2641,
              pid: 2633,
              name: "芦山县",
            },
            {
              id: 2642,
              pid: 2633,
              name: "宝兴县",
            },
          ],
        },
        {
          id: 2643,
          pid: 2483,
          name: "巴中市",
          children: [
            {
              id: 2645,
              pid: 2643,
              name: "巴州区",
            },
            {
              id: 2646,
              pid: 2643,
              name: "恩阳区",
            },
            {
              id: 2647,
              pid: 2643,
              name: "通江县",
            },
            {
              id: 2648,
              pid: 2643,
              name: "南江县",
            },
            {
              id: 2649,
              pid: 2643,
              name: "平昌县",
            },
          ],
        },
        {
          id: 2650,
          pid: 2483,
          name: "资阳市",
          children: [
            {
              id: 2652,
              pid: 2650,
              name: "雁江区",
            },
            {
              id: 2653,
              pid: 2650,
              name: "安岳县",
            },
            {
              id: 2654,
              pid: 2650,
              name: "乐至县",
            },
          ],
        },
        {
          id: 2655,
          pid: 2483,
          name: "阿坝藏族羌族自治州",
          children: [
            {
              id: 2656,
              pid: 2655,
              name: "马尔康市",
            },
            {
              id: 2657,
              pid: 2655,
              name: "汶川县",
            },
            {
              id: 2658,
              pid: 2655,
              name: "理县",
            },
            {
              id: 2659,
              pid: 2655,
              name: "茂县",
            },
            {
              id: 2660,
              pid: 2655,
              name: "松潘县",
            },
            {
              id: 2661,
              pid: 2655,
              name: "九寨沟县",
            },
            {
              id: 2662,
              pid: 2655,
              name: "金川县",
            },
            {
              id: 2663,
              pid: 2655,
              name: "小金县",
            },
            {
              id: 2664,
              pid: 2655,
              name: "黑水县",
            },
            {
              id: 2665,
              pid: 2655,
              name: "壤塘县",
            },
            {
              id: 2666,
              pid: 2655,
              name: "阿坝县",
            },
            {
              id: 2667,
              pid: 2655,
              name: "若尔盖县",
            },
            {
              id: 2668,
              pid: 2655,
              name: "红原县",
            },
          ],
        },
        {
          id: 2669,
          pid: 2483,
          name: "甘孜藏族自治州",
          children: [
            {
              id: 2670,
              pid: 2669,
              name: "康定市",
            },
            {
              id: 2671,
              pid: 2669,
              name: "泸定县",
            },
            {
              id: 2672,
              pid: 2669,
              name: "丹巴县",
            },
            {
              id: 2673,
              pid: 2669,
              name: "九龙县",
            },
            {
              id: 2674,
              pid: 2669,
              name: "雅江县",
            },
            {
              id: 2675,
              pid: 2669,
              name: "道孚县",
            },
            {
              id: 2676,
              pid: 2669,
              name: "炉霍县",
            },
            {
              id: 2677,
              pid: 2669,
              name: "甘孜县",
            },
            {
              id: 2678,
              pid: 2669,
              name: "新龙县",
            },
            {
              id: 2679,
              pid: 2669,
              name: "德格县",
            },
            {
              id: 2680,
              pid: 2669,
              name: "白玉县",
            },
            {
              id: 2681,
              pid: 2669,
              name: "石渠县",
            },
            {
              id: 2682,
              pid: 2669,
              name: "色达县",
            },
            {
              id: 2683,
              pid: 2669,
              name: "理塘县",
            },
            {
              id: 2684,
              pid: 2669,
              name: "巴塘县",
            },
            {
              id: 2685,
              pid: 2669,
              name: "乡城县",
            },
            {
              id: 2686,
              pid: 2669,
              name: "稻城县",
            },
            {
              id: 2687,
              pid: 2669,
              name: "得荣县",
            },
          ],
        },
        {
          id: 2688,
          pid: 2483,
          name: "凉山彝族自治州",
          children: [
            {
              id: 2689,
              pid: 2688,
              name: "西昌市",
            },
            {
              id: 2690,
              pid: 2688,
              name: "木里藏族自治县",
            },
            {
              id: 2691,
              pid: 2688,
              name: "盐源县",
            },
            {
              id: 2692,
              pid: 2688,
              name: "德昌县",
            },
            {
              id: 2693,
              pid: 2688,
              name: "会理县",
            },
            {
              id: 2694,
              pid: 2688,
              name: "会东县",
            },
            {
              id: 2695,
              pid: 2688,
              name: "宁南县",
            },
            {
              id: 2696,
              pid: 2688,
              name: "普格县",
            },
            {
              id: 2697,
              pid: 2688,
              name: "布拖县",
            },
            {
              id: 2698,
              pid: 2688,
              name: "金阳县",
            },
            {
              id: 2699,
              pid: 2688,
              name: "昭觉县",
            },
            {
              id: 2700,
              pid: 2688,
              name: "喜德县",
            },
            {
              id: 2701,
              pid: 2688,
              name: "冕宁县",
            },
            {
              id: 2702,
              pid: 2688,
              name: "越西县",
            },
            {
              id: 2703,
              pid: 2688,
              name: "甘洛县",
            },
            {
              id: 2704,
              pid: 2688,
              name: "美姑县",
            },
            {
              id: 2705,
              pid: 2688,
              name: "雷波县",
            },
          ],
        },
      ],
    },
    {
      id: 2706,
      pid: 1,
      name: "贵州省",
      children: [
        {
          id: 2707,
          pid: 2706,
          name: "贵阳市",
          children: [
            {
              id: 2709,
              pid: 2707,
              name: "南明区",
            },
            {
              id: 2710,
              pid: 2707,
              name: "云岩区",
            },
            {
              id: 2711,
              pid: 2707,
              name: "花溪区",
            },
            {
              id: 2712,
              pid: 2707,
              name: "乌当区",
            },
            {
              id: 2713,
              pid: 2707,
              name: "白云区",
            },
            {
              id: 2714,
              pid: 2707,
              name: "观山湖区",
            },
            {
              id: 2715,
              pid: 2707,
              name: "开阳县",
            },
            {
              id: 2716,
              pid: 2707,
              name: "息烽县",
            },
            {
              id: 2717,
              pid: 2707,
              name: "修文县",
            },
            {
              id: 2718,
              pid: 2707,
              name: "清镇市",
            },
          ],
        },
        {
          id: 2719,
          pid: 2706,
          name: "六盘水市",
          children: [
            {
              id: 2720,
              pid: 2719,
              name: "钟山区",
            },
            {
              id: 2721,
              pid: 2719,
              name: "六枝特区",
            },
            {
              id: 2722,
              pid: 2719,
              name: "水城区",
            },
            {
              id: 2723,
              pid: 2719,
              name: "盘州市",
            },
          ],
        },
        {
          id: 2724,
          pid: 2706,
          name: "遵义市",
          children: [
            {
              id: 2726,
              pid: 2724,
              name: "红花岗区",
            },
            {
              id: 2727,
              pid: 2724,
              name: "汇川区",
            },
            {
              id: 2728,
              pid: 2724,
              name: "播州区",
            },
            {
              id: 2729,
              pid: 2724,
              name: "桐梓县",
            },
            {
              id: 2730,
              pid: 2724,
              name: "绥阳县",
            },
            {
              id: 2731,
              pid: 2724,
              name: "正安县",
            },
            {
              id: 2732,
              pid: 2724,
              name: "道真仡佬族苗族自治县",
            },
            {
              id: 2733,
              pid: 2724,
              name: "务川仡佬族苗族自治县",
            },
            {
              id: 2734,
              pid: 2724,
              name: "凤冈县",
            },
            {
              id: 2735,
              pid: 2724,
              name: "湄潭县",
            },
            {
              id: 2736,
              pid: 2724,
              name: "余庆县",
            },
            {
              id: 2737,
              pid: 2724,
              name: "习水县",
            },
            {
              id: 2738,
              pid: 2724,
              name: "赤水市",
            },
            {
              id: 2739,
              pid: 2724,
              name: "仁怀市",
            },
          ],
        },
        {
          id: 2740,
          pid: 2706,
          name: "安顺市",
          children: [
            {
              id: 2742,
              pid: 2740,
              name: "西秀区",
            },
            {
              id: 2743,
              pid: 2740,
              name: "平坝区",
            },
            {
              id: 2744,
              pid: 2740,
              name: "普定县",
            },
            {
              id: 2745,
              pid: 2740,
              name: "镇宁布依族苗族自治县",
            },
            {
              id: 2746,
              pid: 2740,
              name: "关岭布依族苗族自治县",
            },
            {
              id: 2747,
              pid: 2740,
              name: "紫云苗族布依族自治县",
            },
          ],
        },
        {
          id: 2748,
          pid: 2706,
          name: "毕节市",
          children: [
            {
              id: 2749,
              pid: 2748,
              name: "七星关区",
            },
            {
              id: 2750,
              pid: 2748,
              name: "大方县",
            },
            {
              id: 2751,
              pid: 2748,
              name: "黔西市",
            },
            {
              id: 2752,
              pid: 2748,
              name: "金沙县",
            },
            {
              id: 2753,
              pid: 2748,
              name: "织金县",
            },
            {
              id: 2754,
              pid: 2748,
              name: "纳雍县",
            },
            {
              id: 2755,
              pid: 2748,
              name: "威宁彝族回族苗族自治县",
            },
            {
              id: 2756,
              pid: 2748,
              name: "赫章县",
            },
          ],
        },
        {
          id: 2757,
          pid: 2706,
          name: "铜仁市",
          children: [
            {
              id: 2758,
              pid: 2757,
              name: "碧江区",
            },
            {
              id: 2759,
              pid: 2757,
              name: "万山区",
            },
            {
              id: 2760,
              pid: 2757,
              name: "江口县",
            },
            {
              id: 2761,
              pid: 2757,
              name: "玉屏侗族自治县",
            },
            {
              id: 2762,
              pid: 2757,
              name: "石阡县",
            },
            {
              id: 2763,
              pid: 2757,
              name: "思南县",
            },
            {
              id: 2764,
              pid: 2757,
              name: "印江土家族苗族自治县",
            },
            {
              id: 2765,
              pid: 2757,
              name: "德江县",
            },
            {
              id: 2766,
              pid: 2757,
              name: "沿河土家族自治县",
            },
            {
              id: 2767,
              pid: 2757,
              name: "松桃苗族自治县",
            },
          ],
        },
        {
          id: 2768,
          pid: 2706,
          name: "黔西南布依族苗族自治州",
          children: [
            {
              id: 2769,
              pid: 2768,
              name: "兴义市",
            },
            {
              id: 2770,
              pid: 2768,
              name: "兴仁市",
            },
            {
              id: 2771,
              pid: 2768,
              name: "普安县",
            },
            {
              id: 2772,
              pid: 2768,
              name: "晴隆县",
            },
            {
              id: 2773,
              pid: 2768,
              name: "贞丰县",
            },
            {
              id: 2774,
              pid: 2768,
              name: "望谟县",
            },
            {
              id: 2775,
              pid: 2768,
              name: "册亨县",
            },
            {
              id: 2776,
              pid: 2768,
              name: "安龙县",
            },
          ],
        },
        {
          id: 2777,
          pid: 2706,
          name: "黔东南苗族侗族自治州",
          children: [
            {
              id: 2778,
              pid: 2777,
              name: "凯里市",
            },
            {
              id: 2779,
              pid: 2777,
              name: "黄平县",
            },
            {
              id: 2780,
              pid: 2777,
              name: "施秉县",
            },
            {
              id: 2781,
              pid: 2777,
              name: "三穗县",
            },
            {
              id: 2782,
              pid: 2777,
              name: "镇远县",
            },
            {
              id: 2783,
              pid: 2777,
              name: "岑巩县",
            },
            {
              id: 2784,
              pid: 2777,
              name: "天柱县",
            },
            {
              id: 2785,
              pid: 2777,
              name: "锦屏县",
            },
            {
              id: 2786,
              pid: 2777,
              name: "剑河县",
            },
            {
              id: 2787,
              pid: 2777,
              name: "台江县",
            },
            {
              id: 2788,
              pid: 2777,
              name: "黎平县",
            },
            {
              id: 2789,
              pid: 2777,
              name: "榕江县",
            },
            {
              id: 2790,
              pid: 2777,
              name: "从江县",
            },
            {
              id: 2791,
              pid: 2777,
              name: "雷山县",
            },
            {
              id: 2792,
              pid: 2777,
              name: "麻江县",
            },
            {
              id: 2793,
              pid: 2777,
              name: "丹寨县",
            },
          ],
        },
        {
          id: 2794,
          pid: 2706,
          name: "黔南布依族苗族自治州",
          children: [
            {
              id: 2795,
              pid: 2794,
              name: "都匀市",
            },
            {
              id: 2796,
              pid: 2794,
              name: "福泉市",
            },
            {
              id: 2797,
              pid: 2794,
              name: "荔波县",
            },
            {
              id: 2798,
              pid: 2794,
              name: "贵定县",
            },
            {
              id: 2799,
              pid: 2794,
              name: "瓮安县",
            },
            {
              id: 2800,
              pid: 2794,
              name: "独山县",
            },
            {
              id: 2801,
              pid: 2794,
              name: "平塘县",
            },
            {
              id: 2802,
              pid: 2794,
              name: "罗甸县",
            },
            {
              id: 2803,
              pid: 2794,
              name: "长顺县",
            },
            {
              id: 2804,
              pid: 2794,
              name: "龙里县",
            },
            {
              id: 2805,
              pid: 2794,
              name: "惠水县",
            },
            {
              id: 2806,
              pid: 2794,
              name: "三都水族自治县",
            },
          ],
        },
      ],
    },
    {
      id: 2807,
      pid: 1,
      name: "云南省",
      children: [
        {
          id: 2808,
          pid: 2807,
          name: "昆明市",
          children: [
            {
              id: 2810,
              pid: 2808,
              name: "五华区",
            },
            {
              id: 2811,
              pid: 2808,
              name: "盘龙区",
            },
            {
              id: 2812,
              pid: 2808,
              name: "官渡区",
            },
            {
              id: 2813,
              pid: 2808,
              name: "西山区",
            },
            {
              id: 2814,
              pid: 2808,
              name: "东川区",
            },
            {
              id: 2815,
              pid: 2808,
              name: "呈贡区",
            },
            {
              id: 2816,
              pid: 2808,
              name: "晋宁区",
            },
            {
              id: 2817,
              pid: 2808,
              name: "富民县",
            },
            {
              id: 2818,
              pid: 2808,
              name: "宜良县",
            },
            {
              id: 2819,
              pid: 2808,
              name: "石林彝族自治县",
            },
            {
              id: 2820,
              pid: 2808,
              name: "嵩明县",
            },
            {
              id: 2821,
              pid: 2808,
              name: "禄劝彝族苗族自治县",
            },
            {
              id: 2822,
              pid: 2808,
              name: "寻甸回族彝族自治县",
            },
            {
              id: 2823,
              pid: 2808,
              name: "安宁市",
            },
          ],
        },
        {
          id: 2824,
          pid: 2807,
          name: "曲靖市",
          children: [
            {
              id: 2826,
              pid: 2824,
              name: "麒麟区",
            },
            {
              id: 2827,
              pid: 2824,
              name: "沾益区",
            },
            {
              id: 2828,
              pid: 2824,
              name: "马龙区",
            },
            {
              id: 2829,
              pid: 2824,
              name: "陆良县",
            },
            {
              id: 2830,
              pid: 2824,
              name: "师宗县",
            },
            {
              id: 2831,
              pid: 2824,
              name: "罗平县",
            },
            {
              id: 2832,
              pid: 2824,
              name: "富源县",
            },
            {
              id: 2833,
              pid: 2824,
              name: "会泽县",
            },
            {
              id: 2834,
              pid: 2824,
              name: "宣威市",
            },
          ],
        },
        {
          id: 2835,
          pid: 2807,
          name: "玉溪市",
          children: [
            {
              id: 2837,
              pid: 2835,
              name: "红塔区",
            },
            {
              id: 2838,
              pid: 2835,
              name: "江川区",
            },
            {
              id: 2839,
              pid: 2835,
              name: "澄江市",
            },
            {
              id: 2840,
              pid: 2835,
              name: "通海县",
            },
            {
              id: 2841,
              pid: 2835,
              name: "华宁县",
            },
            {
              id: 2842,
              pid: 2835,
              name: "易门县",
            },
            {
              id: 2843,
              pid: 2835,
              name: "峨山彝族自治县",
            },
            {
              id: 2844,
              pid: 2835,
              name: "新平彝族傣族自治县",
            },
            {
              id: 2845,
              pid: 2835,
              name: "元江哈尼族彝族傣族自治县",
            },
          ],
        },
        {
          id: 2846,
          pid: 2807,
          name: "保山市",
          children: [
            {
              id: 2848,
              pid: 2846,
              name: "隆阳区",
            },
            {
              id: 2849,
              pid: 2846,
              name: "施甸县",
            },
            {
              id: 2850,
              pid: 2846,
              name: "龙陵县",
            },
            {
              id: 2851,
              pid: 2846,
              name: "昌宁县",
            },
            {
              id: 2852,
              pid: 2846,
              name: "腾冲市",
            },
          ],
        },
        {
          id: 2853,
          pid: 2807,
          name: "昭通市",
          children: [
            {
              id: 2855,
              pid: 2853,
              name: "昭阳区",
            },
            {
              id: 2856,
              pid: 2853,
              name: "鲁甸县",
            },
            {
              id: 2857,
              pid: 2853,
              name: "巧家县",
            },
            {
              id: 2858,
              pid: 2853,
              name: "盐津县",
            },
            {
              id: 2859,
              pid: 2853,
              name: "大关县",
            },
            {
              id: 2860,
              pid: 2853,
              name: "永善县",
            },
            {
              id: 2861,
              pid: 2853,
              name: "绥江县",
            },
            {
              id: 2862,
              pid: 2853,
              name: "镇雄县",
            },
            {
              id: 2863,
              pid: 2853,
              name: "彝良县",
            },
            {
              id: 2864,
              pid: 2853,
              name: "威信县",
            },
            {
              id: 2865,
              pid: 2853,
              name: "水富市",
            },
          ],
        },
        {
          id: 2866,
          pid: 2807,
          name: "丽江市",
          children: [
            {
              id: 2868,
              pid: 2866,
              name: "古城区",
            },
            {
              id: 2869,
              pid: 2866,
              name: "玉龙纳西族自治县",
            },
            {
              id: 2870,
              pid: 2866,
              name: "永胜县",
            },
            {
              id: 2871,
              pid: 2866,
              name: "华坪县",
            },
            {
              id: 2872,
              pid: 2866,
              name: "宁蒗彝族自治县",
            },
          ],
        },
        {
          id: 2873,
          pid: 2807,
          name: "普洱市",
          children: [
            {
              id: 2875,
              pid: 2873,
              name: "思茅区",
            },
            {
              id: 2876,
              pid: 2873,
              name: "宁洱哈尼族彝族自治县",
            },
            {
              id: 2877,
              pid: 2873,
              name: "墨江哈尼族自治县",
            },
            {
              id: 2878,
              pid: 2873,
              name: "景东彝族自治县",
            },
            {
              id: 2879,
              pid: 2873,
              name: "景谷傣族彝族自治县",
            },
            {
              id: 2880,
              pid: 2873,
              name: "镇沅彝族哈尼族拉祜族自治县",
            },
            {
              id: 2881,
              pid: 2873,
              name: "江城哈尼族彝族自治县",
            },
            {
              id: 2882,
              pid: 2873,
              name: "孟连傣族拉祜族佤族自治县",
            },
            {
              id: 2883,
              pid: 2873,
              name: "澜沧拉祜族自治县",
            },
            {
              id: 2884,
              pid: 2873,
              name: "西盟佤族自治县",
            },
          ],
        },
        {
          id: 2885,
          pid: 2807,
          name: "临沧市",
          children: [
            {
              id: 2887,
              pid: 2885,
              name: "临翔区",
            },
            {
              id: 2888,
              pid: 2885,
              name: "凤庆县",
            },
            {
              id: 2889,
              pid: 2885,
              name: "云县",
            },
            {
              id: 2890,
              pid: 2885,
              name: "永德县",
            },
            {
              id: 2891,
              pid: 2885,
              name: "镇康县",
            },
            {
              id: 2892,
              pid: 2885,
              name: "双江拉祜族佤族布朗族傣族自治县",
            },
            {
              id: 2893,
              pid: 2885,
              name: "耿马傣族佤族自治县",
            },
            {
              id: 2894,
              pid: 2885,
              name: "沧源佤族自治县",
            },
          ],
        },
        {
          id: 2895,
          pid: 2807,
          name: "楚雄彝族自治州",
          children: [
            {
              id: 2896,
              pid: 2895,
              name: "楚雄市",
            },
            {
              id: 2897,
              pid: 2895,
              name: "双柏县",
            },
            {
              id: 2898,
              pid: 2895,
              name: "牟定县",
            },
            {
              id: 2899,
              pid: 2895,
              name: "南华县",
            },
            {
              id: 2900,
              pid: 2895,
              name: "姚安县",
            },
            {
              id: 2901,
              pid: 2895,
              name: "大姚县",
            },
            {
              id: 2902,
              pid: 2895,
              name: "永仁县",
            },
            {
              id: 2903,
              pid: 2895,
              name: "元谋县",
            },
            {
              id: 2904,
              pid: 2895,
              name: "武定县",
            },
            {
              id: 2905,
              pid: 2895,
              name: "禄丰县",
            },
          ],
        },
        {
          id: 2906,
          pid: 2807,
          name: "红河哈尼族彝族自治州",
          children: [
            {
              id: 2907,
              pid: 2906,
              name: "个旧市",
            },
            {
              id: 2908,
              pid: 2906,
              name: "开远市",
            },
            {
              id: 2909,
              pid: 2906,
              name: "蒙自市",
            },
            {
              id: 2910,
              pid: 2906,
              name: "弥勒市",
            },
            {
              id: 2911,
              pid: 2906,
              name: "屏边苗族自治县",
            },
            {
              id: 2912,
              pid: 2906,
              name: "建水县",
            },
            {
              id: 2913,
              pid: 2906,
              name: "石屏县",
            },
            {
              id: 2914,
              pid: 2906,
              name: "泸西县",
            },
            {
              id: 2915,
              pid: 2906,
              name: "元阳县",
            },
            {
              id: 2916,
              pid: 2906,
              name: "红河县",
            },
            {
              id: 2917,
              pid: 2906,
              name: "金平苗族瑶族傣族自治县",
            },
            {
              id: 2918,
              pid: 2906,
              name: "绿春县",
            },
            {
              id: 2919,
              pid: 2906,
              name: "河口瑶族自治县",
            },
          ],
        },
        {
          id: 2920,
          pid: 2807,
          name: "文山壮族苗族自治州",
          children: [
            {
              id: 2921,
              pid: 2920,
              name: "文山市",
            },
            {
              id: 2922,
              pid: 2920,
              name: "砚山县",
            },
            {
              id: 2923,
              pid: 2920,
              name: "西畴县",
            },
            {
              id: 2924,
              pid: 2920,
              name: "麻栗坡县",
            },
            {
              id: 2925,
              pid: 2920,
              name: "马关县",
            },
            {
              id: 2926,
              pid: 2920,
              name: "丘北县",
            },
            {
              id: 2927,
              pid: 2920,
              name: "广南县",
            },
            {
              id: 2928,
              pid: 2920,
              name: "富宁县",
            },
          ],
        },
        {
          id: 2929,
          pid: 2807,
          name: "西双版纳傣族自治州",
          children: [
            {
              id: 2930,
              pid: 2929,
              name: "景洪市",
            },
            {
              id: 2931,
              pid: 2929,
              name: "勐海县",
            },
            {
              id: 2932,
              pid: 2929,
              name: "勐腊县",
            },
          ],
        },
        {
          id: 2933,
          pid: 2807,
          name: "大理白族自治州",
          children: [
            {
              id: 2934,
              pid: 2933,
              name: "大理市",
            },
            {
              id: 2935,
              pid: 2933,
              name: "漾濞彝族自治县",
            },
            {
              id: 2936,
              pid: 2933,
              name: "祥云县",
            },
            {
              id: 2937,
              pid: 2933,
              name: "宾川县",
            },
            {
              id: 2938,
              pid: 2933,
              name: "弥渡县",
            },
            {
              id: 2939,
              pid: 2933,
              name: "南涧彝族自治县",
            },
            {
              id: 2940,
              pid: 2933,
              name: "巍山彝族回族自治县",
            },
            {
              id: 2941,
              pid: 2933,
              name: "永平县",
            },
            {
              id: 2942,
              pid: 2933,
              name: "云龙县",
            },
            {
              id: 2943,
              pid: 2933,
              name: "洱源县",
            },
            {
              id: 2944,
              pid: 2933,
              name: "剑川县",
            },
            {
              id: 2945,
              pid: 2933,
              name: "鹤庆县",
            },
          ],
        },
        {
          id: 2946,
          pid: 2807,
          name: "德宏傣族景颇族自治州",
          children: [
            {
              id: 2947,
              pid: 2946,
              name: "瑞丽市",
            },
            {
              id: 2948,
              pid: 2946,
              name: "芒市",
            },
            {
              id: 2949,
              pid: 2946,
              name: "梁河县",
            },
            {
              id: 2950,
              pid: 2946,
              name: "盈江县",
            },
            {
              id: 2951,
              pid: 2946,
              name: "陇川县",
            },
          ],
        },
        {
          id: 2952,
          pid: 2807,
          name: "怒江傈僳族自治州",
          children: [
            {
              id: 2953,
              pid: 2952,
              name: "泸水市",
            },
            {
              id: 2954,
              pid: 2952,
              name: "福贡县",
            },
            {
              id: 2955,
              pid: 2952,
              name: "贡山独龙族怒族自治县",
            },
            {
              id: 2956,
              pid: 2952,
              name: "兰坪白族普米族自治县",
            },
          ],
        },
        {
          id: 2957,
          pid: 2807,
          name: "迪庆藏族自治州",
          children: [
            {
              id: 2958,
              pid: 2957,
              name: "香格里拉市",
            },
            {
              id: 2959,
              pid: 2957,
              name: "德钦县",
            },
            {
              id: 2960,
              pid: 2957,
              name: "维西傈僳族自治县",
            },
          ],
        },
      ],
    },
    {
      id: 2961,
      pid: 1,
      name: "西藏自治区",
      children: [
        {
          id: 2962,
          pid: 2961,
          name: "拉萨市",
          children: [
            {
              id: 2964,
              pid: 2962,
              name: "城关区",
            },
            {
              id: 2965,
              pid: 2962,
              name: "堆龙德庆区",
            },
            {
              id: 2966,
              pid: 2962,
              name: "达孜区",
            },
            {
              id: 2967,
              pid: 2962,
              name: "林周县",
            },
            {
              id: 2968,
              pid: 2962,
              name: "当雄县",
            },
            {
              id: 2969,
              pid: 2962,
              name: "尼木县",
            },
            {
              id: 2970,
              pid: 2962,
              name: "曲水县",
            },
            {
              id: 2971,
              pid: 2962,
              name: "墨竹工卡县",
            },
          ],
        },
        {
          id: 2972,
          pid: 2961,
          name: "日喀则市",
          children: [
            {
              id: 2973,
              pid: 2972,
              name: "桑珠孜区",
            },
            {
              id: 2974,
              pid: 2972,
              name: "南木林县",
            },
            {
              id: 2975,
              pid: 2972,
              name: "江孜县",
            },
            {
              id: 2976,
              pid: 2972,
              name: "定日县",
            },
            {
              id: 2977,
              pid: 2972,
              name: "萨迦县",
            },
            {
              id: 2978,
              pid: 2972,
              name: "拉孜县",
            },
            {
              id: 2979,
              pid: 2972,
              name: "昂仁县",
            },
            {
              id: 2980,
              pid: 2972,
              name: "谢通门县",
            },
            {
              id: 2981,
              pid: 2972,
              name: "白朗县",
            },
            {
              id: 2982,
              pid: 2972,
              name: "仁布县",
            },
            {
              id: 2983,
              pid: 2972,
              name: "康马县",
            },
            {
              id: 2984,
              pid: 2972,
              name: "定结县",
            },
            {
              id: 2985,
              pid: 2972,
              name: "仲巴县",
            },
            {
              id: 2986,
              pid: 2972,
              name: "亚东县",
            },
            {
              id: 2987,
              pid: 2972,
              name: "吉隆县",
            },
            {
              id: 2988,
              pid: 2972,
              name: "聂拉木县",
            },
            {
              id: 2989,
              pid: 2972,
              name: "萨嘎县",
            },
            {
              id: 2990,
              pid: 2972,
              name: "岗巴县",
            },
          ],
        },
        {
          id: 2991,
          pid: 2961,
          name: "昌都市",
          children: [
            {
              id: 2992,
              pid: 2991,
              name: "卡若区",
            },
            {
              id: 2993,
              pid: 2991,
              name: "江达县",
            },
            {
              id: 2994,
              pid: 2991,
              name: "贡觉县",
            },
            {
              id: 2995,
              pid: 2991,
              name: "类乌齐县",
            },
            {
              id: 2996,
              pid: 2991,
              name: "丁青县",
            },
            {
              id: 2997,
              pid: 2991,
              name: "察雅县",
            },
            {
              id: 2998,
              pid: 2991,
              name: "八宿县",
            },
            {
              id: 2999,
              pid: 2991,
              name: "左贡县",
            },
            {
              id: 3e3,
              pid: 2991,
              name: "芒康县",
            },
            {
              id: 3001,
              pid: 2991,
              name: "洛隆县",
            },
            {
              id: 3002,
              pid: 2991,
              name: "边坝县",
            },
          ],
        },
        {
          id: 3003,
          pid: 2961,
          name: "林芝市",
          children: [
            {
              id: 3004,
              pid: 3003,
              name: "巴宜区",
            },
            {
              id: 3005,
              pid: 3003,
              name: "工布江达县",
            },
            {
              id: 3006,
              pid: 3003,
              name: "米林县",
            },
            {
              id: 3007,
              pid: 3003,
              name: "墨脱县",
            },
            {
              id: 3008,
              pid: 3003,
              name: "波密县",
            },
            {
              id: 3009,
              pid: 3003,
              name: "察隅县",
            },
            {
              id: 3010,
              pid: 3003,
              name: "朗县",
            },
          ],
        },
        {
          id: 3011,
          pid: 2961,
          name: "山南市",
          children: [
            {
              id: 3012,
              pid: 3011,
              name: "乃东区",
            },
            {
              id: 3013,
              pid: 3011,
              name: "扎囊县",
            },
            {
              id: 3014,
              pid: 3011,
              name: "贡嘎县",
            },
            {
              id: 3015,
              pid: 3011,
              name: "桑日县",
            },
            {
              id: 3016,
              pid: 3011,
              name: "琼结县",
            },
            {
              id: 3017,
              pid: 3011,
              name: "曲松县",
            },
            {
              id: 3018,
              pid: 3011,
              name: "措美县",
            },
            {
              id: 3019,
              pid: 3011,
              name: "洛扎县",
            },
            {
              id: 3020,
              pid: 3011,
              name: "加查县",
            },
            {
              id: 3021,
              pid: 3011,
              name: "隆子县",
            },
            {
              id: 3022,
              pid: 3011,
              name: "错那县",
            },
            {
              id: 3023,
              pid: 3011,
              name: "浪卡子县",
            },
          ],
        },
        {
          id: 3024,
          pid: 2961,
          name: "那曲市",
          children: [
            {
              id: 3025,
              pid: 3024,
              name: "色尼区",
            },
            {
              id: 3026,
              pid: 3024,
              name: "嘉黎县",
            },
            {
              id: 3027,
              pid: 3024,
              name: "比如县",
            },
            {
              id: 3028,
              pid: 3024,
              name: "聂荣县",
            },
            {
              id: 3029,
              pid: 3024,
              name: "安多县",
            },
            {
              id: 3030,
              pid: 3024,
              name: "申扎县",
            },
            {
              id: 3031,
              pid: 3024,
              name: "索县",
            },
            {
              id: 3032,
              pid: 3024,
              name: "班戈县",
            },
            {
              id: 3033,
              pid: 3024,
              name: "巴青县",
            },
            {
              id: 3034,
              pid: 3024,
              name: "尼玛县",
            },
            {
              id: 3035,
              pid: 3024,
              name: "双湖县",
            },
          ],
        },
        {
          id: 3036,
          pid: 2961,
          name: "阿里地区",
          children: [
            {
              id: 3037,
              pid: 3036,
              name: "普兰县",
            },
            {
              id: 3038,
              pid: 3036,
              name: "札达县",
            },
            {
              id: 3039,
              pid: 3036,
              name: "噶尔县",
            },
            {
              id: 3040,
              pid: 3036,
              name: "日土县",
            },
            {
              id: 3041,
              pid: 3036,
              name: "革吉县",
            },
            {
              id: 3042,
              pid: 3036,
              name: "改则县",
            },
            {
              id: 3043,
              pid: 3036,
              name: "措勤县",
            },
          ],
        },
      ],
    },
    {
      id: 3044,
      pid: 1,
      name: "陕西省",
      children: [
        {
          id: 3045,
          pid: 3044,
          name: "西安市",
          children: [
            {
              id: 3047,
              pid: 3045,
              name: "新城区",
            },
            {
              id: 3048,
              pid: 3045,
              name: "碑林区",
            },
            {
              id: 3049,
              pid: 3045,
              name: "莲湖区",
            },
            {
              id: 3050,
              pid: 3045,
              name: "灞桥区",
            },
            {
              id: 3051,
              pid: 3045,
              name: "未央区",
            },
            {
              id: 3052,
              pid: 3045,
              name: "雁塔区",
            },
            {
              id: 3053,
              pid: 3045,
              name: "阎良区",
            },
            {
              id: 3054,
              pid: 3045,
              name: "临潼区",
            },
            {
              id: 3055,
              pid: 3045,
              name: "长安区",
            },
            {
              id: 3056,
              pid: 3045,
              name: "高陵区",
            },
            {
              id: 3057,
              pid: 3045,
              name: "鄠邑区",
            },
            {
              id: 3058,
              pid: 3045,
              name: "蓝田县",
            },
            {
              id: 3059,
              pid: 3045,
              name: "周至县",
            },
          ],
        },
        {
          id: 3060,
          pid: 3044,
          name: "铜川市",
          children: [
            {
              id: 3062,
              pid: 3060,
              name: "王益区",
            },
            {
              id: 3063,
              pid: 3060,
              name: "印台区",
            },
            {
              id: 3064,
              pid: 3060,
              name: "耀州区",
            },
            {
              id: 3065,
              pid: 3060,
              name: "宜君县",
            },
          ],
        },
        {
          id: 3066,
          pid: 3044,
          name: "宝鸡市",
          children: [
            {
              id: 3068,
              pid: 3066,
              name: "渭滨区",
            },
            {
              id: 3069,
              pid: 3066,
              name: "金台区",
            },
            {
              id: 3070,
              pid: 3066,
              name: "陈仓区",
            },
            {
              id: 3071,
              pid: 3066,
              name: "凤翔县",
            },
            {
              id: 3072,
              pid: 3066,
              name: "岐山县",
            },
            {
              id: 3073,
              pid: 3066,
              name: "扶风县",
            },
            {
              id: 3074,
              pid: 3066,
              name: "眉县",
            },
            {
              id: 3075,
              pid: 3066,
              name: "陇县",
            },
            {
              id: 3076,
              pid: 3066,
              name: "千阳县",
            },
            {
              id: 3077,
              pid: 3066,
              name: "麟游县",
            },
            {
              id: 3078,
              pid: 3066,
              name: "凤县",
            },
            {
              id: 3079,
              pid: 3066,
              name: "太白县",
            },
          ],
        },
        {
          id: 3080,
          pid: 3044,
          name: "咸阳市",
          children: [
            {
              id: 3082,
              pid: 3080,
              name: "秦都区",
            },
            {
              id: 3083,
              pid: 3080,
              name: "杨陵区",
            },
            {
              id: 3084,
              pid: 3080,
              name: "渭城区",
            },
            {
              id: 3085,
              pid: 3080,
              name: "三原县",
            },
            {
              id: 3086,
              pid: 3080,
              name: "泾阳县",
            },
            {
              id: 3087,
              pid: 3080,
              name: "乾县",
            },
            {
              id: 3088,
              pid: 3080,
              name: "礼泉县",
            },
            {
              id: 3089,
              pid: 3080,
              name: "永寿县",
            },
            {
              id: 3090,
              pid: 3080,
              name: "彬州市",
            },
            {
              id: 3091,
              pid: 3080,
              name: "长武县",
            },
            {
              id: 3092,
              pid: 3080,
              name: "旬邑县",
            },
            {
              id: 3093,
              pid: 3080,
              name: "淳化县",
            },
            {
              id: 3094,
              pid: 3080,
              name: "武功县",
            },
            {
              id: 3095,
              pid: 3080,
              name: "兴平市",
            },
          ],
        },
        {
          id: 3096,
          pid: 3044,
          name: "渭南市",
          children: [
            {
              id: 3098,
              pid: 3096,
              name: "临渭区",
            },
            {
              id: 3099,
              pid: 3096,
              name: "华州区",
            },
            {
              id: 3100,
              pid: 3096,
              name: "潼关县",
            },
            {
              id: 3101,
              pid: 3096,
              name: "大荔县",
            },
            {
              id: 3102,
              pid: 3096,
              name: "合阳县",
            },
            {
              id: 3103,
              pid: 3096,
              name: "澄城县",
            },
            {
              id: 3104,
              pid: 3096,
              name: "蒲城县",
            },
            {
              id: 3105,
              pid: 3096,
              name: "白水县",
            },
            {
              id: 3106,
              pid: 3096,
              name: "富平县",
            },
            {
              id: 3107,
              pid: 3096,
              name: "韩城市",
            },
            {
              id: 3108,
              pid: 3096,
              name: "华阴市",
            },
          ],
        },
        {
          id: 3109,
          pid: 3044,
          name: "延安市",
          children: [
            {
              id: 3111,
              pid: 3109,
              name: "宝塔区",
            },
            {
              id: 3112,
              pid: 3109,
              name: "安塞区",
            },
            {
              id: 3113,
              pid: 3109,
              name: "延长县",
            },
            {
              id: 3114,
              pid: 3109,
              name: "延川县",
            },
            {
              id: 3115,
              pid: 3109,
              name: "子长市",
            },
            {
              id: 3116,
              pid: 3109,
              name: "志丹县",
            },
            {
              id: 3117,
              pid: 3109,
              name: "吴起县",
            },
            {
              id: 3118,
              pid: 3109,
              name: "甘泉县",
            },
            {
              id: 3119,
              pid: 3109,
              name: "富县",
            },
            {
              id: 3120,
              pid: 3109,
              name: "洛川县",
            },
            {
              id: 3121,
              pid: 3109,
              name: "宜川县",
            },
            {
              id: 3122,
              pid: 3109,
              name: "黄龙县",
            },
            {
              id: 3123,
              pid: 3109,
              name: "黄陵县",
            },
          ],
        },
        {
          id: 3124,
          pid: 3044,
          name: "汉中市",
          children: [
            {
              id: 3126,
              pid: 3124,
              name: "汉台区",
            },
            {
              id: 3127,
              pid: 3124,
              name: "南郑区",
            },
            {
              id: 3128,
              pid: 3124,
              name: "城固县",
            },
            {
              id: 3129,
              pid: 3124,
              name: "洋县",
            },
            {
              id: 3130,
              pid: 3124,
              name: "西乡县",
            },
            {
              id: 3131,
              pid: 3124,
              name: "勉县",
            },
            {
              id: 3132,
              pid: 3124,
              name: "宁强县",
            },
            {
              id: 3133,
              pid: 3124,
              name: "略阳县",
            },
            {
              id: 3134,
              pid: 3124,
              name: "镇巴县",
            },
            {
              id: 3135,
              pid: 3124,
              name: "留坝县",
            },
            {
              id: 3136,
              pid: 3124,
              name: "佛坪县",
            },
          ],
        },
        {
          id: 3137,
          pid: 3044,
          name: "榆林市",
          children: [
            {
              id: 3139,
              pid: 3137,
              name: "榆阳区",
            },
            {
              id: 3140,
              pid: 3137,
              name: "横山区",
            },
            {
              id: 3141,
              pid: 3137,
              name: "府谷县",
            },
            {
              id: 3142,
              pid: 3137,
              name: "靖边县",
            },
            {
              id: 3143,
              pid: 3137,
              name: "定边县",
            },
            {
              id: 3144,
              pid: 3137,
              name: "绥德县",
            },
            {
              id: 3145,
              pid: 3137,
              name: "米脂县",
            },
            {
              id: 3146,
              pid: 3137,
              name: "佳县",
            },
            {
              id: 3147,
              pid: 3137,
              name: "吴堡县",
            },
            {
              id: 3148,
              pid: 3137,
              name: "清涧县",
            },
            {
              id: 3149,
              pid: 3137,
              name: "子洲县",
            },
            {
              id: 3150,
              pid: 3137,
              name: "神木市",
            },
          ],
        },
        {
          id: 3151,
          pid: 3044,
          name: "安康市",
          children: [
            {
              id: 3153,
              pid: 3151,
              name: "汉滨区",
            },
            {
              id: 3154,
              pid: 3151,
              name: "汉阴县",
            },
            {
              id: 3155,
              pid: 3151,
              name: "石泉县",
            },
            {
              id: 3156,
              pid: 3151,
              name: "宁陕县",
            },
            {
              id: 3157,
              pid: 3151,
              name: "紫阳县",
            },
            {
              id: 3158,
              pid: 3151,
              name: "岚皋县",
            },
            {
              id: 3159,
              pid: 3151,
              name: "平利县",
            },
            {
              id: 3160,
              pid: 3151,
              name: "镇坪县",
            },
            {
              id: 3161,
              pid: 3151,
              name: "旬阳县",
            },
            {
              id: 3162,
              pid: 3151,
              name: "白河县",
            },
          ],
        },
        {
          id: 3163,
          pid: 3044,
          name: "商洛市",
          children: [
            {
              id: 3165,
              pid: 3163,
              name: "商州区",
            },
            {
              id: 3166,
              pid: 3163,
              name: "洛南县",
            },
            {
              id: 3167,
              pid: 3163,
              name: "丹凤县",
            },
            {
              id: 3168,
              pid: 3163,
              name: "商南县",
            },
            {
              id: 3169,
              pid: 3163,
              name: "山阳县",
            },
            {
              id: 3170,
              pid: 3163,
              name: "镇安县",
            },
            {
              id: 3171,
              pid: 3163,
              name: "柞水县",
            },
          ],
        },
      ],
    },
    {
      id: 3172,
      pid: 1,
      name: "甘肃省",
      children: [
        {
          id: 3173,
          pid: 3172,
          name: "兰州市",
          children: [
            {
              id: 3175,
              pid: 3173,
              name: "城关区",
            },
            {
              id: 3176,
              pid: 3173,
              name: "七里河区",
            },
            {
              id: 3177,
              pid: 3173,
              name: "西固区",
            },
            {
              id: 3178,
              pid: 3173,
              name: "安宁区",
            },
            {
              id: 3179,
              pid: 3173,
              name: "红古区",
            },
            {
              id: 3180,
              pid: 3173,
              name: "永登县",
            },
            {
              id: 3181,
              pid: 3173,
              name: "皋兰县",
            },
            {
              id: 3182,
              pid: 3173,
              name: "榆中县",
            },
          ],
        },
        {
          id: 3183,
          pid: 3172,
          name: "嘉峪关市",
          children: [
            {
              id: 3922,
              pid: 3183,
              name: "嘉峪关市",
            },
          ],
        },
        {
          id: 3185,
          pid: 3172,
          name: "金昌市",
          children: [
            {
              id: 3187,
              pid: 3185,
              name: "金川区",
            },
            {
              id: 3188,
              pid: 3185,
              name: "永昌县",
            },
          ],
        },
        {
          id: 3189,
          pid: 3172,
          name: "白银市",
          children: [
            {
              id: 3191,
              pid: 3189,
              name: "白银区",
            },
            {
              id: 3192,
              pid: 3189,
              name: "平川区",
            },
            {
              id: 3193,
              pid: 3189,
              name: "靖远县",
            },
            {
              id: 3194,
              pid: 3189,
              name: "会宁县",
            },
            {
              id: 3195,
              pid: 3189,
              name: "景泰县",
            },
          ],
        },
        {
          id: 3196,
          pid: 3172,
          name: "天水市",
          children: [
            {
              id: 3198,
              pid: 3196,
              name: "秦州区",
            },
            {
              id: 3199,
              pid: 3196,
              name: "麦积区",
            },
            {
              id: 3200,
              pid: 3196,
              name: "清水县",
            },
            {
              id: 3201,
              pid: 3196,
              name: "秦安县",
            },
            {
              id: 3202,
              pid: 3196,
              name: "甘谷县",
            },
            {
              id: 3203,
              pid: 3196,
              name: "武山县",
            },
            {
              id: 3204,
              pid: 3196,
              name: "张家川回族自治县",
            },
          ],
        },
        {
          id: 3205,
          pid: 3172,
          name: "武威市",
          children: [
            {
              id: 3207,
              pid: 3205,
              name: "凉州区",
            },
            {
              id: 3208,
              pid: 3205,
              name: "民勤县",
            },
            {
              id: 3209,
              pid: 3205,
              name: "古浪县",
            },
            {
              id: 3210,
              pid: 3205,
              name: "天祝藏族自治县",
            },
          ],
        },
        {
          id: 3211,
          pid: 3172,
          name: "张掖市",
          children: [
            {
              id: 3213,
              pid: 3211,
              name: "甘州区",
            },
            {
              id: 3214,
              pid: 3211,
              name: "肃南裕固族自治县",
            },
            {
              id: 3215,
              pid: 3211,
              name: "民乐县",
            },
            {
              id: 3216,
              pid: 3211,
              name: "临泽县",
            },
            {
              id: 3217,
              pid: 3211,
              name: "高台县",
            },
            {
              id: 3218,
              pid: 3211,
              name: "山丹县",
            },
          ],
        },
        {
          id: 3219,
          pid: 3172,
          name: "平凉市",
          children: [
            {
              id: 3221,
              pid: 3219,
              name: "崆峒区",
            },
            {
              id: 3222,
              pid: 3219,
              name: "泾川县",
            },
            {
              id: 3223,
              pid: 3219,
              name: "灵台县",
            },
            {
              id: 3224,
              pid: 3219,
              name: "崇信县",
            },
            {
              id: 3225,
              pid: 3219,
              name: "华亭市",
            },
            {
              id: 3226,
              pid: 3219,
              name: "庄浪县",
            },
            {
              id: 3227,
              pid: 3219,
              name: "静宁县",
            },
          ],
        },
        {
          id: 3228,
          pid: 3172,
          name: "酒泉市",
          children: [
            {
              id: 3230,
              pid: 3228,
              name: "肃州区",
            },
            {
              id: 3231,
              pid: 3228,
              name: "金塔县",
            },
            {
              id: 3232,
              pid: 3228,
              name: "瓜州县",
            },
            {
              id: 3233,
              pid: 3228,
              name: "肃北蒙古族自治县",
            },
            {
              id: 3234,
              pid: 3228,
              name: "阿克塞哈萨克族自治县",
            },
            {
              id: 3235,
              pid: 3228,
              name: "玉门市",
            },
            {
              id: 3236,
              pid: 3228,
              name: "敦煌市",
            },
          ],
        },
        {
          id: 3237,
          pid: 3172,
          name: "庆阳市",
          children: [
            {
              id: 3239,
              pid: 3237,
              name: "西峰区",
            },
            {
              id: 3240,
              pid: 3237,
              name: "庆城县",
            },
            {
              id: 3241,
              pid: 3237,
              name: "环县",
            },
            {
              id: 3242,
              pid: 3237,
              name: "华池县",
            },
            {
              id: 3243,
              pid: 3237,
              name: "合水县",
            },
            {
              id: 3244,
              pid: 3237,
              name: "正宁县",
            },
            {
              id: 3245,
              pid: 3237,
              name: "宁县",
            },
            {
              id: 3246,
              pid: 3237,
              name: "镇原县",
            },
          ],
        },
        {
          id: 3247,
          pid: 3172,
          name: "定西市",
          children: [
            {
              id: 3249,
              pid: 3247,
              name: "安定区",
            },
            {
              id: 3250,
              pid: 3247,
              name: "通渭县",
            },
            {
              id: 3251,
              pid: 3247,
              name: "陇西县",
            },
            {
              id: 3252,
              pid: 3247,
              name: "渭源县",
            },
            {
              id: 3253,
              pid: 3247,
              name: "临洮县",
            },
            {
              id: 3254,
              pid: 3247,
              name: "漳县",
            },
            {
              id: 3255,
              pid: 3247,
              name: "岷县",
            },
          ],
        },
        {
          id: 3256,
          pid: 3172,
          name: "陇南市",
          children: [
            {
              id: 3258,
              pid: 3256,
              name: "武都区",
            },
            {
              id: 3259,
              pid: 3256,
              name: "成县",
            },
            {
              id: 3260,
              pid: 3256,
              name: "文县",
            },
            {
              id: 3261,
              pid: 3256,
              name: "宕昌县",
            },
            {
              id: 3262,
              pid: 3256,
              name: "康县",
            },
            {
              id: 3263,
              pid: 3256,
              name: "西和县",
            },
            {
              id: 3264,
              pid: 3256,
              name: "礼县",
            },
            {
              id: 3265,
              pid: 3256,
              name: "徽县",
            },
            {
              id: 3266,
              pid: 3256,
              name: "两当县",
            },
          ],
        },
        {
          id: 3267,
          pid: 3172,
          name: "临夏回族自治州",
          children: [
            {
              id: 3268,
              pid: 3267,
              name: "临夏市",
            },
            {
              id: 3269,
              pid: 3267,
              name: "临夏县",
            },
            {
              id: 3270,
              pid: 3267,
              name: "康乐县",
            },
            {
              id: 3271,
              pid: 3267,
              name: "永靖县",
            },
            {
              id: 3272,
              pid: 3267,
              name: "广河县",
            },
            {
              id: 3273,
              pid: 3267,
              name: "和政县",
            },
            {
              id: 3274,
              pid: 3267,
              name: "东乡族自治县",
            },
            {
              id: 3275,
              pid: 3267,
              name: "积石山保安族东乡族撒拉族自治县",
            },
          ],
        },
        {
          id: 3276,
          pid: 3172,
          name: "甘南藏族自治州",
          children: [
            {
              id: 3277,
              pid: 3276,
              name: "合作市",
            },
            {
              id: 3278,
              pid: 3276,
              name: "临潭县",
            },
            {
              id: 3279,
              pid: 3276,
              name: "卓尼县",
            },
            {
              id: 3280,
              pid: 3276,
              name: "舟曲县",
            },
            {
              id: 3281,
              pid: 3276,
              name: "迭部县",
            },
            {
              id: 3282,
              pid: 3276,
              name: "玛曲县",
            },
            {
              id: 3283,
              pid: 3276,
              name: "碌曲县",
            },
            {
              id: 3284,
              pid: 3276,
              name: "夏河县",
            },
          ],
        },
      ],
    },
    {
      id: 3285,
      pid: 1,
      name: "青海省",
      children: [
        {
          id: 3286,
          pid: 3285,
          name: "西宁市",
          children: [
            {
              id: 3288,
              pid: 3286,
              name: "城东区",
            },
            {
              id: 3289,
              pid: 3286,
              name: "城中区",
            },
            {
              id: 3290,
              pid: 3286,
              name: "城西区",
            },
            {
              id: 3291,
              pid: 3286,
              name: "城北区",
            },
            {
              id: 3292,
              pid: 3286,
              name: "大通回族土族自治县",
            },
            {
              id: 3293,
              pid: 3286,
              name: "湟中区",
            },
            {
              id: 3294,
              pid: 3286,
              name: "湟源县",
            },
          ],
        },
        {
          id: 3295,
          pid: 3285,
          name: "海东市",
          children: [
            {
              id: 3296,
              pid: 3295,
              name: "乐都区",
            },
            {
              id: 3297,
              pid: 3295,
              name: "平安区",
            },
            {
              id: 3298,
              pid: 3295,
              name: "民和回族土族自治县",
            },
            {
              id: 3299,
              pid: 3295,
              name: "互助土族自治县",
            },
            {
              id: 3300,
              pid: 3295,
              name: "化隆回族自治县",
            },
            {
              id: 3301,
              pid: 3295,
              name: "循化撒拉族自治县",
            },
          ],
        },
        {
          id: 3302,
          pid: 3285,
          name: "海北藏族自治州",
          children: [
            {
              id: 3303,
              pid: 3302,
              name: "门源回族自治县",
            },
            {
              id: 3304,
              pid: 3302,
              name: "祁连县",
            },
            {
              id: 3305,
              pid: 3302,
              name: "海晏县",
            },
            {
              id: 3306,
              pid: 3302,
              name: "刚察县",
            },
          ],
        },
        {
          id: 3307,
          pid: 3285,
          name: "黄南藏族自治州",
          children: [
            {
              id: 3308,
              pid: 3307,
              name: "同仁市",
            },
            {
              id: 3309,
              pid: 3307,
              name: "尖扎县",
            },
            {
              id: 3310,
              pid: 3307,
              name: "泽库县",
            },
            {
              id: 3311,
              pid: 3307,
              name: "河南蒙古族自治县",
            },
          ],
        },
        {
          id: 3312,
          pid: 3285,
          name: "海南藏族自治州",
          children: [
            {
              id: 3313,
              pid: 3312,
              name: "共和县",
            },
            {
              id: 3314,
              pid: 3312,
              name: "同德县",
            },
            {
              id: 3315,
              pid: 3312,
              name: "贵德县",
            },
            {
              id: 3316,
              pid: 3312,
              name: "兴海县",
            },
            {
              id: 3317,
              pid: 3312,
              name: "贵南县",
            },
          ],
        },
        {
          id: 3318,
          pid: 3285,
          name: "果洛藏族自治州",
          children: [
            {
              id: 3319,
              pid: 3318,
              name: "玛沁县",
            },
            {
              id: 3320,
              pid: 3318,
              name: "班玛县",
            },
            {
              id: 3321,
              pid: 3318,
              name: "甘德县",
            },
            {
              id: 3322,
              pid: 3318,
              name: "达日县",
            },
            {
              id: 3323,
              pid: 3318,
              name: "久治县",
            },
            {
              id: 3324,
              pid: 3318,
              name: "玛多县",
            },
          ],
        },
        {
          id: 3325,
          pid: 3285,
          name: "玉树藏族自治州",
          children: [
            {
              id: 3326,
              pid: 3325,
              name: "玉树市",
            },
            {
              id: 3327,
              pid: 3325,
              name: "杂多县",
            },
            {
              id: 3328,
              pid: 3325,
              name: "称多县",
            },
            {
              id: 3329,
              pid: 3325,
              name: "治多县",
            },
            {
              id: 3330,
              pid: 3325,
              name: "囊谦县",
            },
            {
              id: 3331,
              pid: 3325,
              name: "曲麻莱县",
            },
          ],
        },
        {
          id: 3332,
          pid: 3285,
          name: "海西蒙古族藏族自治州",
          children: [
            {
              id: 3333,
              pid: 3332,
              name: "格尔木市",
            },
            {
              id: 3334,
              pid: 3332,
              name: "德令哈市",
            },
            {
              id: 3335,
              pid: 3332,
              name: "茫崖市",
            },
            {
              id: 3336,
              pid: 3332,
              name: "乌兰县",
            },
            {
              id: 3337,
              pid: 3332,
              name: "都兰县",
            },
            {
              id: 3338,
              pid: 3332,
              name: "天峻县",
            },
            {
              id: 3339,
              pid: 3332,
              name: "海西蒙古族藏族自治州直辖",
            },
          ],
        },
      ],
    },
    {
      id: 3340,
      pid: 1,
      name: "宁夏回族自治区",
      children: [
        {
          id: 3341,
          pid: 3340,
          name: "银川市",
          children: [
            {
              id: 3343,
              pid: 3341,
              name: "兴庆区",
            },
            {
              id: 3344,
              pid: 3341,
              name: "西夏区",
            },
            {
              id: 3345,
              pid: 3341,
              name: "金凤区",
            },
            {
              id: 3346,
              pid: 3341,
              name: "永宁县",
            },
            {
              id: 3347,
              pid: 3341,
              name: "贺兰县",
            },
            {
              id: 3348,
              pid: 3341,
              name: "灵武市",
            },
          ],
        },
        {
          id: 3349,
          pid: 3340,
          name: "石嘴山市",
          children: [
            {
              id: 3351,
              pid: 3349,
              name: "大武口区",
            },
            {
              id: 3352,
              pid: 3349,
              name: "惠农区",
            },
            {
              id: 3353,
              pid: 3349,
              name: "平罗县",
            },
          ],
        },
        {
          id: 3354,
          pid: 3340,
          name: "吴忠市",
          children: [
            {
              id: 3356,
              pid: 3354,
              name: "利通区",
            },
            {
              id: 3357,
              pid: 3354,
              name: "红寺堡区",
            },
            {
              id: 3358,
              pid: 3354,
              name: "盐池县",
            },
            {
              id: 3359,
              pid: 3354,
              name: "同心县",
            },
            {
              id: 3360,
              pid: 3354,
              name: "青铜峡市",
            },
          ],
        },
        {
          id: 3361,
          pid: 3340,
          name: "固原市",
          children: [
            {
              id: 3363,
              pid: 3361,
              name: "原州区",
            },
            {
              id: 3364,
              pid: 3361,
              name: "西吉县",
            },
            {
              id: 3365,
              pid: 3361,
              name: "隆德县",
            },
            {
              id: 3366,
              pid: 3361,
              name: "泾源县",
            },
            {
              id: 3367,
              pid: 3361,
              name: "彭阳县",
            },
          ],
        },
        {
          id: 3368,
          pid: 3340,
          name: "中卫市",
          children: [
            {
              id: 3370,
              pid: 3368,
              name: "沙坡头区",
            },
            {
              id: 3371,
              pid: 3368,
              name: "中宁县",
            },
            {
              id: 3372,
              pid: 3368,
              name: "海原县",
            },
          ],
        },
      ],
    },
    {
      id: 3373,
      pid: 1,
      name: "新疆维吾尔自治区",
      children: [
        {
          id: 3374,
          pid: 3373,
          name: "乌鲁木齐市",
          children: [
            {
              id: 3376,
              pid: 3374,
              name: "天山区",
            },
            {
              id: 3377,
              pid: 3374,
              name: "沙依巴克区",
            },
            {
              id: 3378,
              pid: 3374,
              name: "新市区",
            },
            {
              id: 3379,
              pid: 3374,
              name: "水磨沟区",
            },
            {
              id: 3380,
              pid: 3374,
              name: "头屯河区",
            },
            {
              id: 3381,
              pid: 3374,
              name: "达坂城区",
            },
            {
              id: 3382,
              pid: 3374,
              name: "米东区",
            },
            {
              id: 3383,
              pid: 3374,
              name: "乌鲁木齐县",
            },
          ],
        },
        {
          id: 3384,
          pid: 3373,
          name: "克拉玛依市",
          children: [
            {
              id: 3386,
              pid: 3384,
              name: "独山子区",
            },
            {
              id: 3387,
              pid: 3384,
              name: "克拉玛依区",
            },
            {
              id: 3388,
              pid: 3384,
              name: "白碱滩区",
            },
            {
              id: 3389,
              pid: 3384,
              name: "乌尔禾区",
            },
          ],
        },
        {
          id: 3390,
          pid: 3373,
          name: "吐鲁番市",
          children: [
            {
              id: 3391,
              pid: 3390,
              name: "高昌区",
            },
            {
              id: 3392,
              pid: 3390,
              name: "鄯善县",
            },
            {
              id: 3393,
              pid: 3390,
              name: "托克逊县",
            },
          ],
        },
        {
          id: 3934,
          pid: 3373,
          name: "石河子市",
          children: [
            {
              id: 3935,
              pid: 3934,
              name: "石河子市",
            },
            {
              id: 3936,
              pid: 3934,
              name: "莫索湾",
            },
            {
              id: 3397,
              pid: 3934,
              name: "下野地",
            },
          ],
        },
        {
          id: 3395,
          pid: 3373,
          name: "哈密市",
          children: [
            {
              id: 3396,
              pid: 3395,
              name: "伊州区",
            },
            {
              id: 3397,
              pid: 3395,
              name: "巴里坤哈萨克自治县",
            },
            {
              id: 3398,
              pid: 3395,
              name: "伊吾县",
            },
          ],
        },
        {
          id: 3399,
          pid: 3373,
          name: "昌吉回族自治州",
          children: [
            {
              id: 3400,
              pid: 3399,
              name: "昌吉市",
            },
            {
              id: 3401,
              pid: 3399,
              name: "阜康市",
            },
            {
              id: 3402,
              pid: 3399,
              name: "呼图壁县",
            },
            {
              id: 3403,
              pid: 3399,
              name: "玛纳斯县",
            },
            {
              id: 3404,
              pid: 3399,
              name: "奇台县",
            },
            {
              id: 3405,
              pid: 3399,
              name: "吉木萨尔县",
            },
            {
              id: 3406,
              pid: 3399,
              name: "木垒哈萨克自治县",
            },
          ],
        },
        {
          id: 3407,
          pid: 3373,
          name: "博尔塔拉蒙古自治州",
          children: [
            {
              id: 3408,
              pid: 3407,
              name: "博乐市",
            },
            {
              id: 3409,
              pid: 3407,
              name: "阿拉山口市",
            },
            {
              id: 3410,
              pid: 3407,
              name: "精河县",
            },
            {
              id: 3411,
              pid: 3407,
              name: "温泉县",
            },
          ],
        },
        {
          id: 3412,
          pid: 3373,
          name: "巴音郭楞蒙古自治州",
          children: [
            {
              id: 3413,
              pid: 3412,
              name: "库尔勒市",
            },
            {
              id: 3414,
              pid: 3412,
              name: "轮台县",
            },
            {
              id: 3415,
              pid: 3412,
              name: "尉犁县",
            },
            {
              id: 3416,
              pid: 3412,
              name: "若羌县",
            },
            {
              id: 3417,
              pid: 3412,
              name: "且末县",
            },
            {
              id: 3418,
              pid: 3412,
              name: "焉耆回族自治县",
            },
            {
              id: 3419,
              pid: 3412,
              name: "和静县",
            },
            {
              id: 3420,
              pid: 3412,
              name: "和硕县",
            },
            {
              id: 3421,
              pid: 3412,
              name: "博湖县",
            },
          ],
        },
        {
          id: 3422,
          pid: 3373,
          name: "阿克苏地区",
          children: [
            {
              id: 3423,
              pid: 3422,
              name: "阿克苏市",
            },
            {
              id: 3424,
              pid: 3422,
              name: "温宿县",
            },
            {
              id: 3425,
              pid: 3422,
              name: "库车市",
            },
            {
              id: 3426,
              pid: 3422,
              name: "沙雅县",
            },
            {
              id: 3427,
              pid: 3422,
              name: "新和县",
            },
            {
              id: 3428,
              pid: 3422,
              name: "拜城县",
            },
            {
              id: 3429,
              pid: 3422,
              name: "乌什县",
            },
            {
              id: 3430,
              pid: 3422,
              name: "阿瓦提县",
            },
            {
              id: 3431,
              pid: 3422,
              name: "柯坪县",
            },
          ],
        },
        {
          id: 3432,
          pid: 3373,
          name: "克孜勒苏柯尔克孜自治州",
          children: [
            {
              id: 3433,
              pid: 3432,
              name: "阿图什市",
            },
            {
              id: 3434,
              pid: 3432,
              name: "阿克陶县",
            },
            {
              id: 3435,
              pid: 3432,
              name: "阿合奇县",
            },
            {
              id: 3436,
              pid: 3432,
              name: "乌恰县",
            },
          ],
        },
        {
          id: 3437,
          pid: 3373,
          name: "喀什地区",
          children: [
            {
              id: 3438,
              pid: 3437,
              name: "喀什市",
            },
            {
              id: 3439,
              pid: 3437,
              name: "疏附县",
            },
            {
              id: 3440,
              pid: 3437,
              name: "疏勒县",
            },
            {
              id: 3441,
              pid: 3437,
              name: "英吉沙县",
            },
            {
              id: 3442,
              pid: 3437,
              name: "泽普县",
            },
            {
              id: 3443,
              pid: 3437,
              name: "莎车县",
            },
            {
              id: 3444,
              pid: 3437,
              name: "叶城县",
            },
            {
              id: 3445,
              pid: 3437,
              name: "麦盖提县",
            },
            {
              id: 3446,
              pid: 3437,
              name: "岳普湖县",
            },
            {
              id: 3447,
              pid: 3437,
              name: "伽师县",
            },
            {
              id: 3448,
              pid: 3437,
              name: "巴楚县",
            },
            {
              id: 3449,
              pid: 3437,
              name: "塔什库尔干塔吉克自治县",
            },
          ],
        },
        {
          id: 3450,
          pid: 3373,
          name: "和田地区",
          children: [
            {
              id: 3451,
              pid: 3450,
              name: "和田市",
            },
            {
              id: 3452,
              pid: 3450,
              name: "和田县",
            },
            {
              id: 3453,
              pid: 3450,
              name: "墨玉县",
            },
            {
              id: 3454,
              pid: 3450,
              name: "皮山县",
            },
            {
              id: 3455,
              pid: 3450,
              name: "洛浦县",
            },
            {
              id: 3456,
              pid: 3450,
              name: "策勒县",
            },
            {
              id: 3457,
              pid: 3450,
              name: "于田县",
            },
            {
              id: 3458,
              pid: 3450,
              name: "民丰县",
            },
          ],
        },
        {
          id: 3459,
          pid: 3373,
          name: "伊犁哈萨克自治州",
          children: [
            {
              id: 3460,
              pid: 3459,
              name: "伊宁市",
            },
            {
              id: 3461,
              pid: 3459,
              name: "奎屯市",
            },
            {
              id: 3462,
              pid: 3459,
              name: "霍尔果斯市",
            },
            {
              id: 3463,
              pid: 3459,
              name: "伊宁县",
            },
            {
              id: 3464,
              pid: 3459,
              name: "察布查尔锡伯自治县",
            },
            {
              id: 3465,
              pid: 3459,
              name: "霍城县",
            },
            {
              id: 3466,
              pid: 3459,
              name: "巩留县",
            },
            {
              id: 3467,
              pid: 3459,
              name: "新源县",
            },
            {
              id: 3468,
              pid: 3459,
              name: "昭苏县",
            },
            {
              id: 3469,
              pid: 3459,
              name: "特克斯县",
            },
            {
              id: 3470,
              pid: 3459,
              name: "尼勒克县",
            },
          ],
        },
        {
          id: 3471,
          pid: 3373,
          name: "塔城地区",
          children: [
            {
              id: 3472,
              pid: 3471,
              name: "塔城市",
            },
            {
              id: 3473,
              pid: 3471,
              name: "乌苏市",
            },
            {
              id: 3474,
              pid: 3471,
              name: "额敏县",
            },
            {
              id: 3475,
              pid: 3471,
              name: "沙湾县",
            },
            {
              id: 3476,
              pid: 3471,
              name: "托里县",
            },
            {
              id: 3477,
              pid: 3471,
              name: "裕民县",
            },
            {
              id: 3478,
              pid: 3471,
              name: "和布克赛尔蒙古自治县",
            },
          ],
        },
        {
          id: 3479,
          pid: 3373,
          name: "阿勒泰地区",
          children: [
            {
              id: 3480,
              pid: 3479,
              name: "阿勒泰市",
            },
            {
              id: 3481,
              pid: 3479,
              name: "布尔津县",
            },
            {
              id: 3482,
              pid: 3479,
              name: "富蕴县",
            },
            {
              id: 3483,
              pid: 3479,
              name: "福海县",
            },
            {
              id: 3484,
              pid: 3479,
              name: "哈巴河县",
            },
            {
              id: 3485,
              pid: 3479,
              name: "青河县",
            },
            {
              id: 3486,
              pid: 3479,
              name: "吉木乃县",
            },
          ],
        },
      ],
    },
  ];
export default address